import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import MultipleFileUpload from "../Components/MultipleFileUpload";
import { Accordion, AccordionContext, Card, useAccordionButton } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-dropdown-select";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import * as qs from "qs";
import PopoverStickOnHover from "../Components/PopoverStickOnHover";
import CustomControl from "../Components/CustomControl";
import CustomControlMulti from "../Components/CustomControlMulti";
import CustomDropdown from "../Components/CustomDropdown";
import CustomDropdownMulti from "../Components/CustomDropdownMulti";
import CustomDropdownWithSearch from "../Components/CustomDropdownWithSearch";
import NumberToPersianWord from "number_to_persian_word";
import UserProjects from "../Static Files/UserProjects.json";
import GetPrice from "../Functions/GetPrice";
import { useDispatch, useSelector } from "react-redux";
import UploadedFilesList from "../Components/UploadedFilesList";
import { CartUpdatedTrue, ShowLogin2Modal } from "../Actions/types";
import authHeader from "../Services/auth-header";
import SaveUserProject from "../Functions/SaveUserProject";
import { refreshToken } from "../Services/auth.service";
import GetUserProjectData from "../Functions/GetUserProjectData";
import setGetDeps from "../Functions/setGetDeps";
import ModalLogin from "../Components/ModalLogin";
import AddProjectToCart from "../Functions/AddProjectToCart";
import GetMeasurementArray from "../Functions/GetMeasurementArray";
import GetSewingFilters from "../Functions/GetSewingFilters";
import ChainLengthSelector, { getChainLengthOption } from "../Components/ChainLengthSelector";
import {
  Capitalize,
  CapitalizeAllWords,
  NumToFa,
  convertToPersian,
  RangeToFa,
  capitalizeWordsText,
} from "../Functions/TextTransform";
import { DebounceInput } from "react-debounce-input";
import {
  createGetCart,
  createGetHasZipcode,
} from "../Functions/FunctionsGrommet/cartAndZipcode";
import { rooms, motorChannels } from "../Static Files/Static_Labels";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import {
  formatCombinedOutsideMountLabel,
  normalizeOutsideMountSubType,
} from "../Components/draperyUi";
import RenderSideCart from "../Components/RenderSideCart";
import { useMediaQuery } from "react-responsive";
import AddSwatch from "../Functions/AddSwatch";
import { generateFabricItemId } from "../Functions/GenerateFabricItemId";
import {
  imgUrl,
  baseURLModel,
  baseURLFabrics,
  baseURLPrice,
  baseURLZipCode,
  baseURLFreeShipping,
  baseURGetProject,
  baseURLGetCart,
  baseURLGetRemoteNames,
  baseURLUploadImg,
  baseURLUploadPdf,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
} from "../config/api";
const persianTimeout = 300;

function Roller({
  CatID,
  ModelID,
  PageType,
  ProjectId,
  EditIndex,
  PageItem,
  QueryString,
  Parameters,
  PageId,
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const firstRender = useRef(true);
  const modalTopRef = useRef(null);
  const [catID, setCatID] = useState(CatID);
  const [modelID, setModelID] = useState(ModelID);
  const [pageType, setPageType] = useState(PageType);
  const [projectId, setProjectId] = useState(ProjectId);
  const [editIndex, setEditIndex] = useState(EditIndex);
  const [pageItem, setPageItem] = useState(PageItem);
  const [queryString, setQueryString] = useState(QueryString);
  const [parameters, setParameters] = useState(Parameters);
  const [pageId, setPageId] = useState(PageId);
  const { isLoggedIn, SideDiscountedPrice, cartUpdated, mainCart, sideCartPrice } = useSelector(
    (state) => state.auth
  );
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLoad, setPageLoad] = useState(undefined);
  const [motorLoad, setMotorLoad] = useState(false);
  const [motorLoad2, setMotorLoad2] = useState(false);
  const [mesLoad, setMesLoad] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [model, setModel] = useState({});
  const multipleFileUploadRef = useRef();
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedPDFs, setUploadedPDFs] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [modelAccessories, setModelAccessories] = useState({});
  const [fabrics, setFabrics] = useState({});
  const [fabricsList, setFabricsList] = useState([]);
  const [defaultFabricPhoto, setDefaultFabricPhoto] = useState(null);
  const [defaultModelName, setDefaultModelName] = useState("");
  const [defaultModelNameFa, setDefaultModelNameFa] = useState("");
  const [defaultModelDesc, setDefaultModelDesc] = useState("");
  const [defaultModelDescFa, setDefaultModelDescFa] = useState("");
  const [price, setPrice] = useState(0);
  const [fabricQty, setFabricQty] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [measurementsNextStep, setMeasurementsNextStep] = useState("4");
  const [controlTypeNextStep, setControlTypeNextStep] = useState("5");
  const [headrailsNextStep, setHeadrailsNextStep] = useState("6");
  const [hemStyleNextStep, setHemStyleNextStep] = useState("7");
  const [projectModalState, setProjectModalState] = useState(0);
  const [zoomModalHeader, setZoomModalHeader] = useState([]);
  const [zoomModalBody, setZoomModalBody] = useState([]);
  const [swatchId, setSwatchId] = useState(0);
  const [swatchDetailId, setSwatchDetailId] = useState(0);
  const [swatchPhotoPath, setSwatchPhotoPath] = useState("");
  const [hasSwatchId, setHasSwatchId] = useState(false);
  const [addCartErr, setAddCartErr] = useState([]);
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartAgree, setCartAgree] = useState([]);
  const [cartChanged, setCartChanged] = useState(0);
  const [bagUpdate, setBagUpdate] = useState(false);
  const [bag, setBag] = useState({});
  const [remoteNames, setRemoteNames] = useState([]);
  const [showRemoteName, setShowRemoteName] = useState(false);
  const [accordionActiveKey, setAccordionActiveKey] = useState("");
  const [selectedMountOutsideType, setSelectedMountOutsideType] = useState([]);
  const [step21Err2, setStep21Err2] = useState(false);
  const [helpMeasureLengthType, setHelpMeasureLengthType] = useState("wall");
  const [roomLabelText, setRoomLabelText] = useState("");
  const [fabricSelected, setFabricSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [roomLabelSelect, setRoomLabelSelect] = useState({
    label: "",
    value: "",
  });
  const [mountTypeTemp, setMountTypeTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(2)} MB`;
    return `${(bytes / 1024).toFixed(2)} KB`;
  };
  const [chainLengthId, setChainLengthId] = useState(null);
  const [hemStyleId, setHemStyleId] = useState(null);
  const [cordSideId, setCordSideId] = useState(null);
  const [stepBackCordSideId, setStepBackCordSideId] = useState(null);
  const [MetalValanceColorId, setMetalValanceColorId] = useState(null);
  const [headRailId, setHeadRailId] = useState(null);
  const [bottomBarStyleId, setBottomBarStyleId] = useState(null);
  const [rollTypeId, setRollTypeId] = useState(null);
  const [bracketTypeId, setBracketTypeId] = useState(null);
  const [bracketColorId, setBracketColorId] = useState(null);
  const [stepSelectedValue, setStepSelectedValue] = useState({});
  const [headerTruncated, setHeaderTruncated] = useState([]);
  const [detailsShow, setDetailsShow] = useState(false);
  const [filtersShow, setFiltersShow] = useState(false);
  const [windowSize, setWindowSize] = useState("");
  const [windowSizeBool, setWindowSizeBool] = useState(false);
  const [stepSelectedLabel, setStepSelectedLabel] = useState({});
  const [modals, setModals] = useState({});
  const [popoverImages, setPopoverImages] = useState([]);
  const [inputDifRef, setInputDifRef] = useState(undefined);
  const [inputDifdep, setInputDifdep] = useState(undefined);
  const [leftRight, setLeftRight] = useState({
    left: "",
    right: "",
  });
  const [stepSelectedOptions, setStepSelectedOptions] = useState({
    values: {},
    labels: {},
  });
  const [selectCustomValues, setSelectCustomValues] = useState({
    width1: [],
    width2: [],
    width3: [],
    height1: [],
    height2: [],
    left: [],
    right: [],
    width: [],
    length: [],
    width3A: [],
    height3C: [],
    shadeMount: [],
  });
  const [width, setWidth] = useState(undefined);
  const [height, setHeight] = useState(undefined);
  const [width1, setWidth1] = useState(undefined);
  const [width2, setWidth2] = useState(undefined);
  const [width3, setWidth3] = useState(undefined);
  const [height1, setHeight1] = useState(undefined);
  const [height2, setHeight2] = useState(undefined);
  const [height3, setHeight3] = useState(undefined);
  const [ceilingToWindow1, setCeilingToWindow1] = useState(undefined);
  const [ceilingToWindow2, setCeilingToWindow2] = useState(undefined);
  const [ceilingToWindow3, setCeilingToWindow3] = useState(undefined);
  const [width3A, setWidth3A] = useState(undefined);
  const [left, setLeft] = useState(undefined);
  const [right, setRight] = useState(undefined);
  const [height3C, setHeight3C] = useState(undefined);
  const [mount, setMount] = useState(undefined);
  const [widthCart, setWidthCart] = useState(undefined);
  const [heightCart, setHeightCart] = useState(undefined);

  const [requiredStep, setRequiredStep] = useState({});
  const [cartValues, setCartValues] = useState({});
  const [cartStateAgree, setCartStateAgree] = useState(false);
  const [cartAgreeDescription, setCartAgreeDescription] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartProjectIndex, setCartProjectIndex] = useState(-1);
  const [saveProjectCount, setSaveProjectCount] = useState(0);
  const [depSet, setDepSet] = useState(new Set(["1", "2", "3", "4", "5", "6", "71", "72"]));
  const inputs = useRef({});
  const selectedTitle = useRef({});
  const search_input = useRef(null);
  const accordion = useRef(null);
  const isClearingLeftRight = useRef(false);
  const shouldKeep3BOutCleared = useRef(false);
  const [showMoreFilterTrigger, setShowMoreFilterTrigger] = useState(undefined);
  const filterCheckboxes = useRef({
    colors: [],
    patterns: [],
    types: [],
    prices: [],
    colors2: [],
    patterns2: [],
    types2: [],
    prices2: [],
  });
  const steps = useRef({});
  const stepHeaders = useRef({});
  const depDetails = useRef({
    1: {},
    2: {},
    3: {},
    4: {},
    5: {},
    6: {},
    7: {},
  });
  const [filterChanged, setFilterChanged] = useState({
    filter: 0,
    filter_id: undefined,
    isDelete: false,
  });
  const [filterColors, setFilterColors] = useState([...queryString["colors"]]);
  const [filterPatterns, setFilterPatterns] = useState([...queryString["patterns"]]);
  const [filterTypes, setFilterTypes] = useState([...queryString["types"]]);
  const [filterPrices, setFilterPrices] = useState([...queryString["prices"]]);
  const [filterDesigns, setFilterDesigns] = useState([...queryString["designs"]]);
  const [isClearAll, setIsClearAll] = useState(false);
  const [step1, setStep1] = useState("");
  const [step2, setStep2] = useState("");
  const [step21, setStep21] = useState("");
  const [step3, setStep3] = useState("");
  const [step4, setStep4] = useState("");
  const [step41, setStep41] = useState("");
  const [step4A, setStep4A] = useState("");
  const [step4B, setStep4B] = useState("");
  const [step5, setStep5] = useState("");
  const [step5A, setStep5A] = useState("");
  const [step5B, setStep5B] = useState("");
  const [step5C, setStep5C] = useState("");
  const [step5Arc, setStep5Arc] = useState("");
  const [step5AArc, setStep5AArc] = useState("");
  const [step5BArc, setStep5BArc] = useState("");
  const [step6, setStep6] = useState("");
  const [step6A, setStep6A] = useState("");
  const [zipcodeChecked, setZipcodeChecked] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [zipcodeButton, setZipcodeButton] = useState(false);
  const [hasZipcode, setHasZipcode] = useState("");
  const [hasInstall, setHasInstall] = useState(null);
  const [installPrice, setInstallPrice] = useState(-1);
  const [transportPrice, setTransportPrice] = useState(-1);
  const [remoteName, setRemoteName] = useState("");
  const [moreInfoInput, setMoreInfoInput] = useState("");
  const [selectedValanceColor1, setSelectedValanceColor1] = useState([]);
  const [selectedValanceColor2, setSelectedValanceColor2] = useState([]);
  const [selectedRoomLabel, setSelectedRoomLabel] = useState([]);
  const [step21Err1, setStep21Err1] = useState(false);
  const [step21Err3, setStep21Err3] = useState(false);
  const [motorErr1, setMotorErr1] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState("");
  const [editedFileName, setEditedFileName] = useState("");
  const [uploadedImagesList, setUploadedImagesList] = useState([]);
  const [uploadedImagesNamesList, setUploadedImagesNamesList] = useState([]);
  const [uploadedPDFNameList, setUploadedPDFNameList] = useState([]);
  const [uploadedImagesFile, setUploadedImagesFile] = useState([]);
  const [uploadedPDFFile, setUploadedPDFFile] = useState([]);
  const [uploadedImagesURL, setUploadedImagesURL] = useState([]);
  const [uploadedPDFURL, setUploadedPDFURL] = useState([]);
  const [initFilterColors, setInitFilterColors] = useState({});
  const [initFilterPatterns, setInitFilterPatterns] = useState({});
  const [initFilterTypes, setInitFilterTypes] = useState({});
  const [initFilterPrices, setInitFilterPrices] = useState({});
  const [sewingColors, setSewingColors] = useState([]);
  const [sewingPatterns, setSewingPatterns] = useState([]);
  const [sewingTypes, setSewingTypes] = useState([]);
  const [sewingPrices, setSewingPrices] = useState([]);
  const [sewingColors2, setSewingColors2] = useState([]);
  const [sewingPatterns2, setSewingPatterns2] = useState([]);
  const [sewingTypes2, setSewingTypes2] = useState([]);
  const [sewingPrices2, setSewingPrices2] = useState([]);
  const [showMoreFilter, setShowMoreFilter] = useState({
    colors: false,
    patterns: false,
    types: false,
    prices: false,
  });
  const [deleteUploadImageUrl, setDeleteUploadImageUrl] = useState("");
  const [deleteUploadPdfUrl, setDeleteUploadPdfUrl] = useState("");
  const [deleteUploadImageIndex, setDeleteUploadImageIndex] = useState(-1);
  const [deleteUploadPdfIndex, setDeleteUploadPdfIndex] = useState(-1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [swatchLogin, setSwatchLogin] = useState(false);
  const [swatchLoginSwatchId, setSwatchLoginSwatchId] = useState(null);
  const [swatchLoginSwatchDetailId, setSwatchLoginSwatchDetailId] = useState(null);
  const [helpMeasure, setHelpMeasure] = useState("Inside");
  const [customMotorAcc, setCustomMotorAcc] = useState({});
  const [selectedMotorChannels, setSelectedMotorChannels] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorPosition, setSelectedMotorPosition] = useState([]);
  const [selectedRemoteName, setSelectedRemoteName] = useState([]);
  const [selectedMotorType, setSelectedMotorType] = useState([]);
  const [selectedMotorMinPrice, setSelectedMotorMinPrice] = useState(0);
  const getFabrics = () => {
    let paramObj = {
      modelId: modelID,
    };
    let promise5 = new Promise((resolve, reject) => {
      if (filterDesigns.length > 0) {
        paramObj["designs"] = [];
        filterDesigns.forEach((filter_id, index) => {
          paramObj["designs"] = [...paramObj["designs"], filter_id];
          if (index === filterDesigns.length - 1) {
            resolve();
          }
        });
      } else {
        resolve();
      }
    });

    Promise.all([promise5]).then(() => {
      axios
        .get(baseURLFabrics, {
          params: paramObj,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((response) => {
          let tempFabrics = [];
          response.data.forEach((obj) => {
            if (
              tempFabrics[obj["DesignEnName"]] === "" ||
              tempFabrics[obj["DesignEnName"]] === undefined ||
              tempFabrics[obj["DesignEnName"]] === null ||
              tempFabrics[obj["DesignEnName"]] === []
            )
              tempFabrics[obj["DesignEnName"]] = [];
            tempFabrics[obj["DesignEnName"]].push(obj);
          });

          if (Object.keys(tempFabrics).length) {
            setFabrics(tempFabrics);
          } else {
            let pageLanguage1 = pageLanguage;
            setFabricsList([
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + "empty"}
              >
                <div
                  className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <h5 className="empty_fabrics">
                    {pageLanguage1 === "en"
                      ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                      : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                  </h5>
                  <button
                    className="empty_fabrics_btn white_btn btn"
                    onClick={() => {
                      setFabricsList([
                        <div
                          className={`material_detail ${
                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric" + "empty"}
                        >
                          <div
                            className={`material_traits ${
                              pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage1 === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button className="empty_fabrics_btn white_btn btn">
                              {pageLanguage1 === "fa" ? "در حال پاک کردن" : "CLEARING"}
                            </button>
                          </div>
                        </div>,
                      ]);
                      setTimeout(() => {
                        setIsClearAll(true);
                      }, persianTimeout);
                    }}
                  >
                    {pageLanguage1 === "fa" ? "همه فیلترها را پاک کنید" : "CLEAR ALL FILTERS"}
                  </button>
                </div>
              </div>,
            ]);
          }
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        });
    });
  };
  function getFabricsWithFilter(clearAll) {
    if (clearAll) {
      getFabrics();
    } else {
      let paramObj = { modelId: modelID, searchString: searchText };

      let promise1 = new Promise((resolve, reject) => {
        if (filterColors.length > 0) {
          paramObj["colorIds"] = [];
          filterColors.forEach((filter_id, index) => {
            paramObj["colorIds"] = [...paramObj["colorIds"], filter_id];
            if (index === filterColors.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise2 = new Promise((resolve, reject) => {
        if (filterPatterns.length > 0) {
          paramObj["patternTypeIds"] = [];
          filterPatterns.forEach((filter_id, index) => {
            paramObj["patternTypeIds"] = [...paramObj["patternTypeIds"], filter_id];
            if (index === filterPatterns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise3 = new Promise((resolve, reject) => {
        if (filterTypes.length > 0) {
          paramObj["opacityIds"] = [];
          filterTypes.forEach((filter_id, index) => {
            paramObj["opacityIds"] = [...paramObj["opacityIds"], filter_id];
            if (index === filterTypes.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise4 = new Promise((resolve, reject) => {
        if (filterPrices.length > 0) {
          paramObj["priceLevelIds"] = [];
          filterPrices.forEach((filter_id, index) => {
            paramObj["priceLevelIds"] = [...paramObj["priceLevelIds"], filter_id];
            if (index === filterPrices.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise5 = new Promise((resolve, reject) => {
        if (filterDesigns.length > 0) {
          paramObj["designs"] = [];
          filterDesigns.forEach((filter_id, index) => {
            paramObj["designs"] = [...paramObj["designs"], filter_id];
            if (index === filterDesigns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });

      Promise.all([promise1, promise2, promise3, promise4, promise5]).then(() => {
        // console.log(filterColors,paramObj);
        axios
          .get(baseURLFabrics, {
            params: paramObj,
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          })
          .then((response) => {
            let tempFabrics = [];
            response.data.forEach((obj) => {
              if (
                tempFabrics[obj["DesignEnName"]] === "" ||
                tempFabrics[obj["DesignEnName"]] === undefined ||
                tempFabrics[obj["DesignEnName"]] === null ||
                tempFabrics[obj["DesignEnName"]] === []
              )
                tempFabrics[obj["DesignEnName"]] = [];
              tempFabrics[obj["DesignEnName"]].push(obj);
            });

            if (Object.keys(tempFabrics).length) {
              setFabrics(tempFabrics);
            } else {
              let pageLanguage1 = pageLanguage;
              // setFabrics(tempFabrics);
              setFabricsList([
                <div
                  className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  key={"fabric" + "empty"}
                >
                  <div
                    className={`material_traits ${
                      pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                    }`}
                  >
                    <h5 className="empty_fabrics">
                      {pageLanguage1 === "en"
                        ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                        : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                    </h5>
                    <button
                      className="empty_fabrics_btn white_btn btn"
                      onClick={() => {
                        setFabricsList([
                          <div
                            className={`material_detail ${
                              pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                            }`}
                            key={"fabric" + "empty"}
                          >
                            <div
                              className={`material_traits ${
                                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                              }`}
                            >
                              <h5 className="empty_fabrics">
                                {pageLanguage1 === "en"
                                  ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                  : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                              </h5>
                              <button className="empty_fabrics_btn white_btn btn">
                                {pageLanguage1 === "fa" ? "در حال پاک کردن" : "CLEARING"}
                              </button>
                            </div>
                          </div>,
                        ]);
                        setTimeout(() => {
                          setIsClearAll(true);
                        }, persianTimeout);
                      }}
                    >
                      {pageLanguage1 === "fa" ? "همه فیلترها را پاک کنید" : "CLEAR ALL FILTERS"}
                    </button>
                  </div>
                </div>,
              ]);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  }
  const getModel = () => {
    axios
      .get(baseURLModel, {
        params: {
          id: modelID,
        },
      })
      .then((response) => {
        setModel(response.data);
        // console.log(response.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function renderFabrics(bag) {
    const fabricList = [];
    let count = 0;
    let cartObj = {};
    let temp = [];

    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let promiseArr = [];
    Object.keys(fabrics).forEach((key, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];

        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve, reject) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;
            // console.log(fabrics,key);
            let PhotoPath =
              fabrics[key][j].FabricPhotos.find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl || "";

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let HasTrim = fabrics[key][j].HasTrim;
            let DesignCode = fabrics[key][j].DesignCode;
            let DesignRaportLength = fabrics[key][j].DesignRaportLength;
            let DesignRaportWidth = fabrics[key][j].DesignRaportWidth;
            let PolyesterPercent = fabrics[key][j].PolyesterPercent;
            let ViscosePercent = fabrics[key][j].ViscosePercent;
            let NylonPercent = fabrics[key][j].NylonPercent;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                // console.log(index);
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }
            // console.log(HasSwatchId);
            // console.log(step1 === `${FabricId}`, step1, `${FabricId}`, FabricId);

            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = JSON.parse(JSON.stringify(fabric[fabricOrderSelected]));
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  {/*<ReactTooltip id={"fabric" + key + j} place="top" type="light" effect="float"/>*/}
                  <input
                    className="radio"
                    type="radio"
                    ref-num="1"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onChange={(e) => {
                      // console.log("hi1");
                      let temp = JSON.parse(JSON.stringify(fabricSelected));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedHasTrim = HasTrim;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      setFabricSelected(temp);
                      // fabricClicked(e, HasTrim);
                      // selectChanged(e);
                      // setCart("FabricId", FabricId);
                      // setDeps("", "1");
                    }}
                    name="fabric"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step1}
                    ref={(ref) => (inputs.current[`1${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid ${`${FabricId}` === step1 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath)}
                      alt=""
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );
            resolve();
          });
        }

        Promise.all(promiseArr2).then(() => {
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = JSON.parse(
              JSON.stringify(fabricList[designOrderSelected])
            );
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <div
              className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              key={"fabric" + key}
            >
              <div
                className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <hr />
                <span>
                  <p>
                    {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                    {pageLanguage1 === "en" ? DesignEnName : DesignName}
                  </p>
                  <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                  <p>
                    {pageLanguage1 === "en" ? "FROM" : "شروع از"}:{" "}
                    {GetPrice(
                      SamplePrice,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )}
                  </p>
                </span>
              </div>
              {fabric}
            </div>
          );

          resolve();
        });
      });
    });
    Promise.all(promiseArr).then(() => {
      setFabricsList(fabricList);
    });
    // console.log(fabricList)
  }

  function handleClose() {
    setShow(false);
  }

  function handleShow(fabricObj, SwatchDetailId) {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let DesignName = convertToPersian(fabricObj["DesignName"]);
    let DesignEnName = fabricObj["DesignEnName"];
    let FabricId = fabricObj["FabricId"];
    let PhotoPath = "";
    fabricObj["FabricPhotos"].forEach((obj) => {
      if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
    });
    console.log(fabricObj);
    let PriceLevelEnTitle = fabricObj["PriceLevelEnTitle"];
    let PriceLevelTitle = fabricObj["PriceLevelTitle"];
    let PolyesterPercent = fabricObj["PolyesterPercent"] || 0;
    let ViscosePercent = fabricObj["ViscosePercent"] || 0;
    let NylonPercent = fabricObj["NylonPercent"] || 0;
    let ConttonPercent = fabricObj["ConttonPercent"] || 0;
    let LinenPercent = fabricObj["LinenPercent"] || 0;
    let FabricWidth = fabricObj["FabricWidth"] || 0;
    let ColorName = convertToPersian(fabricObj["ColorName"]);
    let ColorEnName = fabricObj["ColorEnName"];
    let SwatchId = fabricObj["SwatchId"] ? fabricObj["SwatchId"] : -1;

    const tempDiv = [];
    const tempDiv1 = [];
    tempDiv.push(
      <div key={PhotoPath} className="zoomImg">
        <div className="imageContainer">
          <ReactImageMagnify
            imageProps={{
              alt: "",
              // isFluidWidth: true,
              src: imgUrl(PhotoPath),
            }}
            magnifiedImageProps={{
              src: imgUrl(PhotoPath),
              width: 800,
              height: 800,
            }}
            portalProps={{ placement: "over" }}
          />
          
        </div>
      </div>
    );
    tempDiv1.push(
      <div key={1} className="zoom_modal_header_container">
        <h1 className="zoom_modal_header_design">
          {pageLanguage === "en" ? DesignEnName : DesignName} /{" "}
          {pageLanguage === "en" ? ColorEnName : ColorName}
        </h1>
        <h1 className="zoom_modal_header_Price">
          {t("PRICE GROUP: ")}
          {pageLanguage === "en" ? capitalizeWordsText(PriceLevelEnTitle) : PriceLevelTitle}
        </h1>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Contents")}</h1>
          {PolyesterPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? PolyesterPercent + "%" : NumToFa(PolyesterPercent) + "%"}{" "}
              {t("Polyester")}
            </p>
          )}
          {ViscosePercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ViscosePercent + "%" : NumToFa(ViscosePercent) + "%"}{" "}
              {t("Viscose")}
            </p>
          )}
          {NylonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? NylonPercent + "%" : NumToFa(NylonPercent) + "%"}{" "}
              {t("Nylon")}
            </p>
          )}
          {ConttonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ConttonPercent + "%" : NumToFa(ConttonPercent) + "%"}{" "}
              {t("Contton")}
            </p>
          )}
          {LinenPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? LinenPercent + "%" : NumToFa(LinenPercent) + "%"}{" "}
              {t("Linen")}
            </p>
          )}
        </div>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Fabric Width")}</h1>
          {FabricWidth > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? FabricWidth + "cm" : NumToFa(FabricWidth) + "cm"}
            </p>
          )}
        </div>
      </div>
    );

    setZoomModalBody(tempDiv);
    setZoomModalHeader(tempDiv1);
    setSwatchId(SwatchId);
    setSwatchDetailId(SwatchDetailId);
    setSwatchPhotoPath(PhotoPath);
    setShow(true);
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function ContextAwareToggle({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey("") : setAccordionActiveKey(eventKey);

      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef] = ref)}
      >
        <div className="steps_header_num_container">
          <div className="steps_header_num">{stepNum}</div>
        </div>
        <div className="steps_header_title_container">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>
        {/*<div className="steps_header_selected_container">*/}
        {/*    <PopoverStickOnHover classNames="step_label_popover"*/}
        {/*                         placement="bottom"*/}
        {/*                         children={<div className={"steps_header_selected"+ (stepSelected===t("Invalid Measurements")?" steps_header_selected_red":"")}*/}
        {/*                                        ref={ref => (selectedTitle.current[stepNum] = ref)}>{stepSelected}</div>}*/}
        {/*                         component={*/}
        {/*                             <div className="step_label_popover_container">*/}
        {/*                                 <div className={"steps_header_selected"+ (stepSelected===t("Invalid Measurements")?" steps_header_selected_red":"")} ref={ref => (selectedTitle.current[stepNum] = ref)}>{stepSelected}</div>*/}
        {/*                             </div>*/}
        {/*                         }/>*/}
        {/*</div>*/}
        <div className="steps_header_selected_container">
          <div className="steps_header_selected_title_container">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (
                  selectedTitle.current[stepNum].clientWidth <
                  selectedTitle.current[stepNum].scrollWidth
                ) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {stepSelected}
            </div>
            {headerTruncated[stepNum] && <div className="header_tooltip">{stepSelected}</div>}
          </div>
          {required && <div className="stepRequired" />}
        </div>
      </div>
    );
  }

  const topScroll = () => {
    setTimeout(() => {
      if (modalTopRef.current) {
        modalTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_filter_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_filter_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_filter_accordion_btn_img_minus img-fluid"
                : "product_filter_accordion_btn_img_plus img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  function NextStep({ children, eventKey, callback, onClick, currentStep }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      setAccordionActiveKey(eventKey);
      setTimeout(() => {
        if (
          currentStep &&
          stepHeaders.current[currentStep] !== undefined &&
          stepHeaders.current[currentStep] !== null
        )
          stepHeaders.current[currentStep].scrollIntoView();
      }, 800);
    });
    return (
      <div className="nextStep_area" onClick={onClick}>
        <div className="nextStep" onClick={decoratedOnClick}>
          {children}
        </div>
      </div>
    );
  }

  function clearAllFilters() {
    filterCheckboxes.current["colors"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patterns"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["types"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["prices"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    search_input.current.value = "";
    setSearchText("");
    setSearchShow(false);

    setFilterColors([]);
    setFilterPatterns([]);
    setFilterTypes([]);
    setFilterPrices([]);
  }

  useEffect(() => {
    if (isClearAll) {
      clearAllFilters();
      getFabricsWithFilter(true);
    }
  }, [isClearAll]);

  function clearFilters(e) {
    let refIndex = e.target.getAttribute("text");
    filterCheckboxes.current[refIndex].forEach((obj) => {
      if (obj) {
        obj.checked = false;
      }
    });

    if (e.target.getAttribute("text") === "colors") {
      setFilterColors([]);
    } else if (e.target.getAttribute("text") === "patterns") {
      setFilterPatterns([]);
    } else if (e.target.getAttribute("text") === "types") {
      setFilterTypes([]);
    } else {
      setFilterPrices([]);
    }
  }

  function popoverThumbnailHover(e) {
    let refIndex = e.target.getAttribute("text");
    let tempImages = [...popoverImages];
    tempImages[refIndex] = e.target.src;
    setPopoverImages(tempImages);
  }

  const metalColorMap = {
    White: 12601,
    Silver: 12602,
    Black: 12603,
  };

  function optionSelectChanged_three(
    obj,
    refIndex,
    position,
    isMin,
    modalRef,
    postfixEn,
    postfixFa,
    pageLang,
    eventKey
  ) {
  
    if (obj !== undefined && typeof obj === "object") {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj.label;
      temp.values[refIndex][position] = parseFloat(obj.value);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
        
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
        
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
      
        // ========== شرط جدید اضافه شده ==========
        if (refIndex === "3CArc" && (
          step2 === "HiddenMoulding" ||
          (step2 === "Outside" && selectedMountOutsideType.length && selectedMountOutsideType[0].value === "Ceiling")
      )) {
          const maxValue = Math.max(...temp.values[refIndex]);
          tempLabels[refIndex] = pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${maxValue}`) + postfixFa
              : maxValue + postfixEn;
      }
        // ======================================
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3AIn") {
            setInputDifdep("3AIn1,3AIn2,3AIn3");
          } else if (refIndex === "3BIn") {
            setInputDifdep("3BIn1,3BIn2,3BIn3");
          } else if (refIndex === "3CArc") {
            setInputDifdep("3CArc1,3CArc2,3CArc3");
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    } else if (obj !== undefined) {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj;
      temp.values[refIndex][position] = parseFloat(obj);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
       
        // ========== شرط جدید اضافه شده ==========
        if (refIndex === "3CArc" && (
          step2 === "HiddenMoulding" ||
          (step2 === "Outside" && selectedMountOutsideType.length && selectedMountOutsideType[0].value === "Ceiling")
      )) {
          const maxValue = Math.max(...temp.values[refIndex]);
          tempLabels[refIndex] = pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${maxValue}`) + postfixFa
              : maxValue + postfixEn;
      }
        // ======================================
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3AIn") {
            setInputDifdep("3AIn1,3AIn2,3AIn3");
          } else if (refIndex === "3BIn") {
            setInputDifdep("3BIn1,3BIn2,3BIn3");
          } else if (refIndex === "3CArc") {
            setInputDifdep("3CArc1,3CArc2,3CArc3");
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    setRequiredStep(temp);
  }

  function clearOptionSelect_three(refIndex, position) {
    let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
    if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
    if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
    temp.labels[refIndex][position] = undefined;
    temp.values[refIndex][position] = undefined;
    setStepSelectedOptions(temp);
  }

  function handleNumberInputLanguage(e) {
    if (pageLanguage === "fa" && e && e.target && typeof e.target.value === "string") {
      const rawValue = e.target.value;
      const faValue = NumberToPersianWord.convertEnToPe(rawValue);
      if (faValue !== rawValue) {
        e.target.value = faValue;
      }
    }
  }

  function optionSelectChanged_LeftRight(
    obj,
    refIndex,
    isLeft,
    postfixEn,
    postfixFa,
    pageLang,
    secondVal
  ) {
    if (obj !== undefined && typeof obj === "object") {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj.value;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;

          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj.value;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;

          setStepSelectedLabel(tempLabels);
        }
      }
    } else if (obj !== undefined) {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;

          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;

          setStepSelectedLabel(tempLabels);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    setRequiredStep(temp);
  }

  function optionSelectChanged(refIndex, selected, postfixEn, postfixFa, pageLang) {
    if (selected !== undefined && typeof selected === "object") {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected.value}`) + postfixFa}`
          : `${selected.value + postfixEn}`;

      if (shouldKeep3BOutCleared.current) {
        delete tempLabels["3BOut"];
        delete tempLabels["3BOut1"];
        delete tempLabels["3BOut2"];
      }

      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected.value;
      // console.log(tempValue);
      setStepSelectedValue(tempValue);
    } else if (selected !== undefined) {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected}`) + postfixFa}`
          : `${selected + postfixEn}`;
      // اگر باید 3BOut پاک بماند، آن را حذف کن
      if (shouldKeep3BOutCleared.current) {
        delete tempLabels["3BOut"];
        delete tempLabels["3BOut1"];
        delete tempLabels["3BOut2"];
      }

      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected;
      // console.log(tempValue);
      setStepSelectedValue(tempValue);
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    setRequiredStep(temp);
  }

  function selectChanged(e, nums, customText, secondRefIndex, secText) {
    
    setStepSelectedLabel((prevLabels) => {
 
      const tempLabels = JSON.parse(JSON.stringify(prevLabels));
      if (e && customText) {
        
        tempLabels[e] = customText;
        if (secondRefIndex !== undefined) {
          secondRefIndex.split(",").forEach((ref, index) => {
            if (ref !== undefined) {
              tempLabels[ref] = secText[index];
            }
          });
        }
      } else if (e) {
        const refIndex = e.target.getAttribute("ref-num");
        tempLabels[refIndex] = e.target.getAttribute("text");
      }
      if (nums !== undefined) {
        nums.split(",").forEach((num) => {
          if (num !== undefined && tempLabels[num] !== undefined) {
            delete tempLabels[num];
          }
        });
      }
      return tempLabels;
    });

    setStepSelectedValue((prevValue) => {
      const tempValue = JSON.parse(JSON.stringify(prevValue));
      if (e && !customText) {
        const refIndex = e.target.getAttribute("ref-num");
        tempValue[refIndex] = e.target.value;
      }
      if (nums !== undefined) {
        nums.split(",").forEach((num) => {
          if (num !== undefined && tempValue[num] !== undefined) {
            delete tempValue[num];
          }
        });
      }
      return tempValue;
    });

    setRequiredStep((prevRequired) => {
      const temp = JSON.parse(JSON.stringify(prevRequired));
      if (e && customText) {
        if (customText !== "" && prevRequired[e]) {
          temp[e] = false;
        }
      } else if (e) {
        const refIndex = e.target.getAttribute("ref-num");
        if (prevRequired[refIndex]) {
          temp[refIndex] = false;
        }
      }
      if (nums !== undefined) {
        nums.split(",").forEach((num) => {
          if (num !== undefined && prevRequired[num]) {
            temp[num] = false;
          }
        });
      }
      return temp;
    });

  }

  let effectless = [
    "PhotoUrl",
    "PageType",
    "PageId",
    "hasPower",
    "MotorPosition",
    "RemoteName",
    "MotorChannels",
    "RoomNameFa",
    "RoomNameEn",
    "WindowName",
    "moreInfoInput",
  ];

  function setCart(refIndex, cartValue, delRefs, secondRefIndex, secondCartValue, customAcc) {
    let temp = JSON.parse(JSON.stringify(cartValues));
    let changingRefs = [];

    if (secondRefIndex === "again") {
      ["Width1", "Width2", "Width3", "Height1", "Height2", "Height3"].forEach(
        (k) => delete temp[k]
      );
    }

    if (refIndex !== undefined) {
      temp[refIndex] = cartValue;
      changingRefs.push(refIndex);
    }
    if (delRefs !== undefined) {
      let tempArr = delRefs.split(",");
      changingRefs.push(...tempArr);
      tempArr.forEach((ref) => {
        if (ref !== undefined) {
          if (temp[ref] !== undefined) delete temp[ref];
        }
      });
    }
    if (secondRefIndex !== undefined && secondRefIndex !== "again") {
      let tempArr1 = secondRefIndex.split(",");
      changingRefs.push(...tempArr1);
      tempArr1.forEach((ref, index) => {
        if (ref !== undefined) {
          temp[ref] = secondCartValue[index];
        }
      });
    }
   
    let MesSce = ["Mount", "calcMeasurements"];
    if (temp["calcMeasurements"]) {
      if (temp["Mount"] === "Inside") {
        MesSce.push(...["Width1", "Width2", "Width2", "Height1", "Height2", "Height3"]);
      } else if (temp["Mount"] === "Outside" && temp["IsWalled"] === "Wall") {
        MesSce.push(...["Width3A", "ExtensionLeft", "ExtensionRight", "Height3C", "ShadeMount"]);
      }else if (temp["Mount"] === "Outside" && temp["IsWalled"] === "Ceiling") {
     
        MesSce.push(
          ...[
            "Width3A",
            "ExtensionLeft",
            "ExtensionRight",
            "CeilingToWindow1",
            "CeilingToWindow2",
            "CeilingToWindow3",
          ]
        );
      } else if (temp["Mount"] === "HiddenMoulding") {
        MesSce.push(
          ...[
            "Width3A",
            "ExtensionLeft",
            "ExtensionRight",
            "CeilingToWindow1",
            "CeilingToWindow2",
            "CeilingToWindow3",
          ]
        );
      }
    } else {
      MesSce.push(...["Width", "Height"]);
    }
    const isMesCompleted = MesSce.every(
      (ref) => Object.keys(temp).includes(ref) && temp[ref] !== undefined
    );
    const isMesCleared =
      delRefs !== undefined &&
      delRefs.split(",").includes("calcMeasurements") &&
      temp["calcMeasurements"] === undefined;
    const isPageLoadEnd =
      refIndex === undefined &&
      cartValue === undefined &&
      delRefs === undefined &&
      secondRefIndex === undefined &&
      secondCartValue === undefined &&
      customAcc === undefined;
    const isEffectless = changingRefs.every((ref) => effectless.includes(ref));
    if (!isPageLoadEnd && !isMesCleared && (isEffectless || (!isMesCompleted && !widthCart))) {
      if (!pageLoad) {
        setCartValues(temp);
      }
      setCartLoading(false);
    } else {
      let tempPostObj = {};
      tempPostObj["WindowCount"] = 1;
      tempPostObj["SewingModelId"] = `${modelID}`;

      let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];

      Object.keys(temp).forEach((key) => {
       
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
        
          if (tempObj === undefined) {
          //  console.log(key);
            // window.location.reload();
          } else {
            if (tempObj && tempObj["apiLabel"] !== "") {
              if (tempObj["apiValue"] === null) {
                tempPostObj[tempObj["apiLabel"]] = temp[key];
              } else {
                tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
              }
            }
          }
        }
      });

      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          // console.log(key,userProjects.find(obj => obj["cart"] === key));
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                  // console.log(i,tempObj["cart"],tempPostObj["SewingOrderDetails"],tempPostObj["SewingOrderDetails"][i]);
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
   
      if (!pageLoad) {
        setCartValues(temp);
      }

      let promise2 = new Promise((resolve, reject) => {
        if (step3 !== "" && !pageLoad && !(motorLoad && refIndex === "MotorType")) {
          for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
            if (
              tempPostObj["SewingOrderDetails"] &&
              tempPostObj["SewingOrderDetails"][i] &&
              tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
            ) {
              tempPostObj["SewingOrderDetails"].splice(i, 1);
            }
          }
          if (zipcode && zipcode !== "") {
            tempPostObj["ZipCode"] = zipcode;
          }
          if (hasZipcode && hasZipcode !== "") {
            tempPostObj["ZipCode"] = hasZipcode;
            delete tempPostObj["InstallAmount"];
            delete tempPostObj["TransportationAmount"];
          }

          // Check if ChainLength exists in temp (cartValues) to persist values even when refIndex changes
          if (temp["ChainLength"] !== undefined && temp["ChainLength"] !== "") {
            tempPostObj["SewingOrderDetails"][0]["ControlType"] = "true";
            if (temp["ChainLength"] === "300") {
              tempPostObj["SewingOrderDetails"][0]["ChainId"] = "90908901";
            } else if (temp["ChainLength"] === "500") {
              tempPostObj["SewingOrderDetails"][0]["ChainId"] = "90908902";
            } else if (temp["ChainLength"] === "200") {
              tempPostObj["SewingOrderDetails"][0]["ChainId"] = "90908903";
            } else if (temp["ChainLength"] === "250") {
              tempPostObj["SewingOrderDetails"][0]["ChainId"] = "90908904";
            } else {
              tempPostObj["SewingOrderDetails"][0]["ChainId"] = null;
            }
          }
          // Check if MotorType exists in temp (cartValues) to persist values even when refIndex changes

        
          if (temp["MotorType"] !== undefined && temp["MotorType"] !== "") {
            tempPostObj["SewingOrderDetails"][0]["ControlType"] = "false";
            if (temp["MotorType"] === "Standard") {
              tempPostObj["SewingOrderDetails"][0]["MotorProductId"] = "61500508";
            } else if (temp["MotorType"] === "Smart") {
              tempPostObj["SewingOrderDetails"][0]["MotorProductId"] = "61500517";
            } else {
              tempPostObj["SewingOrderDetails"][0]["MotorProductId"] = null;
            }
          }

          if (temp["Headrail"] !== undefined && temp["Headrail"] !== "") {
            if (temp["Headrail"] === "Upholstered") {
              tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = "900004";
            } else if (temp["Headrail"] === "MetalValance") {
              tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = "900005";
            } else if (temp["Headrail"] === "MetalValanceFabricInsert") {
              tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = "900006";
            } else {
              tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = null;
            }
          }

          if (temp["HemStyle"] !== undefined && temp["HemStyle"] !== "") {
            if (temp["HemStyle"] === "Scallop") {
              tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = "900001";
            } else if (temp["HemStyle"] === "Wave") {
              tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = "900002";
            } else if (temp["HemStyle"] === "Traditional") {
              tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = "900003";
            } else {
              tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = null;
            }
          }

          // BottomBarStyle
          if (temp["BottomBarStyle"] !== undefined && temp["BottomBarStyle"] !== "") {
            if (temp["BottomBarStyle"] === "Decorative Metal Bar") {
              tempPostObj["SewingOrderDetails"][0]["BottomBarId"] = "900007";
            } else {
              tempPostObj["SewingOrderDetails"][0]["BottomBarId"] = null;
            }
          }

          const totalWidth =
            tempPostObj.Width1 + tempPostObj.LeftStackWidth + tempPostObj.RightStackWidth;
          const totalHeight = tempPostObj.Height1 + tempPostObj.RodMountHeight;
          if (totalWidth > 300) {
            console.log("⚠️ عرض کلی بیشتر از 300 است. درخواست ارسال نشد.", totalWidth);
            return;
          }
          if (totalHeight > 400) {
            console.log("⚠️ ارتفاع کلی بیشتر از 400 است. درخواست ارسال نشد.", totalHeight);
            return;
          }
          axios
            .post(baseURLPrice, tempPostObj)
            .then((response) => {
              setPrice(response.data["Price"]);
              setFabricQty(response.data["FabricQty"]);

              if (response.data["Price"]) {
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                setTransportPrice(
                  response.data["TransportationAmount"] ? response.data["TransportationAmount"] : 0
                );
                setHasInstall(!!response.data["TransportationAmount"]);
              }

              getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
              temp["WindowWidth"] = response.data["WindowWidth"];
              temp["WindowHeight"] = response.data["WindowHeight"];
              temp["WidthCart"] = response.data["Width"];
              temp["HeightCart"] = response.data["Height"];
              setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
              setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
              resolve();
            })
            .catch((err) => {
              setPrice(0);
              setFabricQty(0);
              setWidthCart(undefined);
              setHeightCart(undefined);
              setWindowSizeBool(false);
              resolve(1);
              // console.log(err);
            });
        } else {
          resolve();
        }
      });
      promise2.then((res) => {
        setCartLoading(false);
      });
    }
  }

  function measureWindowSize(zipcode) {
    let promise2 = new Promise((resolve, reject) => {
      let temp = JSON.parse(JSON.stringify(cartValues));
      let tempPostObj = {};
      tempPostObj["WindowCount"] = 1;
      tempPostObj["SewingModelId"] = `${modelID}`;

      let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj === undefined) {
            console.log(key);
            // window.location.reload();
          } else {
            if (tempObj && tempObj["apiLabel"] !== "") {
              if (tempObj["apiValue"] === null) {
                tempPostObj[tempObj["apiLabel"]] = temp[key];
              } else {
                tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
              }
            }
          }
        }
      });

      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          // console.log(key,userProjects.find(obj => obj["cart"] === key));
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                  // console.log(i,tempObj["cart"],tempPostObj["SewingOrderDetails"],tempPostObj["SewingOrderDetails"][i]);
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
 

      if (step3 !== "") {
        for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
          if (
            tempPostObj["SewingOrderDetails"] &&
            tempPostObj["SewingOrderDetails"][i] &&
            tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
          ) {
            tempPostObj["SewingOrderDetails"].splice(i, 1);
          }
        }
        // if (tempPostObj["SewingOrderDetails"][0]["FabricId"] !== undefined && stepSelectedValue["2"] !== undefined && stepSelectedValue["3"] !== undefined) {
        // console.log(JSON.stringify(tempPostObj));
        if (zipcode && zipcode !== "") {
          tempPostObj["ZipCode"] = zipcode;
        }

        axios
          .post(baseURLPrice, tempPostObj)
          .then((response) => {
            if (zipcode && zipcode !== "") {
              if (response.data["Price"]) {
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                setTransportPrice(
                  response.data["TransportationAmount"] ? response.data["TransportationAmount"] : 0
                );
                setHasInstall(!!response.data["TransportationAmount"]);
                setZipcodeButton(true);
              } else {
                HasInstall(zipcode);
              }
            } else {
              setPrice(response.data["Price"]);
              setFabricQty(response.data["FabricQty"]);

              // setCart("HeightCart", totalHeight, "", "WidthCart", [totalWidth]);
              getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
              temp["WindowWidth"] = response.data["WindowWidth"];
              temp["WindowHeight"] = response.data["WindowHeight"];
              temp["WidthCart"] = response.data["Width"];
              temp["HeightCart"] = response.data["Height"];
              setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
              setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
              setCartValues(temp);
              setTimeout(() => {
                resolve();
              }, 1000);
            }
          })
          .catch((err) => {
            if (zipcode && zipcode !== "") {
              setInstallPrice(-1);
              setTransportPrice(-1);
              HasInstall(zipcode);
              setTimeout(() => {
                reject();
              }, 1000);
            } else {
              setWidthCart(undefined);
              setHeightCart(undefined);
              setPrice(0);
              if (temp["HeightCart"] !== undefined) delete temp["HeightCart"];
              if (temp["WidthCart"] !== undefined) delete temp["WidthCart"];

              if (temp["WindowHeight"] !== undefined) delete temp["WindowHeight"];
              if (temp["WindowWidth"] !== undefined) delete temp["WindowWidth"];
              // console.log(err);
              setWindowSizeBool(false);
              setCartValues(temp);
              setTimeout(() => {
                reject();
              }, 1000);
            }
          });
      } else {
        HasInstall(zipcode);
        reject();
      }
    });
    promise2
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function HasInstall(zipcode) {
    axios
      .post(
        baseURLZipCode,
        {},
        {
          params: {
            zipCode: zipcode,
          },
        }
      )
      .then((response) => {
        setHasInstall(response.data);
        setZipcodeButton(true);
      })
      .catch((err) => {
        setHasInstall(false);
        setZipcodeChecked("false");
        setCart("", "", "ZipCode");
        setZipcodeButton(true);
      });
  }

  function clearInputs(e, nums, addNums, Scenario) {
    if (Scenario === undefined) {
      setWidth(undefined);
      setHeight(undefined);
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setWidth1(undefined);
      setWidth2(undefined);
      setWidth3(undefined);
      setHeight1(undefined);
      setHeight2(undefined);
      setHeight3(undefined);
      setWidth3A(undefined);
      setLeft(undefined);
      setRight(undefined);
      setHeight3C(undefined);
      setMount(undefined);
      setStepSelectedOptions({ values: {}, labels: {} });
    } else if (Scenario === "HeightDif") {
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setHeight1(undefined);
      setHeight2(undefined);
      setHeight3(undefined);
    } else if (Scenario === "WidthDif") {
      setWidth1(undefined);
      setWidth2(undefined);
      setWidth3(undefined);
    }

    setTimeout(() => {
      setWindowSizeBool(false);
      selectChanged(
        e,
        nums ? nums : "3AIn,3BIn,3AOut,3BOut,3COut,3DOut,3CArc" + (addNums ? "," + addNums : "")
      );
    }, 100);
  }

  function selectUncheck(e) {
    let refIndex = e.target.getAttribute("ref-num");
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    delete tempLabels[refIndex];
    setStepSelectedLabel(tempLabels);

    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    if (tempValue[refIndex] !== undefined) delete tempValue[refIndex];
    setStepSelectedValue(tempValue);
    e.target.checked = false;
  }

  function setDeps(addDeps, removeDeps, notMainStep) {
    // console.log({
    //   "Added Dependencies": addDeps,
    //   "Removed Dependencies": removeDeps,
    // });
    let temp = JSON.parse(JSON.stringify(requiredStep));
    let depSetTempArr = new Set([...depSet]);
    if (addDeps !== undefined && addDeps !== "") {
      let tempArr = addDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr.add(dep);
        }
      });
    }
    if (removeDeps !== undefined && removeDeps !== "") {
      let tempArr = removeDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr = new Set([...depSetTempArr].filter((x) => x !== dep));

          let tempDep = "";
          if (notMainStep) {
            tempDep = dep.slice(0, Math.abs(notMainStep) * -1);
          } else {
            tempDep = dep;
          }

          if (
            requiredStep[tempDep] &&
            [...depSetTempArr].findIndex((el) => el.startsWith(tempDep) && el.charAt(1) !== "0") ===
              -1
          ) {
            temp[tempDep] = false;
          }
        }
      });
    }

    setDepSet(depSetTempArr);
    setRequiredStep((prev) => {
      if (removeDeps === "32,999") {
        return { ...temp, 3: false };
      }
      if (removeDeps === "21,999") {
        return { ...temp, 2: false };
      }
      if (removeDeps === "4B,999") {
        return { ...temp, 4: false };
      }
      if (removeDeps === "414,999") {
        return { ...temp, 4: false };
      }
      if (removeDeps === "5C,999" || removeDeps === "51,999") {
        return { ...temp, 5: false };
      }
      if (removeDeps === "6A") {
        return { ...temp, 6: false };
      }
      return temp;
    });
  }

  function addToCart() {
    let temp = JSON.parse(JSON.stringify(requiredStep));
    const wallOutsideDeps = ["3COut", "3DOut"];
    const isCeilingOutsideMount =
      step2 === "Outside" &&
      normalizeOutsideMountSubType(
        selectedMountOutsideType[0]?.value ?? cartValues?.IsWalled,
        cartValues?.installationLocation
      ) === "Ceiling";
    const hasCeilingArcSteps =
      stepSelectedLabel["3CArc"] !== undefined ||
      [ceilingToWindow1, ceilingToWindow2, ceilingToWindow3].every((v) => v !== undefined) ||
      [cartValues?.CeilingToWindow1, cartValues?.CeilingToWindow2, cartValues?.CeilingToWindow3].every(
        (v) => v !== undefined
      );
    let tempDepSet =
      isCeilingOutsideMount && hasCeilingArcSteps
        ? [...depSet].filter((dep) => !wallOutsideDeps.includes(dep))
        : [...depSet];
    let tempErr = {};
    let promiseArr = [];
    tempDepSet.forEach((dependency, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        if (steps.current[dependency] !== undefined && steps.current[dependency] !== null) {
          temp[dependency] = true;
          let type =
            steps.current[dependency].getAttribute("type-of-step") === "1"
              ? pageLanguage === "fa"
                ? ""
                : ""
              : pageLanguage === "fa"
              ? ""
              : "";
          tempErr[dependency] = {
            order: dependency,
            el: (
              <li key={index}>
                {pageLanguage === "fa"
                  ? "" + steps.current[dependency].getAttribute("cart-custom-text") + type
                  : "" + type + steps.current[dependency].getAttribute("cart-custom-text")}
              </li>
            ),
          };
        }
        resolve();
      });
    });

    Promise.all(promiseArr).then(() => {
      if (tempDepSet.length  > 0) {
        let promiseArr2 = [];
        Object.keys(depDetails.current).forEach((key, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            let promiseArr3 = [];
            Object.keys(depDetails.current[key]).forEach((key2, index2) => {
              promiseArr3[index2] = new Promise((resolve, reject) => {
                if (
                  depDetails.current[key][key2] !== undefined &&
                  depDetails.current[key][key2] !== null &&
                  tempDepSet.includes(key2)
                ) {
                  let depGroup =
                    depDetails.current[key][key2].getAttribute("dep-group") === ""
                      ? key2
                      : depDetails.current[key][key2].getAttribute("dep-group");
                  // let depType=depDetails.current[key][key2].getAttribute("dep-type")||"";
                  let depText = depDetails.current[key][key2].getAttribute("text") || "";
                  if (steps.current[depGroup] !== undefined && steps.current[depGroup] !== null) {
                    temp[depGroup] = true;
                    if (tempErr[depGroup] === undefined) {
                      let type =
                        steps.current[depGroup].getAttribute("type-of-step") === "1"
                          ? pageLanguage === "fa"
                            ? ""
                            : ""
                          : pageLanguage === "fa"
                          ? ""
                          : "";
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: (
                          <li key={index}>
                            {pageLanguage === "fa"
                              ? "" + steps.current[depGroup].getAttribute("cart-custom-text") + type
                              : "" +
                                type +
                                steps.current[depGroup].getAttribute("cart-custom-text")}
                          </li>
                        ),
                      };
                    }
                    resolve();
                  } else {
                    temp[key] = true;
                    if (tempErr[depGroup] === undefined) {
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: <li key={index + "_" + index2}>{depText}</li>,
                      };
                    }
                    resolve();
                  }
                } else {
                  resolve();
                }
              });
            });

            Promise.all(promiseArr3)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                console.log(err);
                resolve();
              });
          });
        });

        Promise.all(promiseArr2)
          .then(() => {
            if (step3 === "") {
              delete tempErr["3AIn"];
              delete tempErr["3BIn"];
            }
            if (selectedMountOutsideType.length && selectedMountOutsideType[0]?.value === "Ceiling") {
              delete tempErr["3COut"];
              delete tempErr["3DOut"];
          
              if (!tempErr.hasOwnProperty("3CArc") && (!ceilingToWindow2 || ceilingToWindow2 === "") && step3 === "true") {
                  tempErr["3CArc"] = {
                      order: "3CArc",
                      el: <li key="3CArc">{t("Height")}</li>
                  };
                  temp["3CArc"] = true;
              }
          }
          if (isCeilingOutsideMount) {
            wallOutsideDeps.forEach((key) => {
              delete tempErr[key];
              delete temp[key];
            });
            if (
              !hasCeilingArcSteps &&
              !tempErr["3CArc"] &&
              step3 === "true" &&
              (!ceilingToWindow2 || ceilingToWindow2 === "")
            ) {
              tempErr["3CArc"] = {
                order: "3CArc",
                el: <li key="3CArc">{t("Height")}</li>,
              };
              temp["3CArc"] = true;
            }
          }
            let sortedArray = Object.entries(tempErr)
              .sort((a, b) => a[1]["order"].localeCompare(b[1]["order"]))
              .map((entry) => entry[1]["el"]);

            console.log(tempErr, sortedArray);
            setRequiredStep(temp);

            if (sortedArray.length > 0) {
              setAddCartErr(sortedArray);
              modalHandleShow("addToCartErr");
            }
            setAddingLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setAddingLoading(false);
          });
        // console.log(depDetails.current,", ",temp);
      } else if (heightCart === undefined || widthCart === undefined) {
        // console.log(cartValues,"1");
        if (measureWindowSize()) {
          addToCart();
        } else {
          setAddingLoading(false);
        }
      } else {
        if (price) {
          // console.log(cartValues,"2");
          let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];
          let tempArr = [];
          let temp1 = [];
          let temp = JSON.parse(JSON.stringify(cartValues));
          let tempPostObj = {};
          let tempBagPrice = 0;

          // tempPostObj["ApiKey"] = window.$apikey;
          tempPostObj["WindowCount"] = 1;
          tempPostObj["SewingModelId"] = `${modelID}`;
          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              // console.log(key,tempObj);
              if (tempObj && tempObj["apiLabel"] !== "") {
                if (tempObj["apiValue"] === null) {
                  tempPostObj[tempObj["apiLabel"]] = temp[key];
                } else {
                  tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
                }
              }
            }
          });

          tempPostObj["SewingOrderDetails"] = [];
          for (let i = 0; i < 3; i++) {
            tempPostObj["SewingOrderDetails"][i] = {};
            tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
            tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] = true;
            tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
          }

          tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
          tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

          tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
          tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

          tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
          tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              // console.log(key,userProjects.find(obj => obj["cart"] === key));
              if (tempObj) {
                for (let i = 0; i < 3; i++) {
                  let j = +i + +2;
                  if (tempObj["apiLabel" + j] !== undefined) {
                    if (tempObj["apiValue" + j] === null) {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                      // console.log(i,tempObj["cart"],tempPostObj["SewingOrderDetails"],tempPostObj["SewingOrderDetails"][i]);
                    } else {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                        tempObj["apiValue" + j][temp[key]];
                    }
                  }
                }
              }
            }
          });

          const setAdditionalFieldsToTemp = (
            temp,
            tempPostObj,
            MetalValanceColorId,
            chainLengthId,
            customMotorAcc
          ) => {
            temp["HemStyleId"] = hemStyleId ? hemStyleId : null;
            temp["HeadRailId"] = headRailId ? headRailId : null;
            temp["MetalValanceStyleId"] = tempPostObj["MetalValanceStyle"] === "MetalValance" ? 12901 : 12902;
            temp["MetalValanceColorId"] = MetalValanceColorId ? MetalValanceColorId : null;

            temp["BottomBarId"] = bottomBarStyleId ? bottomBarStyleId : null;
            temp["RollTypeId"] = rollTypeId ? rollTypeId : null;
            temp["BracketTypeId"] = bracketTypeId ? bracketTypeId : null;
            temp["BracketColorId"] = bracketColorId ? bracketColorId : null;
            temp["ChainId"] = chainLengthId ? chainLengthId : null;

            // MotorProductId from customMotorAcc.SewingAccessoryValue
            temp["MotorProductId"] =
              Object.keys(customMotorAcc).length > 0 &&
              customMotorAcc["SewingAccessoryValue"] !== undefined &&
              customMotorAcc["SewingAccessoryValue"] !== null &&
              customMotorAcc["SewingAccessoryValue"] !== ""
                ? customMotorAcc["SewingAccessoryValue"]
                : null;

            // RemoteName -> MotorName
            temp["RemoteName"] =
              temp["RemoteName"] !== undefined &&
              temp["RemoteName"] !== null &&
              temp["RemoteName"] !== ""
                ? temp["RemoteName"]
                : null;

            // MotorChannel from MotorChannels (take first value if array)
            temp["MotorChannel"] =
              temp["MotorChannels"] !== undefined && temp["MotorChannels"] !== null
                ? Array.isArray(temp["MotorChannels"])
                  ? temp["MotorChannels"].join(",")
                  : temp["MotorChannels"]
                : null;

            temp["CordSideId"] = cordSideId ? cordSideId : null;
            temp["BackCordSideId"] = stepBackCordSideId ? stepBackCordSideId : null;

            // ControlType - boolean: true for "Motorized", false for "Manual", null if not found
            // temp["ControlType"] =
            //   temp["ControlType"] !== undefined &&
            //   temp["ControlType"] !== null &&
            //   temp["ControlType"] !== ""
            //     ? temp["ControlType"] === "Motorized"
            //       ? "false"
            //       : "true"
            //     : null;
          };

          const fabricItemId = generateFabricItemId();
          temp["fabricItemId"] = fabricItemId;
          tempPostObj["SewingOrderDetails"][0]["fabricItemId"] = fabricItemId;
          tempPostObj["SewingOrderDetails"][0]["HemStyleId"] = hemStyleId;
          tempPostObj["SewingOrderDetails"][0]["HeadRailId"] = headRailId;
          tempPostObj["SewingOrderDetails"][0]["MetalValanceStyleId"] =
            tempPostObj["MetalValanceStyle"] === "MetalValance" ? 12901 : 12902;
          tempPostObj["SewingOrderDetails"][0]["MetalValanceColorId"] =
          MetalValanceColorId ? MetalValanceColorId : null;
          tempPostObj["SewingOrderDetails"][0]["BottomBarId"] = bottomBarStyleId;
          tempPostObj["SewingOrderDetails"][0]["RollTypeId"] = rollTypeId;
          tempPostObj["SewingOrderDetails"][0]["BracketTypeId"] = bracketTypeId;
          tempPostObj["SewingOrderDetails"][0]["BracketColorId"] = bracketColorId;
          tempPostObj["SewingOrderDetails"][0]["ChainId"] = chainLengthId;

          // MotorProductId from customMotorAcc.SewingAccessoryValue
          tempPostObj["SewingOrderDetails"][0]["MotorProductId"] =
            Object.keys(customMotorAcc).length > 0 &&
            customMotorAcc["SewingAccessoryValue"] !== undefined &&
            customMotorAcc["SewingAccessoryValue"] !== null &&
            customMotorAcc["SewingAccessoryValue"] !== ""
              ? customMotorAcc["SewingAccessoryValue"]
              : null;

          // RemoteName -> MotorName
          tempPostObj["SewingOrderDetails"][0]["RemoteName"] =
            temp["RemoteName"] !== undefined &&
            temp["RemoteName"] !== null &&
            temp["RemoteName"] !== ""
              ? temp["RemoteName"]
              : null;

          // MotorChannel from MotorChannels (take first value if array)
          tempPostObj["SewingOrderDetails"][0]["MotorChannel"] =
            temp["MotorChannels"] !== undefined && temp["MotorChannels"] !== null
              ? Array.isArray(temp["MotorChannels"])
                ? temp["MotorChannels"].join(",")
                : temp["MotorChannels"]
              : null;

          tempPostObj["SewingOrderDetails"][0]["BackCordSideId"] =
            temp["BackCordSideId"] !== undefined && temp["BackCordSideId"] !== null
              ? temp["BackCordSideId"]
              : null;

          // ControlType - boolean: true for "Motorized", false for "Manual", null if not found
          tempPostObj["SewingOrderDetails"][0]["ControlType"] =
            temp["ControlType"] !== undefined &&
            temp["ControlType"] !== null &&
            temp["ControlType"] !== ""
              ? temp["ControlType"] === "Motorized"
                ? "false"
                : "true"
              : null;

        
          for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
            if (
              tempPostObj["SewingOrderDetails"] &&
              tempPostObj["SewingOrderDetails"][i] &&
              tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
            ) {
              tempPostObj["SewingOrderDetails"].splice(i, 1);
            }
          }
           // Backend: WindowName = room name, WindowDescription = custom window label
           tempPostObj["WindowDescription"] = tempPostObj["WindowName"] || "";
           tempPostObj["WindowName"] =
             tempPostObj["RoomNameEn"] || temp["RoomNameEn"] || tempPostObj["WindowName"] || "";
             
          if (tempPostObj["SewingOrderDetails"][0]["FabricId"] !== undefined) {
            axios
              .post(baseURLPrice, tempPostObj)
              .then((response) => {
                tempBagPrice = response.data["Price"];
                temp["Price"] = response.data["Price"];
                if (zipcodeChecked && response.data["InstallAmount"]) {
                  temp["InstallAmount"] = response.data["InstallAmount"];
                  temp["TransportationAmount"] = response.data["TransportationAmount"];
                }

                let roomNameFa = cartValues["RoomNameFa"];
                let roomName = cartValues["RoomNameEn"];
                let WindowName =
                  cartValues["WindowName"] === undefined ? "" : cartValues["WindowName"];
                let moreInfoInput =
                  cartValues["moreInfoInput"] === undefined ? "" : cartValues["moreInfoInput"];
                Object.keys(cartValues).forEach((key) => {
                  if (key === "IsWalled" ) {
                    return;
                  }
                  let tempObj = userProjects.find((obj) => obj["cart"] === key);
                  if (tempObj === undefined) {
                    // window.location.reload();
                    console.log(key);
                  } else {
                    if (key === "WindowHeight" || key === "WindowWidth") {
                    } else if (
                      tempObj["title"] !== "" &&
                      tempObj["lang"].indexOf(pageLanguage) > -1
                    ) {
                      let objLabel = "";
                      if (key === "Mount" && cartValues["Mount"] === "Outside") {
                        const isWalledRaw = normalizeOutsideMountSubType(
                          selectedMountOutsideType.length > 0
                            ? selectedMountOutsideType[0].value
                            : cartValues["IsWalled"],
                          cartValues["installationLocation"]
                        );
                        const combinedLabel = formatCombinedOutsideMountLabel(
                          isWalledRaw,
                          pageLanguage,
                          t
                        );
                        objLabel = combinedLabel
                          ? pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(combinedLabel).toString()
                            : combinedLabel
                          : pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(t("Outside")).toString()
                            : t("Outside Mount");
                      } else if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                        objLabel =
                          pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(
                                `${t(cartValues[key]?.toString())} / ${t(
                                  cartValues["MotorType"]?.toString()
                                )}`
                              ).toString()
                            : `${t(cartValues[key].toString())} / ${t(
                                cartValues["MotorType"].toString()
                              )}`;
                      } else if (tempObj["titleValue"] === null || true) {
                        if (tempObj["titlePostfix"] === "") {
                          const rawVal = cartValues[key];
                          const val = rawVal ? rawVal.toString() : "0"; // or ""

                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(t(val)).toString()
                              : t(val);
                        } else {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${cartValues[key]}`).toString() +
                                t(tempObj["titlePostfix"])
                              : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                        }
                        // objLabel = cartValues[key].toString() + tempObj["titlePostfix"];
                      } else {
                        // console.log(tempObj["titleValue"],tempObj["titleValue"][cartValues[key].toString()],cartValues[key]);
                        if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                          if (tempObj["titlePostfix"] === "") {
                            objLabel = t(cartValues[key].toString());
                          } else {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${cartValues[key]}`
                                  ).toString() + t(tempObj["titlePostfix"])
                                : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                          }
                        } else {
                          objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                        }
                      }
                      temp1[tempObj["order"]] = (
                        <li className="cart_agree_item" key={key}>
                          <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                        </li>
                      );
                    }
                  }
                });
                let materialColorObj = userProjects.find((obj) => obj["cart"] === "MaterialColor");
                if (
                  materialColorObj &&
                  materialColorObj["lang"].indexOf(pageLanguage) > -1 &&
                  ((pageLanguage === "en" &&
                    cartValues["FabricDesignEn"] &&
                    cartValues["FabricColorEn"]) ||
                    (pageLanguage === "fa" &&
                      cartValues["FabricDesignFa"] &&
                      cartValues["FabricColorFa"]))
                ) {
                  const fabricDesign =
                    pageLanguage === "fa"
                      ? cartValues["FabricDesignFa"]
                      : cartValues["FabricDesignEn"];
                  const fabricColor =
                    pageLanguage === "fa"
                      ? cartValues["FabricColorFa"]
                      : cartValues["FabricColorEn"];

                  temp1[materialColorObj["order"]] = (
                    <li className="cart_agree_item 3" key="MaterialColor">
                      <h1 className="cart_agree_item_title">
                        {t(materialColorObj["title"])}&nbsp;
                      </h1>
                      <h2 className="cart_agree_item_desc">
                        {pageLanguage === "fa"
                          ? fabricDesign + " / " + fabricColor
                          : CapitalizeAllWords(fabricDesign + " / " + fabricColor)}
                      </h2>
                    </li>
                  );
                }

                tempArr.push(
                  <div key={defaultModelName}>
                    <h2 className="cart_agree_title">
                      {pageLanguage === "fa"
                        ? convertToPersian(defaultModelNameFa) + " سفارشی "
                        : "Custom " + defaultModelName}
                    </h2>
                    <ul className="cart_agree_items_container">
                      <GetMeasurementArray modelId={`${modelID}`} cartValues={cartValues} />
                      {temp1}
                      <li className="cart_agree_item">
                        <h1 className="cart_agree_item_title">
                          {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                        </h1>
                        <h2 className="cart_agree_item_desc">
                          {pageLanguage === "fa"
                            ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                            : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                        </h2>
                      </li>
                      {moreInfoInput !== "" && (
                        <li className="cart_agree_item">
                          <h1 className="cart_agree_item_title">{t("Order Notes")}&nbsp;</h1>
                          <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                        </li>
                      )}
                      <li className="cart_agree_item">
                        <h1 className="cart_agree_item_title">{t("Price2")}&nbsp;</h1>
                        <h2 className="cart_agree_item_desc">
                          {GetPrice(tempBagPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                        </h2>
                      </li>
                    </ul>
                  </div>
                );
                setCartAgree(tempArr);
                modalHandleShow("cart_modal");
                setAdditionalFieldsToTemp(
                  temp,
                  tempPostObj,
                  MetalValanceColorId,
                  chainLengthId,
                  customMotorAcc
                );
                setCartValues(temp);
                setAddingLoading(false);
              })
              .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 401) {
                  refreshToken().then((response2) => {
                    if (response2 !== false) {
                      addToCart();
                    } else {
                      setPrice(0);
                      temp["Price"] = 0;
                      setCartValues(temp);
                      setAddingLoading(false);
                      navigate("/" + pageLanguage + "/User");
                    }
                  });
                } else {
                  setPrice(0);
                  temp["Price"] = 0;
                  setCartValues(temp);
                  setAddingLoading(false);
                  modalHandleClose("cart_modal");
                }
              });
          } else {
            setAddingLoading(false);
          }
          // console.log(cartValues);
        }
      }
      // modalHandleShow("cart_modal");
      // renderCart();
      // setCartStateAgree(true);
    });
  }

  function addToCart_agreed() {
    const successImages = uploadedImages.filter((img) => img.status === "success");
    const imageFiles = successImages.map((img) => img.name);
    const imageUrls = successImages.map((img) => {
      if (img.url && img.url.startsWith("http")) {
        try {
          const urlObj = new URL(img.url);
          return urlObj.pathname; // مثلاً "/Content/Images/.../file.jpg"
        } catch (e) {
          return img.url;
        }
      }
      return img.url || "";
    });

    const successPdfs = uploadedPDFs.filter((pdf) => pdf.status === "success");
    const pdfFiles = successPdfs.map((pdf) => pdf.name);
    const pdfUrls = successPdfs.map((pdf) => {
      if (pdf.url && pdf.url.startsWith("http")) {
        try {
          const urlObj = new URL(pdf.url);
          return urlObj.pathname;
        } catch (e) {
          return pdf.url;
        }
      }
      return pdf.url || "";
    });

    const filesForCart = [imageFiles, imageUrls, pdfFiles, pdfUrls];
    if (selectedMountOutsideType && selectedMountOutsideType.length > 0 && selectedMountOutsideType[0].value && cartValues?.Mount === "Outside" ) {
      cartValues.installationLocation = selectedMountOutsideType[0].value;
    }
    AddProjectToCart(
      cartValues,
      `${modelID}`,
      price,
      defaultModelName,
      defaultModelNameFa,
      filesForCart,
      projectId && projectId !== "" ? projectId : cartProjectIndex,
      editIndex,
      navigate,
      isLoggedIn,
      customMotorAcc
    )
      .then((temp) => {
        if (temp === 401) {
          addToCart_agreed();
        } else if (temp) {
          setCartAgreeDescription(false);
          renderCart(temp);
          setBag(temp);
          setTimeout(() => {
            // modalHandleShow("cart_modal");
            setCartStateAgree(true);
          }, 500);
          setAddingLoading(false);
        } else {
          setAddingLoading(false);
          setCartAgreeDescription(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setAddingLoading(false);
        setCartAgreeDescription(false);
      });
  }

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(
        cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402)
      );
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  function renderCart(customPageCart) {
    let cartObjects = {};
    let promise2 = new Promise((resolve, reject) => {
      if (customPageCart !== undefined) {
        cartObjects = customPageCart;
        resolve();
      } else {
        if (isLoggedIn) {
          axios
            .get(baseURLGetCart, {
              headers: authHeader(),
            })
            .then((response) => {
              cartObjects = response.data ? response.data : {};
              resolve();
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    renderCart(customPageCart);
                  } else {
                    navigate("/" + pageLanguage + "/User");
                  }
                });
              } else {
                modalHandleClose("cart_modal");
                reject();
              }
            });
        } else {
          if (localStorage.getItem("cart") === null) {
            modalHandleClose("cart_modal");
            reject();
          } else {
            cartObjects = JSON.parse(localStorage.getItem("cart"));
            resolve();
          }
        }
      }
    });
    promise2.then(() => {
      let cartCount = 0;
      setSideCartObjects(cartObjects);
      updateSideCartSummary(cartObjects);
      if (isLoggedIn) {
        if (cartObjects["CartDetails"].length === 0) {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["CartDetails"].length;
      } else {
        if (
          cartObjects["drapery"].length +
            cartObjects["product"].length +
            cartObjects["swatches"].length ===
          0
        ) {
          setCartCount(0);
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["drapery"].length;
      }
      setCartCount(cartCount);
    });
    axios
      .get(baseURLFreeShipping)
      .then((response) => {
        setFreeShipPrice(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function fabricClicked(photo, hasTrim) {
    if(photo !== undefined && photo !== null && photo !== "") {
      setDefaultFabricPhoto(photo);
    }
  }

  function fabricSwatch(e, SwatchId, SwatchDetailId, PhotoPath) {
    let currentState = e.target ? e.target.getAttribute("current-state") : e;
    if (isLoggedIn) {
      if (currentState === "0") {
        AddSwatch(SwatchId)
          .then((response) => {
            setBag(response.data ? response.data : {});
            renderFabrics(response.data ? response.data : {});
            if (show) {
              if (response.data["CartDetails"]) {
                let index = response.data["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  setSwatchDetailId(response.data["CartDetails"][index]["CartDetailId"]);
                }
              }
            }
          })
          .catch((err) => {
            fabricSwatch(e, SwatchId, SwatchDetailId);
          });
      } else {
        if (SwatchDetailId) {
          axios
            .post(
              baseURLDeleteBasketProject + "/" + SwatchDetailId,
              {},
              {
                headers: authHeader(),
              }
            )
            .then((response) => {
              setCartChanged(cartChanged + 1);
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    fabricSwatch(e, SwatchId, SwatchDetailId);
                  } else {
                    fabricSwatch(e, SwatchId, SwatchDetailId);
                  }
                });
              } else {
              }
            });
        }
      }
      if (show) {
        if (currentState === "0") {
          setHasSwatchId(true);
        } else {
          setHasSwatchId(false);
        }
      }
    } else {
      setSwatchLogin(true);
      setSwatchLoginSwatchId(SwatchId);
      setSwatchLoginSwatchDetailId(SwatchDetailId);
      modalHandleShow("side_login_modal");
      // dispatch({
      //     type: ShowLoginModal,
      // })
      // if (localStorage.getItem("cart") !== null) {
      //     cartObj = JSON.parse(localStorage.getItem("cart"));
      //     temp = cartObj["swatches"];
      // } else {
      //     cartObj["drapery"] = [];
      //     cartObj["product"] = [];
      //     cartObj["swatches"] = [];
      // }
      // if (currentState === "0") {
      //     temp.push({"SwatchId": SwatchId, "Count": 1,"PhotoPath":PhotoPath});
      // } else {
      //     if (temp?.length > 0) {
      //         let index = temp.findIndex(object => {
      //             return object["SwatchId"] === SwatchId;
      //         });
      //         if (index !== -1) {
      //             temp.splice(index, 1);
      //         }
      //     }
      // }
      // cartObj["swatches"] = temp;
      // localStorage.setItem('cart', JSON.stringify(cartObj));
      // setCartChanged(cartChanged + 1);
    }
  }

  function getWindowSize(totalWidth, totalHeight) {
    if (totalWidth > 0 && totalHeight > 0) {
      let pageLanguage = location.pathname
        .split("")
        .slice(1, 3)
        .join("");
      let tempWindowSize =
        pageLanguage === "fa"
          ? `عرض: ${NumberToPersianWord.convertEnToPe(
              totalWidth.toString()
            )}س\u200Cم\u00A0\u00A0\u00A0ارتفاع: ${NumberToPersianWord.convertEnToPe(
              totalHeight.toString()
            )}س\u200Cم`
          : `Width: ${totalWidth}cm\u00A0\u00A0\u00A0Height: ${totalHeight}cm`;
      setWindowSize(tempWindowSize);
      setWindowSizeBool(true);
      // console.log(totalWidth,totalHeight);
    } else {
      setWindowSizeBool(false);
    }
  }

  function roomLabelChanged(changedValue, refIndex, isText) {
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    let tempSelect = JSON.parse(JSON.stringify(roomLabelSelect));
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (isText) {
      if (roomLabelSelect.label !== "") {
        if (changedValue === "") {
          tempLabels[refIndex] = roomLabelSelect.label;
        } else {
          tempLabels[refIndex] = roomLabelSelect.label + " - " + changedValue;
        }
      }
    } else {
      tempSelect.label = changedValue.label;
      tempSelect.value = changedValue.value;

      tempValue[refIndex] = changedValue.value;

      if (changedValue.label !== "") {
        if (roomLabelText === "") {
          tempLabels[refIndex] = changedValue.label;
        } else {
          tempLabels[refIndex] = changedValue.label + " - " + roomLabelText;
        }
      }
    }
    if (tempLabels[refIndex] !== "" && requiredStep[refIndex]) {
      temp[refIndex] = false;
    }

    setStepSelectedLabel(tempLabels);
    setStepSelectedValue(tempValue);
    setRoomLabelSelect(tempSelect);
    setRequiredStep(temp);
  }

  function uploadImg(file) {
    setSelectedFile(file);
    setSelectedFileName(file.name);
  }

  function retryAxiosPost(url, formData, config, onSuccess, onFail, retries = 1, delay = 30000) {
    axios
      .post(url, formData, config)
      .then(onSuccess)
      .catch((err) => {
        console.log("Upload error:", err);

        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              retryAxiosPost(url, formData, config, onSuccess, onFail, retries, delay);
            } else {
              onFail(err);
            }
          });
        } else if (retries > 0) {
          setTimeout(() => {
            console.log("Retrying upload...");
            retryAxiosPost(url, formData, config, onSuccess, onFail, retries - 1, delay);
          }, delay);
        } else {
          onFail(err);
        }
      });
  }

  function submitUploadedFile(PDFOrImg, file) {
    setIsUploading(true);

    let extensionSearch = /(?:\.([^.]+))?$/;
    let extension;
    let newFile;
    if (selectedFile === undefined) {
      extension = extensionSearch.exec(file.name)[1];
      newFile = new File(
        [file],
        editedFileName === "" ? file.name : editedFileName + "." + extension,
        { type: `${file.type}` }
      );
    } else {
      extension = extensionSearch.exec(selectedFile.name)[1];
      newFile = new File(
        [selectedFile],
        editedFileName === "" ? selectedFile.name : editedFileName + "." + extension,
        { type: `${selectedFile.type}` }
      );
    }

    const formData = new FormData();
    formData.append("File", newFile);
    formData.append("UserFileName", newFile.name);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        ...authHeader(),
      },
    };

    const url = PDFOrImg === 1 ? baseURLUploadPdf : baseURLUploadImg;

    const onSuccess = (response) => {
      setIsUploading(false);
      addUploadFileUrl(response.data, newFile.name, PDFOrImg, newFile);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");
    };

    const onFail = (err) => {
      setIsUploading(false);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");

      dispatch({
        type: ShowLogin2Modal,
      });
    };

    retryAxiosPost(url, formData, config, onSuccess, onFail, 1, 30000); // یکبار بعد از ۳۰ ثانیه تلاش مجدد
  }

  function addUploadFileUrl(fileUrl, imageName, PDFOrImg, newFile) {
    if (!fileUrl) return;

    const newFileObj = {
      id: Date.now() + Math.random() + imageName,
      name: imageName,
      url: fileUrl,
      size: newFile.size,
      type: PDFOrImg === 1 ? "application/pdf" : newFile.type,
      status: "success",
      uploadedAt: new Date(),
    };

    if (PDFOrImg === 1) {
      setUploadedPDFs((prev) => {
        const updated = [...prev, newFileObj];
        sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(updated));
        return updated;
      });
    } else {
      setUploadedImages((prev) => {
        const updated = [...prev, newFileObj];
        sessionStorage.setItem("backup_uploadedImages", JSON.stringify(updated));
        return updated;
      });
    }
  }

  function setDeleteUploaded(fileUrl, freeIndex, PDFOrImg) {
    if (PDFOrImg === 1) {
      setDeleteUploadPdfUrl(fileUrl);
      setDeleteUploadPdfIndex(freeIndex);
    } else {
      setDeleteUploadImageUrl(fileUrl);
      setDeleteUploadImageIndex(freeIndex);
    }
  }

  const handleDeleteFile2 = async (fileId) => {
    let file = uploadingFiles.find((f) => f.id === fileId);
    let isUploading = !!file;
    if (!file) file = uploadedImages.find((f) => f.id === fileId);
    if (!file) file = uploadedPDFs.find((f) => f.id === fileId);
    if (!file) return;

    if (isUploading || file.status === "pending" || file.status === "uploading") {
      if (multipleFileUploadRef.current) {
        multipleFileUploadRef.current.cancelUpload(fileId);
      } else {
        console.error("multipleFileUploadRef is null! Check ref assignment.");
      }
      return;
    }

    const isPdf = file.type === "application/pdf";
    const hasError = file.status === "error" || !file.url;

    if (hasError) {
      if (isPdf) {
        setUploadedPDFs((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(newList));
          return newList;
        });
      } else {
        setUploadedImages((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedImages", JSON.stringify(newList));
          return newList;
        });
      }
      return;
    }

    let relativeUrl = file.url;
    if (relativeUrl?.startsWith("http")) {
      try {
        const urlObj = new URL(relativeUrl);
        relativeUrl = urlObj.pathname;
      } catch (e) {}
    }

    try {
      const encodedUrl = encodeURIComponent(relativeUrl);
      await axios.delete(`${baseURLDeleteFile}?url=${encodedUrl}`);
      if (isPdf) {
        setUploadedPDFs((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(newList));
          return newList;
        });
      } else {
        setUploadedImages((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedImages", JSON.stringify(newList));
          return newList;
        });
      }
    } catch (err) {
      console.error("Delete from server failed", err);
    }
  };

  function deleteUploadedImg(uploadedImagesList1, uploadedImagesNamesList1, fileUrl, index) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedImg(uploadedImagesList1, uploadedImagesNamesList1, fileUrl, index);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArray = [...uploadedImagesList1];
      let tempArrayNames = [...uploadedImagesNamesList1];
      let tempArrayFiles = [...uploadedImagesFile];
      let tempArrayURLs = [...uploadedImagesURL];

      delete tempArray[index];
      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedImagesURL(tempArrayURLs);
      setUploadedImagesFile(tempArrayFiles);
      setUploadedImagesList(tempArray);
      setUploadedImagesNamesList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  }

  function deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArrayNames = [...uploadedPdfsNamesList1];
      let tempArrayFiles = [...uploadedPDFFile];
      let tempArrayURLs = [...uploadedPDFURL];

      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedPDFURL(tempArrayURLs);
      setUploadedPDFFile(tempArrayFiles);
      setUploadedPDFNameList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  }

  function getProjectDetail(basketId) {
    axios
      .get(baseURGetProject, {
        params: {
          id: basketId ? basketId : projectId,
        },
        headers: authHeader(),
      })
      .then((response) => {
        setProjectDetails(response.data, basketId);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getProjectDetail();
            } else {
              navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
            }
          });
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      });
  }
  const convertTempToFiles = (temp) => {
    const images =
      temp.uploadedImagesURL?.map((url, idx) => ({
        id: `restored-img-${Date.now()}-${idx}-${temp.uploadedImagesFile?.[idx] || ""}`,
        name: temp.uploadedImagesFile?.[idx] || "unknown",
        url: imgUrl(url),
        size: 0,
        type: "image/" + url.split(".").pop(),
        status: "success",
        uploadedAt: new Date(0),
      })) || [];
    const pdfs =
      temp.uploadedPDFURL?.map((url, idx) => ({
        id: `restored-pdf-${Date.now()}-${idx}-${temp.uploadedPDFFile?.[idx] || ""}`,
        name: temp.uploadedPDFFile?.[idx] || "unknown",
        url: imgUrl(url),
        size: 0,
        type: "application/pdf",
        status: "success",
        uploadedAt: new Date(0),
      })) || [];
    return { images, pdfs };
  };

  function setProjectDetails(data, editIndex, changeLang) {
    let storedImages = [];
    let storedPDFs = [];
    try {
      const imagesRaw = sessionStorage.getItem("backup_uploadedImages");
      const pdfsRaw = sessionStorage.getItem("backup_uploadedPDFs");
      if (imagesRaw) storedImages = JSON.parse(imagesRaw);
      if (pdfsRaw) storedPDFs = JSON.parse(pdfsRaw);
    } catch (e) {
      console.error("sessionStorage read error", e);
    }
    if (storedImages.length) setUploadedImages(storedImages);
    if (storedPDFs.length) setUploadedPDFs(storedPDFs);
    setPageLoad(true);
    setMesLoad(true);
    if (data && Object.keys(data).length !== 0) {
      setProjectData(data);
    }

    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let tempLabels = {};
    let tempValue = {};
    let selectValues = JSON.parse(JSON.stringify(selectCustomValues));
    let tempSelect = JSON.parse(JSON.stringify(roomLabelSelect));
    let depSetTempArr = new Set([...depSet]);

    let postfixFa = "س\u200Cم";
    let postfixEn = "cm";
    GetUserProjectData(data, isLoggedIn, editIndex, changeLang).then((temp) => {
      if (editIndex !== undefined && Object.keys(temp).length !== 0) {
        setCartProjectIndex(editIndex);
      }
      //  console.log(`temp-3357`, temp);
      setCartValues(temp);

      let tempFabric = {};
      let promise2 = new Promise((resolve, reject) => {
        if (temp["FabricId"]) {
          axios
            .get(baseURLFabrics, {
              params: {
                modelId: modelID,
              },
            })
            .then((response) => {
              response.data.forEach((obj) => {
                if (obj["FabricId"] === temp["FabricId"]) {
                  tempFabric = obj;
                }
              });
              resolve();
            })
            .catch((err) => {
              console.log(err);
              reject();
            });
        } else {
          reject();
        }
      });
      promise2
        .then(() => {
          if (tempFabric !== {}) {
            let temp1 = JSON.parse(JSON.stringify(fabricSelected));
            temp1.selectedFabricId = tempFabric.FabricId;
            temp1.selectedTextEn = tempFabric.DesignEnName;
            temp1.selectedTextFa = tempFabric.DesignName;
            temp1.selectedColorEn = tempFabric.ColorEnName;
            temp1.selectedColorFa = tempFabric.ColorName;
            temp1.selectedHasTrim = tempFabric.HasTrim;
            temp1.selectedPhoto = tempFabric.FabricOnModelPhotoUrl;
            setFabricSelected(temp1);
            // fabricClicked(tempFabric["FabricOnModelPhotoUrl"], tempFabric["HasTrim"]);
            tempLabels["1"] =
              location.pathname
                .split("")
                .slice(1, 3)
                .join("") === "fa"
                ? tempFabric["DesignName"] + "/" + tempFabric["ColorName"]
                : tempFabric["DesignEnName"] + "/" + tempFabric["ColorEnName"];
            tempValue["1"] = temp["FabricId"];
            depSetTempArr = new Set([...setGetDeps("", "1", depSetTempArr)]);

            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            promise2.reject();
          }
        })
        .catch(() => {
          console.log(`temp`, temp);
          if (temp["Mount"]) {
            setStep2(temp["Mount"]);
            if (temp["Mount"] === "Inside") {
              setStep21("true");
              let refIndex = inputs.current["211"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["211"].getAttribute("text");
              tempValue[refIndex] = inputs.current["211"].value;
              depSetTempArr = new Set([...setGetDeps("", "2", depSetTempArr)]);
            } else if (temp["Mount"] === "Outside") {
             
              let refIndex = inputs.current["22"].getAttribute("ref-num");
              const isWalledValue =
                temp["IsWalled"] === true || temp["IsWalled"] === "true"
                  ? "Wall"
                  : temp["IsWalled"] === false || temp["IsWalled"] === "false"
                    ? "Ceiling"
                    : temp["IsWalled"];
              const isWalledOption =
                isWalledValue &&
                optionsOutside[pageLanguage].find((opt) => opt.value === isWalledValue);
              tempLabels[refIndex] =
                inputs.current["22"].getAttribute("text") +
                (isWalledOption ? "/" + isWalledOption.label : "");
              tempValue[refIndex] = inputs.current["22"].value;
              if (isWalledOption) {
                setSelectedMountOutsideType([
                  {
                    value: isWalledValue,
                    label: isWalledOption.label,
                  },
                ]);
              }
              depSetTempArr = new Set([...setGetDeps("", "2", depSetTempArr)]);
            }  else {
              setStep21("true");
              let refIndex = inputs.current["213"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["213"].getAttribute("text");
              tempValue[refIndex] = inputs.current["213"].value;
              depSetTempArr = new Set([...setGetDeps("", "2", depSetTempArr)]);
            }
            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
          }

          if (temp["calcMeasurements"] !== undefined) {
            setStep3(temp["calcMeasurements"].toString());
            if (!temp["calcMeasurements"]) {
              let refIndex = inputs.current["31"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["31"].getAttribute("text");
              tempValue[refIndex] = inputs.current["31"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);

              // selectValues["width"] = temp["Width"] ? [{value: temp["Width"]}] : [];
              // selectValues["length"] = temp["Height"] ? [{value: temp["Height"]}] : [];
              setWidth(temp["Width"] ? temp["Width"] : undefined);
              setHeight(temp["Height"] ? temp["Height"] : undefined);
              depSetTempArr = new Set([
                ...setGetDeps(
                  (temp["Width"] ? "" : "31,") + (temp["Height"] ? "" : "32,"),
                  "3",
                  depSetTempArr
                ),
              ]);
              setSelectCustomValues(selectValues);
            } else {
              let refIndex = inputs.current["32"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["32"].getAttribute("text");
              tempValue[refIndex] = inputs.current["32"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              if (temp["Mount"]) {
                if (temp["Mount"] === "Inside") {
                  let tempWidth = changeLang ? temp["Width1"] : temp["Width"];
                  let tempHeight = changeLang ? temp["Height1"] : temp["Height"];
                  setWidth1(tempWidth ? tempWidth : undefined);
                  setWidth2(temp["Width2"] ? temp["Width2"] : undefined);
                  setWidth3(temp["Width3"] ? temp["Width3"] : undefined);
                  setHeight1(tempHeight ? tempHeight : undefined);
                  setHeight2(temp["Height2"] ? temp["Height2"] : undefined);
                  setHeight3(temp["Height3"] ? temp["Height3"] : undefined);
                  if (tempWidth && temp["Width2"] && temp["Width3"]) {
                    let tempMin = Math.min(tempWidth, temp["Width2"], temp["Width3"]);
                    tempLabels["3AIn"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
                        : tempMin + postfixEn;
                  }
                  if (tempHeight && temp["Height2"] && temp["Height3"]) {
                    let tempMax = Math.min(tempHeight, temp["Height2"], temp["Height3"]);
                    tempLabels["3BIn"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                        : tempMax + postfixEn;
                  }

                  depSetTempArr = new Set([
                    ...setGetDeps(
                      (tempWidth ? "" : "3AIn1,") +
                        (temp["Width2"] ? "" : "3AIn2,") +
                        (temp["Width3"] ? "" : "3AIn3,") +
                        (tempHeight ? "" : "3BIn1,") +
                        (temp["Height2"] ? "" : "3BIn2,") +
                        (temp["Height3"] ? "" : "3BIn3,"),
                      "3",
                      depSetTempArr
                    ),
                  ]);
                  setSelectCustomValues(selectValues);
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                } else if (temp["Mount"] === "Outside") {
                  let tempWidth = changeLang ? temp["Width3A"] : temp["Width"];
                  let tempHeight = changeLang ? temp["Height3C"] : temp["Height"];
                  setWidth3A(tempWidth ? tempWidth : undefined);
                  if (tempWidth) {
                    tempLabels["3AOut"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                        : tempWidth + postfixEn;
                  }
                  // selectValues["height3C"] = tempHeight ? [{value: tempHeight}] : [];
                  setHeight3C(tempHeight ? tempHeight : undefined);
                  if (tempHeight) {
                    tempLabels["3COut"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                        : tempHeight + postfixEn;
                  }
                  setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                  setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                  if (temp["ExtensionLeft"] !== undefined && temp["ExtensionRight"] !== undefined) {
                    tempLabels["3BOut"] =
                      pageLanguage === "fa"
                        ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp["ExtensionRight"]}`) +
                            postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                            `${temp["ExtensionLeft"]}`
                          ) + postfixFa}`
                        : `Left: ${temp["ExtensionLeft"] +
                            postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                            postfixEn}`;
                  }
                  // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                  setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                  if (temp["ShadeMount"] !== undefined) {
                    tempLabels["3DOut"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) + postfixFa
                        : temp["ShadeMount"] + postfixEn;
                  }

                  if(temp["IsWalled"] === "Ceiling"){
                    let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                    let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                    let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];
  
                    setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                    setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                    setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                    if (tempHeight && tempHeight2 && tempHeight3) {
                      let tempMax = Math.max(tempHeight, tempHeight2, tempHeight3);
                      tempLabels["3CArc"] =
                        pageLanguage === "fa"
                          ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                          : tempMax + postfixEn;
                    }
  
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (tempWidth ? "" : "3AOut,") +
                          (temp["ExtensionLeft"] !== undefined ? "" : "3BOut1,") +
                          (temp["ExtensionRight"] !== undefined ? "" : "3BOut2,") +
                          (tempHeight !== undefined ? "" : "3CArc1,") +
                          (tempHeight2 !== undefined ? "" : "3CArc2,") +
                          (tempHeight3 !== undefined ? "" : "3CArc3,"),
                        "3",
                        depSetTempArr
                      ),
                    ]);
                 
                   }

                  depSetTempArr = new Set([
                    ...setGetDeps(
                      (tempWidth ? "" : "3AOut,") +
                        (tempHeight ? "" : "3COut,") +
                        (temp["ExtensionLeft"] !== undefined ? "" : "3BOut1,") +
                        (temp["ExtensionRight"] !== undefined ? "" : "3BOut2,") +
                        (temp["ShadeMount"] !== undefined ? "" : "3DOut,"),
                      "3",
                      depSetTempArr
                    ),
                  ]);
                  setSelectCustomValues(selectValues);
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                } else {
                  let tempWidth = changeLang ? temp["Width3A"] : temp["Width"];
                  let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                  let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                  let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];

                  // selectValues["width3A"] = tempWidth ? [{value: tempWidth}] : [];
                  setWidth3A(tempWidth ? tempWidth : undefined);
                  if (tempWidth) {
                    tempLabels["3AOut"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                        : tempWidth + postfixEn;
                  }
                  // selectValues["left"] = temp["ExtensionLeft"] ? [{value: temp["ExtensionLeft"]}] : [];
                  // selectValues["right"] = temp["ExtensionRight"] ? [{value: temp["ExtensionRight"]}] : [];
                  setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                  setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                  if (temp["ExtensionLeft"] !== undefined && temp["ExtensionRight"] !== undefined) {
                    tempLabels["3BOut"] =
                      pageLanguage === "fa"
                        ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp["ExtensionRight"]}`) +
                            postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                            `${temp["ExtensionLeft"]}`
                          ) + postfixFa}`
                        : `Left: ${temp["ExtensionLeft"] +
                            postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                            postfixEn}`;
                  }
                  // selectValues["CeilingToWindow1"] = tempHeight ? [{value: tempHeight}] : [];
                  // selectValues["CeilingToWindow2"] = tempHeight2 ? [{value: tempHeight2}] : [];
                  // selectValues["CeilingToWindow3"] = tempHeight3 ? [{value: tempHeight3}] : [];
                  setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                  setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                  setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                  if (tempHeight && tempHeight2 && tempHeight3) {
                    let tempMax = Math.max(tempHeight, tempHeight2, tempHeight3);
                    tempLabels["3CArc"] =
                      pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                        : tempMax + postfixEn;
                  }

                  depSetTempArr = new Set([
                    ...setGetDeps(
                      (tempWidth ? "" : "3AOut,") +
                        (temp["ExtensionLeft"] !== undefined ? "" : "3BOut1,") +
                        (temp["ExtensionRight"] !== undefined ? "" : "3BOut2,") +
                        (tempHeight !== undefined ? "" : "3CArc1,") +
                        (tempHeight2 !== undefined ? "" : "3CArc2,") +
                        (tempHeight3 !== undefined ? "" : "3CArc3,"),
                      "3",
                      depSetTempArr
                    ),
                  ]);
                  setSelectCustomValues(selectValues);
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                }
              }
            }
          }
          if (temp["WindowWidth"] && temp["WindowHeight"]) {
            getWindowSize(temp["WindowWidth"], temp["WindowHeight"]);
          }

          if (temp["ControlType"]) {
            setStep4(temp["ControlType"]);
            if (temp["ControlType"] === "Continuous Loop") {
              let refIndex = inputs.current["41"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["41"].getAttribute("text");
              tempValue[refIndex] = inputs.current["41"].value;

              depSetTempArr = new Set([
                ...setGetDeps(
                  (temp["ControlPosition"] ? "" : "4A,") + (temp["ChainLength"] ? "" : "4B,"),
                  "4",
                  depSetTempArr
                ),
              ]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);

              if (temp["ControlPosition"]) {
                setStep4A(temp["ControlPosition"].toString());
                if (temp["ControlPosition"] === "Left") {
                  let refIndex = inputs.current["4A1"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["4A1"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["4A1"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                } else {
                  let refIndex = inputs.current["4A2"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["4A2"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["4A2"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                }
              }

              if (temp["ChainLength"]) {
                const chainLength = temp["ChainLength"].toString();
                const chainOption = getChainLengthOption(chainLength);
                setStep4B(chainLength);
                setChainLengthId(chainOption?.chainId ?? null);
                const inputEl = chainOption ? inputs.current[chainOption.id] : null;
                const refIndex = "4B";
                tempLabels[refIndex] = inputEl
                  ? inputEl.getAttribute("text")
                  : t(`${chainLength}cm`);
                tempValue[refIndex] = inputEl ? inputEl.value : chainOption?.value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
              }
            } else {
              let refIndex = inputs.current["42"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["42"].getAttribute("text");
              tempValue[refIndex] = inputs.current["42"].value;

              depSetTempArr = new Set([
                ...setGetDeps(
                  temp["hasPower"]
                    ? (temp["MotorType"] ? "" : "411,") +
                        (temp["MotorPosition"] ? "" : "412,") +
                        (temp["RemoteName"] && temp["RemoteName"] !== "" ? "" : "413,")
                    : "41,",
                  "4",
                  depSetTempArr
                ),
              ]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              if (temp["hasPower"] !== undefined) {
                setStep41(temp["hasPower"].toString());

                setTimeout(() => {
                  let refIndex = inputs.current["411"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["411"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["411"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);

              

                  setSelectedMotorPosition(
                    temp["MotorPosition"]
                      ? [
                          {
                            value: temp["MotorPosition"],
                            label: MotorPosition[pageLanguage].find(
                              (opt) => opt.value === temp["MotorPosition"]
                            ).label,
                          },
                        ]
                      : []
                  );
                  setRemoteName(temp["RemoteName"] ? temp["RemoteName"] : "");
                  setSelectedRemoteName(
                    temp["RemoteName"] && temp["RemoteName"] !== ""
                      ? [{ value: temp["RemoteName"], label: temp["RemoteName"] }]
                      : []
                  );
                  setSelectedMotorChannels(
                    temp["MotorChannels"]
                      ? temp["MotorChannels"].map((item) => ({
                          value: item,
                          label: motorChannels[pageLanguage].find((opt) => opt.value === item)
                            .label,
                        }))
                      : []
                  );
                }, 200);
              }
            }
          }

          if (temp["Mount"] !== "HiddenMoulding") {
            if (temp["Headrail"]) {
              setStep5(temp["Headrail"]);

              if (temp["Headrail"] === "MetalValance") {
                setHeadrailsNextStep("5A");
                let refIndex = inputs.current["53"].getAttribute("ref-num");
                tempLabels[refIndex] =
                  inputs.current["53"].getAttribute("text") +
                  (temp["MetalValanceColor"] ? "/" + temp["MetalValanceColor"] : "");
                tempValue[refIndex] = inputs.current["53"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                setSelectedValanceColor1(
                  temp["MetalValanceColor"]
                    ? [
                        {
                          value: temp["MetalValanceColor"],
                          label: optionsMetalValance[pageLanguage].find(
                            (opt) => opt.value === temp["MetalValanceColor"]
                          ).label,
                        },
                      ]
                    : []
                );
                depSetTempArr = new Set([
                  ...setGetDeps(temp["MetalValanceColor"] ? "" : "51,", "5,5Arc", depSetTempArr),
                ]);
              } else if (temp["Headrail"] === "MetalValanceFabricInsert") {
                setHeadrailsNextStep("6");
                let refIndex = inputs.current["54"].getAttribute("ref-num");
                tempLabels[refIndex] =
                  inputs.current["54"].getAttribute("text") +
                  (temp["MetalValanceColor"] ? "/" + temp["MetalValanceColor"] : "");
                tempValue[refIndex] = inputs.current["54"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                setSelectedValanceColor2(
                  temp["MetalValanceColor"]
                    ? [
                        {
                          value: temp["MetalValanceColor"],
                          label: optionsMetalValance[pageLanguage].find(
                            (opt) => opt.value === temp["MetalValanceColor"]
                          ).label,
                        },
                      ]
                    : []
                );
                depSetTempArr = new Set([
                  ...setGetDeps(temp["MetalValanceColor"] ? "" : "51,", "5,5Arc", depSetTempArr),
                ]);
              } else if (temp["Headrail"] === "Upholstered") {
                setHeadrailsNextStep("6");
                let refIndex = inputs.current["52"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["52"].getAttribute("text");
                tempValue[refIndex] = inputs.current["52"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                depSetTempArr = new Set([...setGetDeps("", "5,5Arc", depSetTempArr)]);
              } else {
                setHeadrailsNextStep("6");
                let refIndex = inputs.current["51"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["51"].getAttribute("text");
                tempValue[refIndex] = inputs.current["51"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["RollType"] ? "" : "5A,") +
                      (temp["BracketType"] ? "" : "5B,") +
                      (temp["BracketColor"] ? "" : "5C,"),
                    "5,5Arc",
                    depSetTempArr
                  ),
                ]);

                setTimeout(() => {
                  if (temp["RollType"]) {
                    setStep5A(temp["RollType"]);
                    if (temp["RollType"] === "Standard") {
                      let refIndex = inputs.current["5A1"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5A1"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5A1"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5A", depSetTempArr)]);
                    } else {
                      let refIndex = inputs.current["5A2"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5A2"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5A2"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5A", depSetTempArr)]);
                    }
                  }
                  if (temp["BracketType"]) {
                    setStep5B(temp["BracketType"]);
                    if (temp["BracketType"] === "Round Edge") {
                      let refIndex = inputs.current["5B1"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5B1"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5B1"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5B", depSetTempArr)]);
                    } else {
                      let refIndex = inputs.current["5B2"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5B2"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5B2"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5B", depSetTempArr)]);
                    }
                  }
                  if (temp["BracketColor"]) {
                    setStep5C(temp["BracketColor"]);
                    if (temp["BracketColor"] === "Satin Brass") {
                      let refIndex = inputs.current["5C1"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5C1"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5C1"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5C", depSetTempArr)]);
                    } else if (temp["BracketColor"] === "Satin Nickel") {
                      let refIndex = inputs.current["5C2"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5C2"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5C2"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5C", depSetTempArr)]);
                    } else {
                      let refIndex = inputs.current["5C3"].getAttribute("ref-num");
                      tempLabels[refIndex] = inputs.current["5C3"].getAttribute("text");
                      tempValue[refIndex] = inputs.current["5C3"].value;
                      setStepSelectedLabel(tempLabels);
                      setStepSelectedValue(tempValue);
                      depSetTempArr = new Set([...setGetDeps("", "5C", depSetTempArr)]);
                    }
                  }
                }, 200);
              }
            }
          }

          if (temp["Mount"] === "HiddenMoulding") {
            setTimeout(() => {
              if (temp["RollType"]) {
                setStep5Arc(temp["RollType"]);

                if (temp["RollType"] === "Standard") {
                  let refIndex = inputs.current["5Arc1"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5Arc1"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5Arc1"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5,5Arc", depSetTempArr)]);
                } else {
                  let refIndex = inputs.current["5Arc2"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5Arc2"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5Arc2"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5,5Arc", depSetTempArr)]);
                }
              }

              if (temp["BracketType"]) {
                setStep5B(temp["BracketType"]);
                if (temp["BracketType"] === "Round Edge") {
                  let refIndex = inputs.current["5AArc1"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5AArc1"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5AArc1"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5B", depSetTempArr)]);
                } else {
                  let refIndex = inputs.current["5AArc2"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5AArc2"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5AArc2"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5AArc", depSetTempArr)]);
                }
              }
              if (temp["BracketColor"]) {
                setStep5AArc(temp["BracketColor"]);
                if (temp["BracketColor"] === "Satin Brass") {
                  let refIndex = inputs.current["5BArc1"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5BArc1"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5BArc1"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5BArc", depSetTempArr)]);
                } else if (temp["BracketColor"] === "Satin Nickel") {
                  let refIndex = inputs.current["5BArc2"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5BArc2"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5BArc2"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5BArc", depSetTempArr)]);
                } else {
                  let refIndex = inputs.current["5BArc3"].getAttribute("ref-num");
                  tempLabels[refIndex] = inputs.current["5BArc3"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["5BArc3"].value;
                  setStepSelectedLabel(tempLabels);
                  setStepSelectedValue(tempValue);
                  depSetTempArr = new Set([...setGetDeps("", "5BArc", depSetTempArr)]);
                }
              }
            }, 200);
          }

          if (temp["HemStyle"]) {
            setStep6(temp["HemStyle"]);

            if (temp["HemStyle"] === "Scallop") {
              let refIndex = inputs.current["62"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["62"].getAttribute("text");
              tempValue[refIndex] = inputs.current["62"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              depSetTempArr = new Set([...setGetDeps("", "6", depSetTempArr)]);
            } else if (temp["HemStyle"] === "Wave") {
              let refIndex = inputs.current["63"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["63"].getAttribute("text");
              tempValue[refIndex] = inputs.current["63"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              depSetTempArr = new Set([...setGetDeps("", "6", depSetTempArr)]);
            } else if (temp["HemStyle"] === "Traditional") {
              let refIndex = inputs.current["64"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["64"].getAttribute("text");
              tempValue[refIndex] = inputs.current["64"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              depSetTempArr = new Set([...setGetDeps("", "6", depSetTempArr)]);
            } else {
              let refIndex = inputs.current["61"].getAttribute("ref-num");
              tempLabels[refIndex] = inputs.current["61"].getAttribute("text");
              tempValue[refIndex] = inputs.current["61"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              depSetTempArr = new Set([
                ...setGetDeps(temp["RollType"] ? "" : "6A,", "6", depSetTempArr),
              ]);

              setTimeout(() => {
                if (temp["BottomBarStyle"]) {
                  setStep6A(temp["BottomBarStyle"]);
                  if (temp["BottomBarStyle"] === "Sewn-In") {
                    let refIndex = inputs.current["6A1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["6A1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["6A1"].value;
                    setStepSelectedLabel(tempLabels);
                    setStepSelectedValue(tempValue);
                    depSetTempArr = new Set([...setGetDeps("", "6A", depSetTempArr)]);
                  } else {
                    let refIndex = inputs.current["6A2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["6A2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["6A2"].value;
                    setStepSelectedLabel(tempLabels);
                    setStepSelectedValue(tempValue);
                    depSetTempArr = new Set([...setGetDeps("", "6A", depSetTempArr)]);
                  }
                }
              }, 200);
            }
          }

          if (temp["MetalValanceStyle"]) {
            setStep5(temp["MetalValanceStyle"]);

            if (temp["MetalValanceStyle"] === "MetalValance") {
              let refIndex = inputs.current["51"].getAttribute("ref-num");
              tempLabels[refIndex] =
                inputs.current["51"].getAttribute("text") +
                (temp["MetalValanceColor"]
                  ? "/" +
                    optionsMetalValance[pageLanguage].find(
                      (opt) => opt.value === temp["MetalValanceColor"]
                    ).label
                  : "");
              tempValue[refIndex] = inputs.current["51"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              setSelectedValanceColor1(
                temp["MetalValanceColor"]
                  ? [
                      {
                        value: temp["MetalValanceColor"],
                        label: optionsMetalValance[pageLanguage].find(
                          (opt) => opt.value === temp["MetalValanceColor"]
                        ).label,
                      },
                    ]
                  : []
              );
              depSetTempArr = new Set([
                ...setGetDeps(temp["MetalValanceColor"] ? "" : "51,", "5", depSetTempArr),
              ]);
            } else {
              let refIndex = inputs.current["52"].getAttribute("ref-num");
              tempLabels[refIndex] =
                inputs.current["52"].getAttribute("text") +
                (temp["MetalValanceColor"]
                  ? "/" +
                    optionsMetalValance[pageLanguage].find(
                      (opt) => opt.value === temp["MetalValanceColor"]
                    ).label
                  : "");
              tempValue[refIndex] = inputs.current["52"].value;
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
              setSelectedValanceColor2(
                temp["MetalValanceColor"]
                  ? [
                      {
                        value: temp["MetalValanceColor"],
                        label: optionsMetalValance[pageLanguage].find(
                          (opt) => opt.value === temp["MetalValanceColor"]
                        ).label,
                      },
                    ]
                  : []
              );
              depSetTempArr = new Set([
                ...setGetDeps(temp["MetalValanceColor"] ? "" : "51,", "5", depSetTempArr),
              ]);
            }
          }
          if (temp["RoomNameEn"]) {
            depSetTempArr = new Set([...setGetDeps("", "71", depSetTempArr)]);
            setSelectedRoomLabel(
              temp["RoomNameEn"]
                ? [
                    {
                      value: temp["RoomNameEn"],
                      label: rooms[pageLanguage].find((opt) => opt.value === temp["RoomNameEn"])
                        .label,
                    },
                  ]
                : []
            );
            tempSelect.label = rooms[pageLanguage].find(
              (opt) => opt.value === temp["RoomNameEn"]
            ).label;
            tempSelect.value = temp["RoomNameEn"];
            setRoomLabelSelect(tempSelect);
            if (
              temp["WindowName"] === undefined ||
              (temp["WindowName"] && temp["WindowName"] === "")
            ) {
              tempLabels["7"] = tempSelect.label;
            } else if (temp["WindowName"]) {
              tempLabels["7"] = tempSelect.label + " - " + temp["WindowName"];
            }
            setStepSelectedLabel(tempLabels);
          }
          if (temp["WindowName"] && temp["WindowName"] !== "") {
            depSetTempArr = new Set([...setGetDeps("", "72", depSetTempArr)]);
            setRoomLabelText(temp["WindowName"]);
          }

          if (
            temp["ZipCode"] &&
            temp["ZipCode"] !== "" &&
            temp["InstallAmount"] &&
            temp["InstallAmount"] > 0 &&
            temp["TransportationAmount"] &&
            temp["TransportationAmount"] > 0
          ) {
            setZipcode(temp["ZipCode"]);
            setZipcodeButton(true);
            setHasInstall(true);
            setZipcodeChecked("true");
            setInstallPrice(temp["InstallAmount"]);
            setTransportPrice(temp["TransportationAmount"]);
          } else if (temp["ZipCode"] && temp["ZipCode"] !== "") {
            setZipcode(temp["ZipCode"]);
            setZipcodeButton(true);
            setHasInstall(true);
            setZipcodeChecked("true");
          }

          if (temp["uploadedImagesURL"] && temp["uploadedImagesURL"].length > 0) {
            const { images, pdfs } = convertTempToFiles(temp);
            setUploadedImages(images);
            setUploadedPDFs(pdfs);
            sessionStorage.setItem("backup_uploadedImages", JSON.stringify(images));
            sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(pdfs));
            let tempArrayNames = [];
            let tempArray = [];

            let promise3 = new Promise((resolve, reject) => {
              temp["uploadedImagesFile"].forEach((obj, index) => {
                tempArrayNames[index] = (
                  <li className="uploaded_name_item" key={index}>
                    <i className="fa fa-file" />
                    <span className="uploaded_name_item_text">{obj.replace(/\.[^/.]+$/, "")}</span>
                    <span
                      className="uploaded_name_item_x"
                      onClick={() => {
                        setDeleteUploaded(temp["uploadedImagesURL"][index], index, 2);
                      }}
                    >
                      X
                    </span>
                  </li>
                );

                tempArray[index] = (
                  <li className="uploaded_image_item" key={index}>
                    <img
                      src={imgUrl(temp["uploadedImagesURL"][index])}
                      className="img-fluid"
                      alt=""
                    />
                  </li>
                );

                if (index === temp["uploadedImagesFile"].length - 1) {
                  resolve();
                }
              });
            });

            promise3.then(() => {
              setUploadedImagesNamesList(tempArrayNames);
              setUploadedImagesList(tempArray);
            });
          }
          if (temp["uploadedPDFURL"] && temp["uploadedPDFURL"].length > 0) {
            setUploadedPDFURL(temp["uploadedPDFURL"]);
            setUploadedPDFFile(temp["uploadedPDFFile"]);
            let tempArrayNames = [];

            let promise3 = new Promise((resolve, reject) => {
              temp["uploadedPDFFile"].forEach((obj, index) => {
                tempArrayNames[index] = (
                  <li className="uploaded_name_item" key={index}>
                    <i className="fa fa-file" />
                    <span className="uploaded_name_item_text">{obj.replace(/\.[^/.]+$/, "")}</span>
                    <span
                      className="uploaded_name_item_x"
                      onClick={() => {
                        setDeleteUploaded(temp["uploadedPDFURL"][index], index, 1);
                      }}
                    >
                      X
                    </span>
                  </li>
                );
                if (index === temp["uploadedPDFFile"].length - 1) {
                  resolve();
                }
              });
            });

            promise3.then(() => {
              setUploadedPDFNameList(tempArrayNames);
            });
          }

          setTimeout(() => {
            setDepSet(depSetTempArr);
            setSelectCustomValues(selectValues);
            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            setPageLoad(false);
          }, persianTimeout);
        });
    });
  }

  function filterSelected(filter, filterId, isDelete) {
    if (filter === "colors") {
      if (!filterColors.includes(filterId)) {
        setFilterColors([...filterColors, filterId]);
      } else {
        setFilterColors(filterColors.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "patterns") {
      if (!filterPatterns.includes(filterId)) {
        setFilterPatterns([...filterPatterns, filterId]);
      } else {
        setFilterPatterns(filterPatterns.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "types") {
      if (!filterTypes.includes(filterId)) {
        setFilterTypes([...filterTypes, filterId]);
      } else {
        setFilterTypes(filterTypes.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "prices") {
      if (!filterPrices.includes(filterId)) {
        setFilterPrices([...filterPrices, filterId]);
      } else {
        setFilterPrices(filterPrices.filter((id1) => id1 !== filterId));
      }
    }
  }

  const addFailedFileToParent = (fileItem, errorMessage, errorType = "server") => {
    const failedFileObj = {
      id: fileItem.id,
      name: fileItem.name,
      size: fileItem.size,
      type: fileItem.file.type,
      status: "error",
      errorMessage: errorMessage,
      errorType: errorType,
      url: null,
      uploadedAt: new Date(),
    };

    if (fileItem.file.type === "application/pdf") {
      setUploadedPDFs((prev) => [...prev, failedFileObj]);
    } else {
      setUploadedImages((prev) => [...prev, failedFileObj]);
    }
  };

  const optionsMetalValance = {
    en: [
      { value: "White", label: "White" },
      { value: "Silver", label: "Silver" },
      { value: "Black", label: "Black" },
    ],
    fa: [
      { value: "White", label: "سفید" },
      { value: "Silver", label: "نقره\u200Cای" },
      { value: "Black", label: "مشکی" },
    ],
  };

  const optionsMetalValanceFabricInsert = {
    en: [
      { value: "White", label: "White" },
      { value: "Silver", label: "Silver" },
      { value: "Black", label: "Black" },
    ],
    fa: [
      { value: "White", label: "سفید" },
      { value: "Silver", label: "نقره\u200Cای" },
      { value: "Black", label: "مشکی" },
    ],
  };

  const [MotorType, setMotorType] = useState({
    en: [{ value: "Standard", label: "Standard" }, { value: "Smart", label: "Smart" }],
    fa: [{ value: "Standard", label: "استاندارد" }, { value: "Smart", label: "هوشمند" }],
  });

  const optionsOutside = {
    en: [{ value: "Wall", label: "Wall" }, { value: "Ceiling", label: "Ceiling" }],
    fa: [{ value: "Wall", label: "نصب به دیوار" }, { value: "Ceiling", label: "نصب به سقف" }],
  };

  useEffect(() => {
    if (pageLoad || cartValues?.Mount !== "Outside" || !cartValues?.IsWalled) {
      return;
    }
    const isWalledValue =
      cartValues["IsWalled"] === true || cartValues["IsWalled"] === "true"
        ? "Wall"
        : cartValues["IsWalled"] === false || cartValues["IsWalled"] === "false"
          ? "Ceiling"
          : cartValues["IsWalled"];
    const isWalledOption = optionsOutside[pageLanguage]?.find(
      (opt) => opt.value === isWalledValue
    );
    if (!isWalledOption) {
      return;
    }
    // if (
    //   selectedMountOutsideType.length === 0 ||
    //   selectedMountOutsideType[0]?.value !== isWalledValue
    // ) {
    //   setSelectedMountOutsideType([
    //     { value: isWalledValue, label: isWalledOption.label },
    //   ]);
    // }
    if (step2 !== "Outside") {
      setStep2("Outside");
    }
    const expectedLabel = t("mount_Outside") + "/" + isWalledOption.label;
    if (stepSelectedLabel["2"] !== expectedLabel) {
      setStepSelectedLabel((prev) => ({ ...prev, 2: expectedLabel }));
    }
  }, [pageLoad, cartValues?.Mount, cartValues?.IsWalled, pageLanguage]);

  useEffect(() => {
    if (pageLoad || step4 !== "Continuous Loop" || !cartValues?.ChainLength) {
      return;
    }
    const chainLength = cartValues.ChainLength.toString();
    const chainOption = getChainLengthOption(chainLength);
    if (!chainOption) {
      return;
    }
    if (step4B !== chainLength) {
      setStep4B(chainLength);
    }
    setChainLengthId(chainOption.chainId ?? null);
    const inputEl = inputs.current[chainOption.id];
    const expectedLabel = inputEl?.getAttribute("text") || t(`${chainLength}cm`);
    if (stepSelectedLabel["4B"] !== expectedLabel) {
      setStepSelectedLabel((prev) => ({ ...prev, ["4B"]: expectedLabel }));
      if (inputEl) {
        setStepSelectedValue((prev) => ({ ...prev, ["4B"]: inputEl.value }));
      }
    }
  }, [pageLoad, cartValues?.ChainLength, step4, pageLanguage]);

  useEffect(() => {
    if (Object.keys(modelAccessories).length > 0 && widthCart && heightCart && fabricQty > 0) {
      // let qty=widthCart*heightCart/10000;
      let qty = fabricQty;
      let tempObj = {
        en: [
          {
            value: "Standard",
            label:
              modelAccessories["17"] &&
              modelAccessories["17"]["1"] &&
              qty > modelAccessories["17"]["1"]["FromQty"] &&
              qty <= modelAccessories["17"]["1"]["ToQty"]
                ? "Standard (" +
                  GetPrice(
                    modelAccessories["17"]["1"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : modelAccessories["17"] &&
                  modelAccessories["17"]["14"] &&
                  qty > modelAccessories["17"]["14"]["FromQty"] &&
                  qty <= modelAccessories["17"]["14"]["ToQty"]
                ? "Standard (" +
                  GetPrice(
                    modelAccessories["17"]["14"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : "",
            apiAccValue:
              modelAccessories["17"] &&
              modelAccessories["17"]["1"] &&
              qty > modelAccessories["17"]["1"]["FromQty"] &&
              qty <= modelAccessories["17"]["1"]["ToQty"]
                ? {
                    SewingAccessoryId: 17,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500508",
                    Qty: 1,
                  }
                : modelAccessories["17"] &&
                  modelAccessories["17"]["14"] &&
                  qty > modelAccessories["17"]["14"]["FromQty"] &&
                  qty <= modelAccessories["17"]["14"]["ToQty"]
                ? {
                    SewingAccessoryId: 17,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500507",
                    Qty: 1,
                  }
                : "",
          },
          {
            value: "Smart",
            label:
              modelAccessories["18"] &&
              modelAccessories["18"]["15"] &&
              qty > modelAccessories["18"]["15"]["FromQty"] &&
              qty <= modelAccessories["18"]["15"]["ToQty"]
                ? "Smart (" +
                  GetPrice(
                    modelAccessories["18"]["15"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : modelAccessories["18"] &&
                  modelAccessories["18"]["16"] &&
                  qty > modelAccessories["18"]["16"]["FromQty"] &&
                  qty <= modelAccessories["18"]["16"]["ToQty"]
                ? "Smart (" +
                  GetPrice(
                    modelAccessories["18"]["16"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : "",
            apiAccValue:
              modelAccessories["18"] &&
              modelAccessories["18"]["15"] &&
              qty > modelAccessories["18"]["15"]["FromQty"] &&
              qty <= modelAccessories["18"]["15"]["ToQty"]
                ? {
                    SewingAccessoryId: 18,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500518",
                    Qty: 1,
                  }
                : modelAccessories["18"] &&
                  modelAccessories["18"]["16"] &&
                  qty > modelAccessories["18"]["16"]["FromQty"] &&
                  qty <= modelAccessories["18"]["16"]["ToQty"]
                ? {
                    SewingAccessoryId: 18,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500517",
                    Qty: 1,
                  }
                : "",
          },
        ],
        fa: [
          {
            value: "Standard",
            label:
              modelAccessories["17"] &&
              modelAccessories["17"]["1"] &&
              qty > modelAccessories["17"]["1"]["FromQty"] &&
              qty <= modelAccessories["17"]["1"]["ToQty"]
                ? "استاندارد (" +
                  GetPrice(
                    modelAccessories["17"]["1"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : modelAccessories["17"] &&
                  modelAccessories["17"]["14"] &&
                  qty > modelAccessories["17"]["14"]["FromQty"] &&
                  qty <= modelAccessories["17"]["14"]["ToQty"]
                ? "استاندارد (" +
                  GetPrice(
                    modelAccessories["17"]["14"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : "",
            apiAccValue:
              modelAccessories["17"] &&
              modelAccessories["17"]["1"] &&
              qty > modelAccessories["17"]["1"]["FromQty"] &&
              qty <= modelAccessories["17"]["1"]["ToQty"]
                ? {
                    SewingAccessoryId: 17,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500508",
                    Qty: 1,
                  }
                : modelAccessories["17"] &&
                  modelAccessories["17"]["14"] &&
                  qty > modelAccessories["17"]["14"]["FromQty"] &&
                  qty <= modelAccessories["17"]["14"]["ToQty"]
                ? {
                    SewingAccessoryId: 17,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500507",
                    Qty: 1,
                  }
                : "",
          },
          {
            value: "Smart",
            label:
              modelAccessories["18"] &&
              modelAccessories["18"]["15"] &&
              qty > modelAccessories["18"]["15"]["FromQty"] &&
              qty <= modelAccessories["18"]["15"]["ToQty"]
                ? "هوشمند (" +
                  GetPrice(
                    modelAccessories["18"]["15"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : modelAccessories["18"] &&
                  modelAccessories["18"]["16"] &&
                  qty > modelAccessories["18"]["16"]["FromQty"] &&
                  qty <= modelAccessories["18"]["16"]["ToQty"]
                ? "هوشمند (" +
                  GetPrice(
                    modelAccessories["18"]["16"]["Price"],
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  ) +
                  ")"
                : "",
            apiAccValue:
              modelAccessories["18"] &&
              modelAccessories["18"]["15"] &&
              qty > modelAccessories["18"]["15"]["FromQty"] &&
              qty <= modelAccessories["18"]["15"]["ToQty"]
                ? {
                    SewingAccessoryId: 18,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500518",
                    Qty: 1,
                  }
                : modelAccessories["18"] &&
                  modelAccessories["18"]["16"] &&
                  qty > modelAccessories["18"]["16"]["FromQty"] &&
                  qty <= modelAccessories["18"]["16"]["ToQty"]
                ? {
                    SewingAccessoryId: 18,
                    SewingModelAccessoryId: 0,
                    SewingAccessoryValue: "61500517",
                    Qty: 1,
                  }
                : "",
          },
        ],
      };
      let tempStandardPrice =
        modelAccessories["17"] &&
        modelAccessories["17"]["1"] &&
        qty > modelAccessories["17"]["1"]["FromQty"] &&
        qty <= modelAccessories["17"]["1"]["ToQty"]
          ? modelAccessories["17"]["1"]["Price"]
          : modelAccessories["17"] &&
            modelAccessories["17"]["14"] &&
            qty > modelAccessories["17"]["14"]["FromQty"] &&
            qty <= modelAccessories["17"]["14"]["ToQty"]
          ? modelAccessories["17"]["14"]["Price"]
          : 0;
      let tempSmartPrice =
        modelAccessories["18"] &&
        modelAccessories["18"]["15"] &&
        qty > modelAccessories["18"]["15"]["FromQty"] &&
        qty <= modelAccessories["18"]["15"]["ToQty"]
          ? modelAccessories["18"]["15"]["Price"]
          : modelAccessories["18"] &&
            modelAccessories["18"]["16"] &&
            qty > modelAccessories["18"]["16"]["FromQty"] &&
            qty <= modelAccessories["18"]["16"]["ToQty"]
          ? modelAccessories["18"]["16"]["Price"]
          : 0;
      setMotorType(tempObj);
      // console.log(tempObj);
      if (selectedMotorType.length) {
        if (!motorLoad2) {
          setMotorLoad2(true);
        }
        if (Object.keys(customMotorAcc).length === 0) {
          let newObj =
            tempObj[pageLanguage].find((opt) => opt.value === selectedMotorType[0].value)[
              "apiAccValue"
            ] || {};
          setCustomMotorAcc(newObj);
          setCart("MotorType", selectedMotorType[0].value, undefined, undefined, undefined, newObj);
        }
        setSelectedMotorType(
          selectedMotorType[0].value
            ? [
                {
                  value: selectedMotorType[0].value,
                  label: tempObj[pageLanguage].find(
                    (opt) => opt.value === selectedMotorType[0].value
                  ).label,
                },
              ]
            : []
        );
        // if (motorLoad) {
        //     setTimeout(() => {
        //         setMotorLoad(false);
        //     }, 500);
        // }
      }
      setSelectedMotorMinPrice(Math.min(tempStandardPrice, tempSmartPrice));
      // setCart("", "", "MotorType");
      // if (stepSelectedValue["41"] === "1" && stepSelectedValue["4"] === "2") {
      //     setDeps("411", "");
      // }
    }
  }, [widthCart, heightCart, JSON.stringify(modelAccessories), fabricQty]);

  useEffect(() => {
    if (selectedMotorType.length) {
      if (motorLoad) {
        setTimeout(() => {
          setMotorLoad(false);
        }, 100);
      }
    }
  }, [selectedMotorType]);

  const MotorPosition = {
    en: [{ value: "Left", label: "Left" }, { value: "Right", label: "Right" }],
    fa: [{ value: "Left", label: "چپ" }, { value: "Right", label: "راست" }],
  };
  

  useEffect(() => {
    if (!pageLoad && !mesLoad) {
      if (step6 !== "" || step5 !== "") {
        setStep5("");
        setSelectedValanceColor1([]);
        setSelectedValanceColor2([]);
        setStep5Arc("");
        setStep5AArc("");
        setStep5BArc("");
        setStep6("");
        setStep6A("");
        if (step2 === "HiddenMoulding") {
          setDeps("5Arc,5AArc,5BArc,6", "6A,5,51,5A,5B,5C");
        } else {
          setDeps("5,6", "6A,5Arc,5AArc,5BArc,51,5A,5B,5C");
        }
        setCart(
          "",
          "",
          "Headrail,MetalValanceColor,RollType,BracketType,BracketColor,HemStyle,BottomBarStyle"
        );
        selectChanged(undefined, "5,5Arc,5AArc,5BArc,51,5A,5B,5C,6,6A");
        setHemStyleNextStep("7");
      }
    }
    if (mesLoad) {
      setMesLoad(false);
    }
  }, [widthCart]);

  useEffect(() => {
    if (fabricSelected.selectedFabricId && fabricSelected.selectedFabricId !== 0) {
      fabricClicked(fabricSelected.selectedPhoto, fabricSelected.selectedHasTrim);
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["1"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? fabricSelected.selectedTextFa + "/" + fabricSelected.selectedColorFa
          : fabricSelected.selectedTextEn + "/" + fabricSelected.selectedColorEn;
      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue["1"] = fabricSelected.selectedFabricId;
      setStepSelectedLabel(tempLabels);
      setStepSelectedValue(tempValue);
      // setCart("FabricId", fabricSelected.selectedFabricId);
      setCart(
        "FabricId",
        `${fabricSelected.selectedFabricId}`,
        "",
        "FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl",
        [
          fabricSelected.selectedTextFa,
          fabricSelected.selectedTextEn,
          fabricSelected.selectedColorEn,
          fabricSelected.selectedColorFa,
          fabricSelected.selectedPhoto,
        ]
      );
      // setCart("PhotoUrl", fabricSelected.selectedPhoto);
      setDeps("", "1");
      setStep1(fabricSelected.selectedFabricId.toString());
      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["1"] !== "" && requiredStep["1"]) {
        temp["1"] = false;
      }
      setRequiredStep(temp);
    }
  }, [fabricSelected]);

  useEffect(() => {
    if (!firstRender.current) {
      // getCart().then((temp) => {
      if (Object.keys(fabrics).length) {
        setTimeout(() => {
          renderFabrics(bag);
        }, 100);
      } else {
        setFabricsList([]);
      }
    }
  }, [step1]);

  useEffect(() => {
    if (
      (width3A && left && right && !(width3A < 30 || width3A > 280)) ||
      left < 1 ||
      left > 1000 ||
      right < 1 ||
      right > 1000
    ) {
      if (+width3A + +left + +right > 280) {
        clearInputs(undefined, "left", "right", "WidthDif");
        setLeft(undefined);
        setRight(undefined);

        modalHandleShow("moreThan280");
      }
    }
  }, [left, right]);

  useEffect(() => {
    if (
      (width3A && left && right && !(width3A < 30 || width3A > 280)) ||
      left < 1 ||
      left > 1000 ||
      right < 1 ||
      right > 1000
    ) {
      if (+width3A + +left + +right > 280) {
        isClearingLeftRight.current = true;
        shouldKeep3BOutCleared.current = true;
        modalHandleShow("moreThan280");
        setLeft(undefined);
        setRight(undefined);
        setLeftRight({ left: "", right: "" });
        setCart(undefined, undefined, "ExtensionLeft,ExtensionRight");
        setDeps("3BOut1,3BOut2", "");

        setStepSelectedLabel((prev) => {
          const newLabels = { ...prev };
          delete newLabels["3BOut1"];
          delete newLabels["3BOut2"];
          delete newLabels["3BOut"];

          return newLabels;
        });
        // بعد از پاک کردن، flag را reset کن
        setTimeout(() => {
          isClearingLeftRight.current = false;
        }, 100);
      }
    }
  }, [width3A]);

  useEffect(() => {
    if (width3A && left !== undefined && right !== undefined) {
      const total = +width3A + +left + +right;
      if (total <= 281 && shouldKeep3BOutCleared.current) {
        shouldKeep3BOutCleared.current = false;
      }
    }
  }, [width3A, left, right]);

  useEffect(() => {
    // console.log("hi2");
    if (swatchLogin) {
      setSwatchLogin(false);
      modalHandleClose("side_login_modal");
      setTimeout(() => {
        fabricSwatch("0", swatchLoginSwatchId, swatchLoginSwatchDetailId);
      }, 500);
    } else if ((projectModalState === 2 && isLoggedIn) || (saveProjectCount !== 0 && isLoggedIn)) {
      if (roomLabelText !== "" && selectedRoomLabel.length) {
        if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            projectData,
            customMotorAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                console.log("project not saved!");
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              console.log(err);
              // console.log("hi6");
              setProjectModalState(2);
              setSavingLoading(false);
            });
        } else {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            undefined,
            customMotorAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                console.log("project not saved!");
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              // console.log("hi5",err);
              setProjectModalState(2);
              setSavingLoading(false);
            });
        }
      } else {
        setProjectModalState(0);
        modalHandleShow("add_to_project_modal");
      }
    }
  }, [isLoggedIn, saveProjectCount]);

  useEffect(() => {
    if (+height3C + +mount + 15 > 400) {
      setMount(undefined);
      modalHandleShow("moreThan400");
    }
  }, [mount, height3C]);

  useEffect(() => {
    if (deleteUploadImageIndex !== -1) {
      if (deleteUploadImageUrl !== "") {
        deleteUploadedImg(
          uploadedImagesList,
          uploadedImagesNamesList,
          deleteUploadImageUrl,
          deleteUploadImageIndex
        );
      }
    }
  }, [deleteUploadImageUrl]);

  useEffect(() => {
    if (deleteUploadPdfIndex !== -1) {
      if (deleteUploadPdfUrl !== "") {
        deleteUploadedPdf(uploadedPDFNameList, deleteUploadPdfUrl, deleteUploadPdfIndex);
      }
    }
  }, [deleteUploadPdfUrl]);

  useEffect(() => {
    // console.log(Object.keys(model).length !== 0 , widthCart !== undefined);
    if (Object.keys(model).length !== 0 && widthCart !== undefined) {
      let tempObj = {};
      model["Accessories"].forEach((obj) => {
        let tempObj2 = {};
        obj["SewingAccessoryDetails"].forEach((el) => {
          tempObj2[el["SewingAccessoryDetailId"]] = JSON.parse(JSON.stringify(el));
          tempObj2[el["SewingAccessoryDetailId"]]["Price"] =
            obj["CalcMethodId"] === 5602 ? (el["Price"] * widthCart) / 100 : el["Price"];
        });
        tempObj[obj["SewingAccessoryId"]] = tempObj2;
      });
      setModelAccessories(tempObj);
     
    } else {
      setModelAccessories({});
    }
  }, [model, widthCart]);

  useEffect(() => {
    if (!pageLoad && !motorLoad) {
      setCart(undefined, undefined);
    }
  }, [pageLoad, motorLoad, motorLoad2]);

  useEffect(() => {
    if (modelID !== "" && catID !== "") {
      getModel();
    }
  }, [modelID, catID]);

  useEffect(() => {
    if (pageItem) {
      setDefaultFabricPhoto(pageItem["MainImageUrl"]);
      if (pageType) {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageType,PageId", [pageType, pageId]);
      } else {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageId", [pageId]);
      }
      setDefaultModelName(pageItem["EnTitle"]);
      setDefaultModelNameFa(pageItem["Title"]);
      setDefaultModelDesc(pageItem["DescriptionEn"]);
      setDefaultModelDescFa(pageItem["Description"]);
    }
  }, [pageItem]);

  async function setLang() {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }

  function getRemoteNames() {
    if (isLoggedIn) {
      axios
        .get(baseURLGetRemoteNames, {
          headers: authHeader(),
        })
        .then((response) => {
          let tempArr = [];
          response.data.forEach((el) => {
            tempArr.push({
              value: el,
              label: el,
            });
          });
          tempArr.push({
            value: "addNewRemoteName",
            label: t("Add New Remote"),
          });
          setRemoteNames(tempArr);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                getRemoteNames();
              } else {
                setRemoteNames([]);
              }
            });
          } else {
            setRemoteNames([]);
          }
        });
    } else {
      if (Object.keys(bag).length > 0 && bag["drapery"] !== undefined) {
        let tempArr = bag["drapery"]
          .map((obj, index) => {
            if (
              obj["PreorderText"] &&
              obj["PreorderText"]["RemoteName"] &&
              obj["PreorderText"]["SewingModelId"] === modelID
            ) {
              return {
                value: obj["PreorderText"]["RemoteName"],
                label: obj["PreorderText"]["RemoteName"],
              };
            } else {
              return null;
            }
          })
          .filter((n) => n)
          .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);
        tempArr.push({
          value: "addNewRemoteName",
          label: t("Add New Remote"),
        });
        // console.log(tempArr);
        setRemoteNames(tempArr);
      } else {
        setRemoteNames([]);
      }
    }
  }

  const getHasZipcode = createGetHasZipcode({
    isLoggedIn,
    setHasZipcode,
    setZipcode,
    setZipcodeButton,
    setHasInstall,
  });

  const getCart = createGetCart({
    isLoggedIn,
    cartChanged,
    setBag,
    setCartChanged,
  });

  useEffect(() => {
    if (cartUpdated) {
      setBagUpdate(true);
      setBag(mainCart || {});
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && cartStateAgree && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, cartStateAgree, isLoggedIn]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(fabrics).length) {
          if (!firstRender.current) {
            getCart()
              .then((temp) => {
                // getHasZipcode();
                setTimeout(() => {
                  renderFabrics(temp);
                  getRemoteNames();
                }, 100);
              })
              .catch(() => {
                // getHasZipcode();
                setTimeout(() => {
                  renderFabrics({});
                  getRemoteNames();
                }, 100);
              });
          }
        } else {
          let pageLanguage1 = location.pathname
            .split("")
            .slice(1, 3)
            .join("");
          // setFabricsList([
          //   <div
          //     className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          //     key={"fabric" + "empty"}
          //   >
          //     <div
          //       className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          //     >
          //       <h5 className="empty_fabrics">
          //         {pageLanguage1 === "en"
          //           ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
          //           : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
          //       </h5>
          //       <button
          //         className="empty_fabrics_btn white_btn btn"
          //         onClick={() => {
          //           setFabricsList([
          //             <div
          //               className={`material_detail ${
          //                 pageLanguage1 === "fa" ? "font_farsi" : "font_en"
          //               }`}
          //               key={"fabric" + "empty"}
          //             >
          //               <div
          //                 className={`material_traits ${
          //                   pageLanguage1 === "fa" ? "font_farsi" : "font_en"
          //                 }`}
          //               >
          //                 <h5 className="empty_fabrics">
          //                   {pageLanguage1 === "en"
          //                     ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
          //                     : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
          //                 </h5>
          //                 <button className="empty_fabrics_btn white_btn btn">
          //                   {pageLanguage1 === "fa" ? "در حال پاک کردن" : "CLEARING"}
          //                 </button>
          //               </div>
          //             </div>,
          //           ]);
          //           setTimeout(() => {
          //             setIsClearAll(true);
          //           }, 300);
          //         }}
          //       >
          //         {pageLanguage1 === "fa" ? "همه فیلترها را پاک کنید" : "CLEAR ALL FILTERS"}
          //       </button>
          //     </div>
          //   </div>,
          // ]);
        }
      }
    });
  }, [fabrics, cartChanged, isLoggedIn, location.pathname]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (bagUpdate) {
        setBagUpdate(false);
      } else {
        dispatch({
          type: CartUpdatedTrue,
          payload: { mainCart: bag },
        });
      }
      if (isLoggedIn) {
        setCartCount(bag["CartDetails"]?.length || 0);
      } else {
        setCartCount(bag["drapery"]?.length || 0);
      }
    }
  }, [bag]);

  useEffect(() => {
    if (filterChanged["filter"] !== 0) {
      filterSelected(
        filterChanged["filter"],
        filterChanged["filter_id"],
        filterChanged["isDelete"]
      );

      setFilterChanged({
        filter: 0,
        filter_id: undefined,
        isDelete: false,
      });
    }
  }, [filterChanged]);

  useEffect(() => {
    if (!isClearAll) {
      const shouldSendRequest = searchText.trim() === "" || searchText.trim().length >= 2;

      if (shouldSendRequest) {
        const timer = setTimeout(() => {
          getFabricsWithFilter();
        }, 1200);

        return () => clearTimeout(timer);
      }
    }
  }, [filterColors, filterPatterns, filterTypes, filterPrices, searchText]);

  useEffect(() => {
    if (pageLanguage !== "") {
      // setSelectedMotorChannels([motorChannels[pageLanguage].find(opt => opt.value === '0')]);
      GetSewingFilters(1, `${modelID}`).then((temp) => {
        setInitFilterColors(temp);
      });
      GetSewingFilters(2, `${modelID}`).then((temp) => {
        setInitFilterPatterns(temp);
      });
      GetSewingFilters(7, `${modelID}`).then((temp) => {
        setInitFilterTypes(temp);
      });
      GetSewingFilters(4, `${modelID}`).then((temp) => {
        setInitFilterPrices(temp);
      });
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    let tempLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let pageLanguage = tempLang;
    if (
      Object.keys(initFilterColors).length &&
      Object.keys(initFilterPatterns).length &&
      Object.keys(initFilterTypes).length &&
      Object.keys(initFilterPrices).length
    ) {
      if (initFilterColors[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterColors));
        setSewingColors(
          temp[tempLang].map((obj, index) => (
            <Dropdown.Item as={Button} key={index}>
              <label className="dropdown_label">
                <input
                  type="checkbox"
                  filter-id={obj.value}
                  ref={(ref) =>
                    (filterCheckboxes.current["colors"] = [
                      ...filterCheckboxes.current["colors"],
                      ref,
                    ])
                  }
                  onChange={(e) => {
                    setFilterChanged({
                      filter: "colors",
                      filter_id: e.target.getAttribute("filter-id"),
                      isDelete: e.target.checked,
                    });
                  }}
                  id={"dropdown_color" + obj.value + index}
                />
                <label htmlFor={"dropdown_color" + obj.value + index} className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                {convertToPersian(obj.label, pageLanguage)}
              </label>
            </Dropdown.Item>
          ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["colors"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingColors2(tempArr);
        });
      }
      if (initFilterPatterns[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPatterns));
        setSewingPatterns(
          temp[tempLang].map((obj, index) => (
            <Dropdown.Item as={Button} key={index}>
              <label className="dropdown_label">
                <input
                  type="checkbox"
                  filter-id={obj.value}
                  ref={(ref) =>
                    (filterCheckboxes.current["patterns"] = [
                      ...filterCheckboxes.current["patterns"],
                      ref,
                    ])
                  }
                  onChange={(e) => {
                    setFilterChanged({
                      filter: "patterns",
                      filter_id: e.target.getAttribute("filter-id"),
                      isDelete: e.target.checked,
                    });
                  }}
                  id={"dropdown_pattern" + obj.value + index}
                />
                <label htmlFor={"dropdown_pattern" + obj.value + index} className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                {convertToPersian(obj.label, pageLanguage)}
              </label>
            </Dropdown.Item>
          ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["patterns"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPatterns2(tempArr);
        });
      }
      if (initFilterTypes[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterTypes));
        setSewingTypes(
          temp[tempLang].map((obj, index) => (
            <Dropdown.Item as={Button} key={index}>
              <label className="dropdown_label">
                <input
                  type="checkbox"
                  filter-id={obj.value}
                  ref={(ref) =>
                    (filterCheckboxes.current["types"] = [
                      ...filterCheckboxes.current["types"],
                      ref,
                    ])
                  }
                  onChange={(e) => {
                    setFilterChanged({
                      filter: "types",
                      filter_id: e.target.getAttribute("filter-id"),
                      isDelete: e.target.checked,
                    });
                  }}
                  id={"dropdown_type" + obj.value + index}
                />
                <label htmlFor={"dropdown_type" + obj.value + index} className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                {convertToPersian(obj.label, pageLanguage)}
              </label>
            </Dropdown.Item>
          ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["types"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingTypes2(tempArr);
        });
      }
      if (initFilterPrices[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPrices));
        setSewingPrices(
          temp[tempLang].map((obj, index) => (
            <Dropdown.Item as={Button} key={index}>
              <label className="dropdown_label">
                <input
                  type="checkbox"
                  filter-id={obj.value}
                  ref={(ref) =>
                    (filterCheckboxes.current["prices"] = [
                      ...filterCheckboxes.current["prices"],
                      ref,
                    ])
                  }
                  onChange={(e) => {
                    setFilterChanged({
                      filter: "prices",
                      filter_id: e.target.getAttribute("filter-id"),
                      isDelete: e.target.checked,
                    });
                  }}
                  id={"dropdown_price" + obj.value + index}
                />
                <label htmlFor={"dropdown_price" + obj.value + index} className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                {convertToPersian(obj.label, pageLanguage)}
              </label>
            </Dropdown.Item>
          ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["prices"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPrices2(tempArr);
        });
      }
    }
  }, [
    initFilterColors,
    initFilterPatterns,
    initFilterTypes,
    initFilterPrices,
    showMoreFilter,
    filterColors,
    filterPatterns,
    filterTypes,
    filterPrices,
  ]);

  useEffect(() => {
    if (showMoreFilterTrigger !== undefined) {
      let temp = JSON.parse(JSON.stringify(showMoreFilter));
      temp[showMoreFilterTrigger] = !temp[showMoreFilterTrigger];
      setShowMoreFilter(temp);
      setShowMoreFilterTrigger(undefined);
    }
  }, [showMoreFilterTrigger]);

  useEffect(() => {
    if (Object.keys(cartValues).length !== 0) {
      cartValues["SewingModelId"] = `${modelID}`;
      sessionStorage.setItem("cartValues", JSON.stringify(cartValues));
      if (editIndex) {
        sessionStorage.setItem("editIndex", JSON.stringify(editIndex));
      }
      if (projectId) {
        sessionStorage.setItem("projectId", JSON.stringify(projectId));
      }
    }
  }, [JSON.stringify(cartValues)]);

  useEffect(() => {
    getHasZipcode();
    if (
      sessionStorage.getItem("cartValues") !== null &&
      editIndex === undefined &&
      projectId === undefined
    ) {
      let tempCartValues = {};
      let tempEditIndex;
      let tempProjectId;
      if (sessionStorage.getItem("cartValues") !== null) {
        tempCartValues = JSON.parse(sessionStorage.getItem("cartValues"));
        if (Object.keys(tempCartValues).length !== 0) {
          if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
            setStepSelectedLabel({});
            setWindowSize("");
            setProjectDetails(tempCartValues, undefined, true);
          }
        }
      }
      if (sessionStorage.getItem("editIndex") !== null) {
        tempEditIndex = JSON.parse(
          sessionStorage.getItem("editIndex") &&
            sessionStorage.getItem("editIndex").toUpperCase() !== "UNDEFINED"
        );
        setEditIndex(tempEditIndex);
      }
      if (
        sessionStorage.getItem("projectId") !== null &&
        sessionStorage.getItem("projectId").toUpperCase() !== "UNDEFINED"
      ) {
        tempProjectId = JSON.parse(sessionStorage.getItem("projectId"));
        setProjectId(tempProjectId);
      }
      sessionStorage.removeItem("cartValues");
    }
  }, []);

  useEffect(() => {
    if (editIndex && editIndex !== "") {
      if (isLoggedIn) {
        getProjectDetail(editIndex);
      } else {
        if (localStorage.getItem("cart") !== null) {
          if (JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined) {
            setProjectDetails(
              JSON.parse(localStorage.getItem("cart"))["drapery"][editIndex],
              editIndex
            );
          } else {
            navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
          }
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      }
    } else if (projectId && projectId !== "") {
      getProjectDetail();
    } else if (sessionStorage.getItem("cartCopy") !== null) {
      let tempCartValues = JSON.parse(sessionStorage.getItem("cartCopy"));
      if (Object.keys(tempCartValues).length !== 0) {
        if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
          setStepSelectedLabel({});
          setWindowSize("");
          setProjectDetails(tempCartValues);
        }
      }
      sessionStorage.removeItem("cartCopy");
    } else if (Object.keys(cartValues).length !== 0) {
      setStepSelectedLabel({});
      setWindowSize("");
      setTimeout(() => {
        setProjectDetails(cartValues, undefined, true);
      }, 700);
    }
  }, [location.pathname]);

  const fixedDiv = useRef(null);
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (fixedDiv.current.offsetTop < window.pageYOffset + 92) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const allFilesSorted = [...uploadingFiles, ...uploadedImages, ...uploadedPDFs].sort(
    (a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt)
  );

  return (
    <div className={`Custom_model_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("")}
        dep-group="2"
        ref={(ref) => ["21"].forEach((dep) => (depDetails.current["2"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3"
        ref={(ref) => ["31", "32"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />

      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Width")}
        dep-group=""
        ref={(ref) => ["31"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Height")}
        dep-group=""
        ref={(ref) => ["32"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3AIn"
        ref={(ref) =>
          ["3AIn1", "3AIn2", "3AIn3"].forEach((dep) => (depDetails.current["3"][dep] = ref))
        }
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3BIn"
        ref={(ref) =>
          ["3BIn1", "3BIn2", "3BIn3"].forEach((dep) => (depDetails.current["3"][dep] = ref))
        }
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3BOut"
        ref={(ref) => ["3BOut1", "3BOut2"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3CArc"
        ref={(ref) =>
          ["3CArc1", "3CArc2", "3CArc3"].forEach((dep) => (depDetails.current["3"][dep] = ref))
        }
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("")}
        dep-group="4"
        ref={(ref) => ["41"].forEach((dep) => (depDetails.current["4"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_zebra_411")}
        dep-group=""
        ref={(ref) => ["411"].forEach((dep) => (depDetails.current["4"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_zebra_412")}
        dep-group=""
        ref={(ref) => ["412"].forEach((dep) => (depDetails.current["4"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_zebra_413")}
        dep-group=""
        ref={(ref) => ["413"].forEach((dep) => (depDetails.current["4"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("Channel(s)")}
        dep-group=""
        ref={(ref) => ["414"].forEach((dep) => (depDetails.current["4"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_zebra_51")}
        dep-group=""
        ref={(ref) => ["51"].forEach((dep) => (depDetails.current["5"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={""}
        dep-group="7"
        ref={(ref) => ["71", "72"].forEach((dep) => (depDetails.current["7"][dep] = ref))}
      />

      <div className="models_title_div">
        <h1>
          {defaultModelName === undefined || defaultModelName === ""
            ? " "
            : pageLanguage === "fa"
            ? convertToPersian(defaultModelNameFa) + " سفارشی "
            : "Custom " + defaultModelName}
        </h1>
        {defaultModelDesc && defaultModelDesc !== "" && (
          <h2>{pageLanguage === "fa" ? convertToPersian(defaultModelDescFa) : defaultModelDesc}</h2>
        )}
      </div>
      <div
        className="model_customize_container"
        style={{ justifyContent: "space-between", minHeight: "100%", backgroundColor: "#ece9e580" }}
      >
        <div
          className={
            offset ? "model_customize_image model_customize_image_fixed" : "model_customize_image"
          }
          ref={fixedDiv}
        >
          <div className="fixed-div">
            {defaultFabricPhoto && (
              <img
              src={imgUrl(defaultFabricPhoto)}
                className="img-fluid_allShade"
                // style={{ width: "70%", height: "584px" }}
                alt=""
              />
            )}
          </div>
        </div>
        <div
          className={`model_customize_section ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          style={{ marginInlineStart: "0", background: "#fff" }}
        >
          <Accordion ref={accordion} flush activeKey={accordionActiveKey}>
            {/* step 1 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="1"
                  stepNum={t("1")}
                  stepTitle={t("zebra_step1")}
                  stepRef="1"
                  type="1"
                  required={requiredStep["1"]}
                  stepSelected={stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <div className="card_body card-body-fabric">
                    <div className="search_filter_container">
                      <div className="search_container">
                        <div className="search_box">
                          <input
                            type="text"
                            placeholder={t("Search for product Name/Code")}
                            className="form-control search_input"
                            name="search_input"
                            value={searchText}
                            ref={search_input}
                            onChange={(e) => {
                              if (e.target.value !== "") setSearchShow(true);
                              else setSearchShow(false);
                              setSearchText(e.target.value);
                            }}
                          />
                          {searchShow && (
                            <div
                              className="clear-icon-container"
                              onClick={() => {
                                search_input.current.value = "";
                                setSearchText("");
                                setSearchShow(false);
                              }}
                            >
                              <i className="fa fa-times-circle clear-icon" />
                            </div>
                          )}
                          <div className="search-icon-container">
                            <i className="fa fa-search" />
                          </div>
                        </div>
                        <div
                          className="filters_show_hide_container"
                          onClick={() => {
                            if (filtersShow) {
                              setFiltersShow(false);
                            } else {
                              setFiltersShow(true);
                            }
                          }}
                        >
                          <span className="filters_toggle">{t("Filters")}</span>
                          <span className="filters_indicator">
                            {filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_up.svg").default}
                                alt=""
                              />
                            )}
                            {!filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_down.svg").default}
                                alt=""
                              />
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        className={
                          filtersShow
                            ? "filters_container desktop_only"
                            : "filters_container desktop_only filters_container_hidden"
                        }
                      >
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Color")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="filter_color_items">
                              <div className="filter_items_container">{sewingColors}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="colors"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {t("filter_Clear Filters")}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Pattern")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPatterns}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="patterns"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {t("filter_Clear Filters")}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Opacity")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingTypes}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="types"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {t("filter_Clear Filters")}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Price")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">
                                {/*<div className="price_filter_description">{t("filter_price_title")}</div>*/}
                                {sewingPrices}
                              </div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="prices"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {t("filter_Clear Filters")}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>

                    <div className="fabrics_list_container">{fabricsList}</div>
                    <Modal dialogClassName="zoomModal" show={show} onHide={() => handleClose()}>
                      <Modal.Header closeButton>{zoomModalHeader}</Modal.Header>
                      <Modal.Body>{zoomModalBody}</Modal.Body>
                      <Modal.Footer>
                        <button
                          className={`swatchButton ${hasSwatchId ? "activeSwatch" : ""} ${
                            pageLanguage === "fa" ? "font_farsi" : "font_en"
                          }`}
                          current-state={hasSwatchId ? "1" : "0"}
                          onClick={(e) => {
                            fabricSwatch(e, swatchId, swatchDetailId, swatchPhotoPath);
                          }}
                          disabled={swatchId === -1}
                        >
                          {hasSwatchId ? t("SWATCH IN BAG") : t("ORDER SWATCH")}
                        </button>
                      </Modal.Footer>
                    </Modal>
                    <NextStep currentStep="1" eventKey="2">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 2 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="2"
                  stepNum={t("2")}
                  stepTitle={t("zebra_step2")}
                  stepRef="2"
                  type="1"
                  required={requiredStep["2"]}
                  stepSelected={stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/zebra/new_mount_inside.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        value="1"
                        name="step2"
                        ref-num="2"
                        id="21"
                        checked={step2 === "Inside"}
                        onChange={(e) => {
                          if (step2 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "Inside",
                              id: "",
                              cartValue: "Inside",
                              event: e,
                            });
                          } else {
                            setStep2("Inside");
                            setStep21("");
                            setStep21Err1(false);
                           // setStep21Err2(false);
                            setStep21Err3(false);
                            setSelectedMountOutsideType([]);
                            setStep3("");
                            setMeasurementsNextStep("4");
                            setStep5("");
                            setSelectedValanceColor1([]);
                            setSelectedValanceColor2([]);
                            setStep5Arc("");
                            setStep5AArc("");
                            setStep5BArc("");
                            setDeps("21,5", "2,5Arc,5AArc,5BArc,51,5A,5B,5C,31,32,3AIn");
                            setCart(
                              "Mount",
                              "Inside",
                              "Headrail,MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            clearInputs(e, undefined, "5A,5B,5C");
                          }
                        }}
                        ref={(ref) => (inputs.current["21"] = ref)}
                      />
                      <label htmlFor="21">{t("mount_Inside")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/zebra/new_mount_outside.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("mount_Outside")}
                        value="2"
                        name="step2"
                        ref-num="2"
                        id="22"
                        checked={step2 === "Outside"}
                        onChange={(e) => {
                          if (step2 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "Outside",
                              id: "",
                              cartValue: "Outside",
                              event: e,
                            });
                          } else {
                            setStep2("Outside");
                            setStep21("");
                            setStep21Err1(false);
                            setStep21Err3(false);
                            setStep3("");
                            setStep5("");
                            setSelectedValanceColor1([]);
                            setSelectedValanceColor2([]);
                            setStep5Arc("");
                            setStep5AArc("");
                            setStep5BArc("");
                            setDeps("5", "2,21,5Arc,5AArc,5BArc,51,5A,5B,5C,31,32,3AIn");
                            setCart(
                              "Mount",
                              "Outside",
                              "Headrail,MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            clearInputs(e, undefined, "3,5A,5B,5C");
                          }
                          setSelectedMountOutsideType([]);
                        }}
                        ref={(ref) => (inputs.current["22"] = ref)}
                      />
                      <label htmlFor="22">{t("mount_Outside")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/zebra/new_mount_arc.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        value="3"
                        name="step1"
                        ref-num="2"
                        id="23"
                        checked={step2 === "HiddenMoulding"}
                        onChange={(e) => {
                          if (step2 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "HiddenMoulding",
                              id: "",
                              cartValue: "HiddenMoulding",
                              event: e,
                            });
                          } else {
                            setStep2("HiddenMoulding");
                            setStep21("");
                            setStep21Err1(false);
                            setStep21Err3(false);
                            setStep3("");
                            setStep5("");
                            setSelectedValanceColor1([]);
                            setSelectedValanceColor2([]);
                            setSelectedMountOutsideType([]);
                            setStep5Arc("");
                            setStep5AArc("");
                            setStep5BArc("");
                            setDeps("21,5Arc", "2,5,51,5A,5B,5C,31,32,3AIn");
                            setCart(
                              "Mount",
                              "HiddenMoulding",
                              "Headrail,MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            clearInputs(e, undefined, "5A,5B,5C");
                          }
                        }}
                        ref={(ref) => (inputs.current["23"] = ref)}
                      />
                      <label htmlFor="23">{t("mount_Arc")}</label>
                    </div>
                    <div
                      className={
                        step2 === "Inside"
                          ? step21Err1
                            ? "secondary_options secondary_options_err"
                            : "secondary_options"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <input
                            type="checkbox"
                            text={t("mount_Inside")}
                            value="1"
                            name="step21"
                            ref-num="2"
                            checked={step21 === "true"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectChanged(e);
                                setStep21("true");
                                setStep21Err1(false);

                                setDeps("", "21,999");
                              } else {
                                setStep21("");
                                setDeps("21", "");
                                selectChanged(undefined, "2");
                              }
                            }}
                            id="211"
                            ref={(ref) => (inputs.current["211"] = ref)}
                          />
                          <label htmlFor="211" className="checkbox_label">
                            <img
                              className="checkbox_label_img checkmark1 img-fluid"
                              src={require("../Images/public/checkmark1_checkbox.png")}
                              alt=""
                            />
                          </label>
                          <span className="checkbox_text">{t("inside_checkbox_title")}</span>
                        </div>
                      </div>
                    </div>
                    {step21Err1 && <div className="input_not_valid">{t("roller_step21Err1")}</div>}
                    <div className={step2 === "Outside" ? "selection_section" : "noDisplay"}>
                      <div
                        className={
                          step21Err2 ? "select_container select_container_red" : "select_container"
                        }
                      >
                        <Select
                          className="select"
                          placeholder={t("Please Select")}
                          portal={document.body}
                          dropdownPosition="bottom"
                          dropdownHandle={false}
                          dropdownGap={0}
                          values={selectedMountOutsideType}
                          onDropdownOpen={() => {
                            let temp1 = window.scrollY;
                            window.scrollTo(window.scrollX, window.scrollY + 1);
                            setTimeout(() => {
                              let temp2 = window.scrollY;
                              if (temp2 === temp1)
                                window.scrollTo(window.scrollX, window.scrollY - 1);
                            }, 100);
                          }}
                          dropdownRenderer={({ props, state, methods }) => (
                            <CustomDropdown props={props} state={state} methods={methods} />
                          )}
                          contentRenderer={({ props, state, methods }) => (
                            <CustomControl props={props} state={state} methods={methods} />
                          )}
                          onChange={(selected) => {
                            if (selected.length) {
                              setSelectedMountOutsideType(selected);
                              setStep21Err2(false);

                              const step2Label =
                                t("mount_Outside") + "/" + selected[0].label;
                                
                              setStepSelectedLabel((prev) => ({ ...prev, 2: step2Label }));
                              if (step3 !== "") {
                           //     console.log("1");
                                setHeight3C(undefined);
                             
                                setDeps("3", "2,21,31,32,3AIn");
                                setCart(
                                  "IsWalled",
                                  selected[0].value,
                                  "calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width1,Width2,Width3,Height1,Height2,Height3,FinishedLengthType,Width2B,Height2D,ExtensionLeft,ExtensionRight,ShadeMount,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3,WindowToFloor"
                                );
                                
                                setStep3("");
                                clearInputs(undefined, undefined, "3", undefined);
                              } else {
                              //  console.log("2");
                             
                                if(selectedMountOutsideType.length && selectedMountOutsideType[0]?.value === "Ceiling"){
                               //   console.log("6567 step3 === true");
                                  setDeps(
                                    "3AOut,3BOut,3CArc",
                                    "3COut,3DOut"
                                  );
                                }else {
                                //  console.log("6567 step3 === false"); 
                                  setDeps("", "2,21,31,32,3AIn");
                                }
                                setCart(
                                  "IsWalled",
                                  selected[0].value,
                                  "Width2B,Height2D,ExtensionLeft,ExtensionRight,ShadeMount"
                                );
                              }
                            }
                          }}
                          options={optionsOutside[pageLanguage]}
                        />
                      </div>
                    </div>
                    <div
                      className={
                        step2 === "HiddenMoulding"
                          ? step21Err3
                            ? "secondary_options secondary_options_err"
                            : "secondary_options"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <input
                            type="checkbox"
                            text={t("mount_Arc")}
                            value="3"
                            name="step21"
                            ref-num="2"
                            checked={step21 === "true"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectChanged(e);
                                setStep21("true");
                                setStep21Err3(false);

                                setDeps("", "21,999");
                              } else {
                                setStep21("");
                                setDeps("21", "");
                                selectChanged(undefined, "2");
                              }
                            }}
                            id="213"
                            ref={(ref) => (inputs.current["213"] = ref)}
                          />
                          <label htmlFor="213" className="checkbox_label">
                            <img
                              className="checkbox_label_img checkmark1 img-fluid"
                              src={require("../Images/public/checkmark1_checkbox.png")}
                              alt=""
                            />
                          </label>
                          <span className="checkbox_text">{t("Arc_checkbox_title")}</span>
                        </div>
                      </div>
                    </div>
                    {step21Err3 && <div className="input_not_valid">{t("step21Err3_d")}</div>}
                    <NextStep
                      currentStep="2"
                      eventKey={
                        (step2 === "Inside" || step2 === "HiddenMoulding") && step21 !== "true"
                          ? "2"
                          : "3"
                      }
                      onClick={() => {
                        if (
                          (step2 === "Inside" || step2 === "HiddenMoulding") &&
                          step21 !== "true"
                        ) {
                          if (step2 === "Inside") {
                            setStep21Err1(true);
                          } else {
                            setStep21Err3(true);
                          }
                        }
                      }}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
               
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header"></p>
                        <ul className="help_column_list 1">
                          <li className="no_listStyle">
                            <b>{t("dk_step2_help_1")}</b>
                            {t("dk_step2_help_2")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("dk_step2_help_3")}</b>
                            {t("dk_step2_help_4")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("dk_step2_help_5")}</b>
                            {t("roller_step2_help_6_new")}
                          </li>
                        </ul>
                        <div className="box-help-step2">
                          <p>
                          {t("shade_step2_help_note")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="3"
                  stepNum={t("3")}
                  stepTitle={t("zebra_step3")}
                  stepRef="3"
                  type="2"
                  required={requiredStep["3"]}
                  stepSelected={
                    windowSizeBool
                      ? windowSize
                      : stepSelectedLabel["3"] === undefined
                      ? ""
                      : stepSelectedLabel["3"]
                  }
                  cartCustomText={t("zebra_step3_custom_cart_text")}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("I have my own measurements")}
                        value="1"
                        name="step3"
                        ref-num="3"
                        id="31"
                        checked={step3 === "false"}
                        onChange={(e) => {
                          if (
                            step2 === "" ||
                            (step2 === "Inside" && step21 !== "true") ||
                            (step2 === "HiddenMoulding" && step21 !== "true")
                          ) {
                            setStep3("");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "31,32");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else {
                            setStep3("false");
                            selectChanged(e, "3AIn,3BIn,3AOut,3BOut,3COut,3DOut,3CArc");
                            setMeasurementsNextStep("4");
                            setDeps(
                              "31,32",
                              "3,3AIn1,3BIn1,3AIn2,3BIn2,3AIn3,3BIn3,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3"
                            );
                            clearInputs(e);
                            setCart(
                              "calcMeasurements",
                              false,
                              "WidthCart,HeightCart,Width1,Width2,Width3,Height1,Height2,Height3,Width3A,Height3C,ExtensionLeft,ExtensionRight,ShadeMount,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3"
                            );
                          }
                        }}
                        ref={(ref) => (inputs.current["31"] = ref)}
                      />
                      <label htmlFor="31">{t("I have my own measurements.")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Calculate my measurements")}
                        value="2"
                        name="step3"
                        checked={step3 === "true"}
                        ref-num="3"
                        id="32"
                        ref={(ref) => (inputs.current["32"] = ref)}
                        onChange={(e) => {
                          if (step2 === "") {
                            setStep3("");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "31,32");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else if (step2 === "Inside") {
                            if (step2 === "Inside" && step21 !== "true") {
                              modalHandleShow("noInsideUnderstand");
                              setStep3("");
                              selectUncheck(e);
                              setDeps("3", "31,32");
                              setCart(
                                "",
                                "",
                                "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                              );
                            } else {
                              setStep3("true");
                              clearInputs(e);
                              setMeasurementsNextStep("3A");
                              setDeps(
                                "3AIn1,3BIn1,3AIn2,3BIn2,3AIn3,3BIn3",
                                "3,3AOut,3BOut1,3BOut2,3COut,3DOut,31,32,3CArc1,3CArc2,3CArc3"
                              );
                              setCart(
                                "calcMeasurements",
                                true,
                                "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width3A,Height3C,ExtensionLeft,ExtensionRight,ShadeMount,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3"
                              );
                            }
                          } else if (step2 === "HiddenMoulding") {
                            if (step2 === "HiddenMoulding" && step21 !== "true") {
                              modalHandleShow("noInsideUnderstand");
                              setStep3("");
                              selectUncheck(e);
                              setDeps("3", "31,32");
                              setCart(
                                "",
                                "",
                                "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                              );
                            } else {
                              setStep3("true");
                              clearInputs(e);
                              setMeasurementsNextStep("3A");
                              setDeps(
                                "3AOut,3BOut1,3BOut2,3CArc1,3CArc2,3CArc3",
                                "3,3COut,3DOut,31,32"
                              );
                              setCart(
                                "calcMeasurements",
                                true,
                                "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width1,Width2,Width3,Height1,Height2,Height3,Height3C,ShadeMount"
                              );
                            }
                          } else {
                            setStep3("true");
                            clearInputs(e);
                            setMeasurementsNextStep("3A");
                            if(selectedMountOutsideType?.length && selectedMountOutsideType[0].value === "Ceiling"){
                           
                              setDeps(
                                "3AOut,3BOut1,3BOut2,3CArc1,3CArc2,3CArc3",
                                "3,3COut,3DOut,31,32"
                              );
                            }else {
                              setDeps(
                                "3AOut,3BOut1,3BOut2,3COut,3DOut",
                                "3,3AIn1,3BIn1,3AIn2,3BIn2,3AIn3,3BIn3,31,32,3CArc1,3CArc2,3CArc3"
                              );
                            }
                            setCart(
                              "calcMeasurements",
                              true,
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width1,Width2,Width3,Height1,Height2,Height3,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3"
                            );
                          }
                        }}
                      />
                      <label htmlFor="32">{t("Calculate my measurements.")}</label>
                    </div>

                    <div className={step3 === "false" ? "own_measurements_container" : "noDisplay"}>
                      <div className="own_measurements_width">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Width"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Height"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width !== undefined && (width < 30 || width > 280)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width"
                              value={NumToFa(`${width || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 280
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width", parseInt(newValue));
                                    setDeps("", "31");
                                    setWidth(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width");
                                    setDeps("31", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth(undefined);
                                      selectChanged(undefined, "3");
                                    } else {
                                      setWidth(parseInt(newValue));
                                      selectChanged("3", undefined, t("Invalid Measurements"));
                                    }
                                    setWindowSize("");
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              width !== undefined && (width < 30 || width > 280)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 280`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="own_measurements_Length">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Height"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Width"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height !== undefined && (height < 30 || height > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height"
                              value={NumToFa(`${height || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height", parseInt(newValue));
                                    setDeps("", "32,999");
                                    setHeight(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height");
                                    setDeps("32", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight(undefined);
                                      selectChanged(undefined, "3");
                                    } else {
                                      setHeight(parseInt(newValue));
                                      selectChanged("3", undefined, t("Invalid Measurements"));
                                    }
                                    setWindowSize("");
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              height !== undefined && (height < 30 || height > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                   
                    <div className="secondary_options_zebra">
                      <p
                        className="checkbox_text"
                        style={{ textAlign: pageLanguage === "fa" ? "right" : "left" , fontSize: "0.9375rem" , fontWeight: "500" , letterSpacing :"0.055625rem" , padding:"0 0.79rem" }}
                      >
                        {pageLanguage === "fa" ? "نکته" : "Note"}
                      </p>
                      <ul
                        className="help_column_list"
                        style={{
                          textAlign: pageLanguage === "fa" ? "right" : "left",
                          marginLeft: pageLanguage === "en" ? "0.8rem" : "0",
                          marginRight: pageLanguage === "fa" ? "0.8rem" : "0",
                        }}
                      >
                        <li>{t("new_note_zebra")}</li>
                        <li>{t("new_note_zebra_1")}</li>
                      </ul>
                    </div>
                    <NextStep currentStep="3" eventKey={measurementsNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  {stepSelectedValue["3"] === "1" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <div
                                className="measurementsHelp_link"
                                style={{ display: "flex", alignItems: "center", gap: "1px" }}
                              >
                                {t("step3_help_11")}
                                <span
                                  className="link_between_text"
                                  onClick={(e) => modalHandleShow("measurementsHelp")}
                                >
                                  {t("step3_help_12")}
                                </span>
                                {t("step3_help_13")}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {stepSelectedValue["3"] === "2" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <b>{t("Note:&nbsp;")}</b>
                              {t("step3_help_2.5")}
                            </li>
                            {/*<li className="no_listStyle single_line_height">*/}
                            {/*    {t("step3_help_3")}*/}
                            {/*</li>*/}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3A inside */}
            <Card
              className={
                step3 === "true" && step2 === "Inside" && step21 === "true" ? "" : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3A"
                  stepNum={t("3A")}
                  stepTitle={t("zebra_step3AInside")}
                  stepRef="3AIn"
                  type="2"
                  required={requiredStep["3AIn"]}
                  stepSelected={
                    stepSelectedLabel["3AIn"] === undefined ? "" : stepSelectedLabel["3AIn"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3A_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/zebra/new_width_inside_3_fa.svg").default
                            : require("../Images/drapery/zebra/new_width_inside_3.svg").default
                        }
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div
                      className={`box100 ${
                        pageLanguage === "fa"
                          ? "Three_selection_container_fa"
                          : "Three_selection_container"
                      }`}
                    >
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Width1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["width2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width1 !== undefined && (width1 < 30 || width1 > 280)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width1"
                              value={NumToFa(`${width1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 280
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width1", parseInt(newValue));
                                    setDeps("", "3AIn1");
                                    setWidth1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3AIn",
                                      0,
                                      true,
                                      "widthDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3A"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width1");
                                    setDeps("3AIn1", "");
                                    clearOptionSelect_three("3AIn", 0);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth1(undefined);
                                      selectChanged(undefined, "3AIn");
                                    } else {
                                      setWidth1(parseInt(newValue));
                                      selectChanged("3AIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              width1 !== undefined && (width1 < 30 || width1 > 280)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 280`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["width2"] = ref)}
                              debounceTimeout={1500}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["width3"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width2 !== undefined && (width2 < 30 || width2 > 280)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width2"
                              value={NumToFa(`${width2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 280
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width2", parseInt(newValue));
                                    setDeps("", "3AIn2");
                                    setWidth2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3AIn",
                                      1,
                                      true,
                                      "widthDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3A"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width2");
                                    setDeps("3AIn2", "");
                                    clearOptionSelect_three("3AIn", 1);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth2(undefined);
                                      selectChanged(undefined, "3AIn");
                                    } else {
                                      setWidth2(parseInt(newValue));
                                      selectChanged("3AIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              width2 !== undefined && (width2 < 30 || width2 > 280)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 280`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["width3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width3 !== undefined && (width3 < 30 || width3 > 280)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width3"
                              value={NumToFa(`${width3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 280
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width3", parseInt(newValue));
                                    setDeps("", "3AIn3");
                                    setWidth3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3AIn",
                                      2,
                                      true,
                                      "widthDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3A"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width3");
                                    setDeps("3AIn3", "");
                                    clearOptionSelect_three("3AIn", 2);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth3(undefined);
                                      selectChanged(undefined, "3AIn");
                                    } else {
                                      setWidth3(parseInt(newValue));
                                      selectChanged("3AIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              width3 !== undefined && (width3 < 30 || width3 > 280)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 280`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3AIn" eventKey="3B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("step3A_help_roller_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3B inside */}
            <Card
              className={
                step3 === "true" && step2 === "Inside" && step21 === "true" ? "" : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("3B")}
                  stepTitle={t("zebra_step3BInside")}
                  stepRef="3BIn"
                  type="2"
                  required={requiredStep["3BIn"]}
                  stepSelected={
                    stepSelectedLabel["3BIn"] === undefined ? "" : stepSelectedLabel["3BIn"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3B_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/zebra/new_height_inside_3_fa.svg").default
                            : require("../Images/drapery/zebra/new_height_inside_3.svg").default
                        }
                        className="img-fluid"
                        alt=""
                      />
                    </div>

                    <div
                      className={`box100 ${
                        pageLanguage === "fa"
                          ? "Three_selection_container_fa"
                          : "Three_selection_container"
                      }`}
                    >
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["height1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["height2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height1 !== undefined && (height1 < 30 || height1 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height1"
                              value={NumToFa(`${height1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height1", parseInt(newValue));
                                    setDeps("", "3BIn1");
                                    setHeight1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3BIn",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3B"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height1");
                                    setDeps("3BIn1", "");
                                    clearOptionSelect_three("3BIn", 0);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight1(undefined);
                                      selectChanged(undefined, "3BIn");
                                    } else {
                                      setHeight1(parseInt(newValue));
                                      selectChanged("3BIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              height1 !== undefined && (height1 < 30 || height1 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["height2"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["height3"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height2 !== undefined && (height2 < 30 || height2 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height2"
                              value={NumToFa(`${height2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height2", parseInt(newValue));
                                    setDeps("", "3BIn2");
                                    setHeight2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3BIn",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3B"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height2");
                                    setDeps("3BIn2", "");
                                    clearOptionSelect_three("3BIn", 1);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight2(undefined);
                                      selectChanged(undefined, "3BIn");
                                    } else {
                                      setHeight2(parseInt(newValue));
                                      selectChanged("3BIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              height2 !== undefined && (height2 < 30 || height2 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["height3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height3 !== undefined && (height3 < 30 || height3 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height3"
                              value={NumToFa(`${height3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height3", parseInt(newValue));
                                    setDeps("", "3BIn3");
                                    setHeight3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3BIn",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3B"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height3");
                                    setDeps("3BIn3", "");
                                    clearOptionSelect_three("3BIn", 2);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight3(undefined);
                                      selectChanged(undefined, "3BIn");
                                    } else {
                                      setHeight3(parseInt(newValue));
                                      selectChanged("3BIn", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              height3 !== undefined && (height3 < 30 || height3 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>

                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3BIn"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">{t("step3B_help_1")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3A outside */}
            <Card
              className={
                step3 === "true" && !!(step2 === "Outside" || step2 === "HiddenMoulding")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3A"
                  stepNum={t("3A")}
                  stepTitle={t("zebra_step3AOutside")}
                  stepRef="3AOut"
                  type="2"
                  required={requiredStep["3AOut"]}
                  stepSelected={
                    stepSelectedLabel["3AOut"] === undefined ? "" : stepSelectedLabel["3AOut"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3A_out_title")}</p>
                      <img
                        src={require("../Images/drapery/zebra/new_FrameSize.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width3A !== undefined && (width3A < 30 || width3A > 280)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width3A"
                              value={NumToFa(`${width3A || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 280
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width3A", parseInt(newValue));
                                    setDeps("", "3AOut");
                                    setWidth3A(parseInt(newValue));
                                    optionSelectChanged(
                                      "3AOut",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width3A");
                                    setDeps("3AOut", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth3A(undefined);
                                      selectChanged(undefined, "3AOut");
                                    } else {
                                      setWidth3A(parseInt(newValue));
                                      selectChanged("3AOut", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              width3A !== undefined && (width3A < 30 || width3A > 280)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 280`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3AOut" eventKey="3B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3B outside */}
            <Card
              className={
                step3 === "true" && !!(step2 === "Outside" || step2 === "HiddenMoulding")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("3B")}
                  stepTitle={t("zebra_step3BOutside")}
                  stepRef="3BOut"
                  type="2"
                  required={requiredStep["3BOut"]}
                  stepSelected={
                    stepSelectedLabel["3BOut"] === undefined ? "" : stepSelectedLabel["3BOut"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3B_out_title")}</p>
                      <img
                        src={require("../Images/drapery/zebra/new_wall_cover.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="box100 Two_selection_container dir_ltr">
                      <div className="box50">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Left")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Left"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Right"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (left !== undefined && (left < 0 || left > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="Left"
                              value={NumToFa(`${left || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 0 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("ExtensionLeft", parseInt(newValue));
                                    setDeps("", "3BOut1");
                                    setLeft(parseInt(newValue));
                                    optionSelectChanged_LeftRight(
                                      parseInt(newValue),
                                      "3BOut",
                                      true,
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "ExtensionLeft");
                                    setDeps("3BOut1", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setLeft(undefined);
                                      selectChanged(undefined, "3BOut");
                                    } else {
                                      setLeft(parseInt(newValue));
                                      selectChanged("3BOut", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="box50">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Right")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Right"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Left"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (right !== undefined && (right < 0 || right > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="Right"
                              value={NumToFa(`${right || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 0 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("ExtensionRight", parseInt(newValue));
                                    setDeps("", "3BOut2");
                                    setRight(parseInt(newValue));
                                    optionSelectChanged_LeftRight(
                                      parseInt(newValue),
                                      "3BOut",
                                      false,
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "ExtensionRight");
                                    setDeps("3BOut2", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRight(undefined);
                                      selectChanged(undefined, "3BOut");
                                    } else {
                                      setRight(parseInt(newValue));
                                      selectChanged("3BOut", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <NextStep currentStep="3BOut" eventKey="3C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("step3B_out_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3C outside */}
            {/* <Card className={step3 === "true" && step2 === "Outside" ? "" : "noDisplay"}> */}
            <Card className={step3 === "true" && step2 === "Outside" && selectedMountOutsideType[0].value === "Wall" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("3C")}
                  stepTitle={t("zebra_step3COutside")}
                  stepRef="3COut"
                  type="2"
                  required={requiredStep["3COut"]}
                  stepSelected={
                    stepSelectedLabel["3COut"] === undefined ? "" : stepSelectedLabel["3COut"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3C_out_title")}</p>
                      <img
                        src={require("../Images/drapery/zebra/new_frame_height.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height3C !== undefined && (height3C < 30 || height3C > 370)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height3C"
                              value={NumToFa(`${height3C || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 370
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height3C", parseInt(newValue));
                                    setDeps("", "3COut");
                                    setHeight3C(parseInt(newValue));
                                    optionSelectChanged(
                                      "3COut",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height3C");
                                    setDeps("3COut", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight3C(undefined);
                                      selectChanged(undefined, "3COut");
                                    } else {
                                      setHeight3C(parseInt(newValue));
                                      selectChanged("3COut", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              height3C !== undefined && (height3C < 30 || height3C > 370)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 370`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3COut" eventKey="3D">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("dualroller Measurements")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3C Arc */}
            {/* <Card className={step3 === "true" && step2 === "HiddenMoulding" ? "" : "noDisplay"}> */}
            <Card 
           className={
           (step3 === "true" && step2 === "HiddenMoulding") ||
            (step3 === "true" && step2 === "Outside" && selectedMountOutsideType[0]?.value === "Ceiling")
           ? ""
          : "noDisplay"
          }
         >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("3C")}
                  stepTitle={t("dk_step2D")}
                  stepRef="3CArc"
                  type="2"
                  required={requiredStep["3CArc"]}
                  stepSelected={
                    stepSelectedLabel["3CArc"] === undefined ? "" : stepSelectedLabel["3CArc"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                    {
                        step2 === "HiddenMoulding" && <>
                         <p className="step_selection_title">{t("arc_step2D_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/dk/new_ceiling_to_window_3_arc_fa.svg")
                                .default
                            : require("../Images/drapery/dk/new_ceiling_to_window_3_arc.svg")
                                .default
                        }
                        className="img-fluid"
                        alt=""
                      />
                        </>
                      }
                      {
                        step2 === "Outside" && <>
                             <p className="step_selection_title">  {t("dk_step2D_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                          ? require("../Images/drapery/dk/new_ceiling_to_window_3_fa.svg").default
                          : require("../Images/drapery/dk/new_ceiling_to_window_3.svg").default
                        }
                        className="img-fluid"
                        alt="img--ceiling"
                      />

                        </>


                      }
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow1 !== undefined &&
                                (ceilingToWindow1 < 30 || ceilingToWindow1 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow1"
                              value={NumToFa(`${ceilingToWindow1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow1", parseInt(newValue));
                                    setDeps("", "3CArc1");
                                    setCeilingToWindow1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3CArc",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3C"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow1");
                                    setDeps("3CArc1", "");
                                    clearOptionSelect_three("3CArc", 0);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow1(undefined);
                                      selectChanged(undefined, "3CArc");
                                    } else {
                                      setCeilingToWindow1(parseInt(newValue));
                                      selectChanged("3CArc", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              ceilingToWindow1 !== undefined &&
                              (ceilingToWindow1 < 30 || ceilingToWindow1 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow2"] = ref)}
                              debounceTimeout={1500}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  if (pageLanguage === "fa") {
                                    inputs.current["ceilingToWindow1"].focus();
                                  } else {
                                    inputs.current["ceilingToWindow3"].focus();
                                  }
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow2 !== undefined &&
                                (ceilingToWindow2 < 30 || ceilingToWindow2 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow2"
                              value={NumToFa(`${ceilingToWindow2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow2", parseInt(newValue));
                                    setDeps("", "3CArc2");
                                    setCeilingToWindow2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3CArc",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3C"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow2");
                                    setDeps("3CArc2", "");
                                    clearOptionSelect_three("3CArc", 1);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow2(undefined);
                                      selectChanged(undefined, "3CArc");
                                    } else {
                                      setCeilingToWindow2(parseInt(newValue));
                                      selectChanged("3CArc", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              ceilingToWindow2 !== undefined &&
                              (ceilingToWindow2 < 30 || ceilingToWindow2 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow3 !== undefined &&
                                (ceilingToWindow3 < 30 || ceilingToWindow3 > 400)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow3"
                              value={NumToFa(`${ceilingToWindow3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                handleNumberInputLanguage(e);
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 30 &&
                                    parseInt(newValue) <= 400
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow3", parseInt(newValue));
                                    setDeps("", "3CArc3");
                                    setCeilingToWindow3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3CArc",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3C"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow3");
                                    setDeps("3CArc3", "");
                                    clearOptionSelect_three("3CArc", 2);
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow3(undefined);
                                      selectChanged(undefined, "3CArc");
                                    } else {
                                      setCeilingToWindow3(parseInt(newValue));
                                      selectChanged("3CArc", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              ceilingToWindow3 !== undefined &&
                              (ceilingToWindow3 < 30 || ceilingToWindow3 > 400)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {RangeToFa(`30 - 400`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      // currentStep={
                      //   [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3CArc"
                      // }
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3DOut"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      aria-label="imgCamera"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 1">
                                        <img
                                          src={
                                            popoverImages["step2d"] === undefined
                                              ? require("../Images/drapery/dk/mouldinghelpphoto1.jpg")
                                              : popoverImages["step2d"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("dk_step_help_camera_title")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/dk/mouldinghelpphoto1.jpg")}
                                              text="step2d"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/dk/mouldinghelpphoto2.jpg")}
                                              text="step2d"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("dk_step2D_help_1")}
                          </li>
                          <li className="single_line_height">
                            {t("dualroller Measurements")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3D outside */}
            <Card className={step3 === "true" && step2 === "Outside" && selectedMountOutsideType[0].value === "Wall" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3D"
                  stepNum={t("3D")}
                  stepTitle={t("zebra_step3DOutside")}
                  stepRef="3DOut"
                  type="2"
                  required={requiredStep["3DOut"]}
                  stepSelected={
                    stepSelectedLabel["3DOut"] === undefined ? "" : stepSelectedLabel["3DOut"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3D">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("step3D_out_title")}</p>
                      <img
                        src={require("../Images/drapery/zebra/new_shade_mount.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (mount !== undefined && (mount < 15 || mount > 100)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="mount"
                              value={NumToFa(`${mount || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 15 &&
                                    parseInt(newValue) <= 100
                                  ) {
                                    setCartLoading(true);
                                    setCart("ShadeMount", parseInt(newValue));
                                    setDeps("", "3DOut");
                                    setMount(parseInt(newValue));
                                    optionSelectChanged(
                                      "3DOut",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "ShadeMount");
                                    setDeps("3DOut", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setMount(undefined);
                                      selectChanged(undefined, "3DOut");
                                    } else {
                                      setMount(parseInt(newValue));
                                      selectChanged("3DOut", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${
                              mount !== undefined && (mount < 15 || mount > 100)
                                ? " measure_input_desc_err"
                                : ""
                            }`}
                          >
                            {t("Min: ")} {NumToFa(`15`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3DOut"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("step3D_out_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 4 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="4"
                  stepNum={t("4")}
                  stepTitle={t("zebra_step4")}
                  stepRef="4"
                  type="1"
                  required={requiredStep["4"]}
                  stepSelected={stepSelectedLabel["4"] === undefined ? "" : stepSelectedLabel["4"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Continuous") + " " + t("Loop")}
                        value="1"
                        name="step4"
                        ref-num="4"
                        id="41"
                        checked={step4 === "Continuous Loop"}
                        onChange={(e) => {
                          
                          setStep4("Continuous Loop");
                          setStep41("false");
                          setStep4A("");
                          setStep4B("");
                          setMotorErr1(false);
                          setControlTypeNextStep("4A");
                          setDeps("4A,4B", "4,41,411,412,413,414");
                          selectChanged(e);
                          setCart(
                            "ControlType",
                            "Continuous Loop",
                            "hasPower,MotorType,MotorPosition,RemoteName,MotorChannels"
                          );
                          setCustomMotorAcc({});
                          setSelectedMotorPosition([]);
                          setSelectedMotorType([]);
                          setSelectedRemoteName([]);
                          setSelectedMotorChannels([
                            motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                          ]);
                          setRemoteName("");
                        }}
                        ref={(ref) => (inputs.current["41"] = ref)}
                      />
                      <label htmlFor="41">
                        {t("Continuous")}
                        <br />
                        <p>{t("Loop")}</p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        value="2"
                        name="step4"
                        checked={step4 === "Motorized"}
                        ref-num="4"
                        id="42"
                        onChange={(e) => {
                         
                          selectChanged(e, "41,4A,4B");
                          setControlTypeNextStep("5");
                          setStep4("Motorized");
                          setStep4A("");
                          setStep4B("");
                          setDeps("41", "4,4A,4B");
                          setCart("", "", "ControlPosition,ChainLength");
                        }}
                        ref={(ref) => (inputs.current["42"] = ref)}
                      />
                      <label htmlFor="42">
                        {t("Motorized")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0 || selectedMotorMinPrice > 0
                            ? t("Starts at ") +
                              GetPrice(
                                selectedMotorMinPrice,
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )
                            : t("Surcharge Applies")}
                        </p>
                      </label>
                    </div>

                    <div
                      className={
                        step4 === "Motorized"
                          ? motorErr1
                            ? "secondary_options secondary_options_err"
                            : "secondary_options"
                          : "noDisplay"
                      }
                    >
                     
                      <div className="card-body-display-flex">
                       
                        <div className="width_max checkbox_style">
                          <input
                            type="checkbox"
                            text={t("Motorized")}
                            value="2"
                            name="step41"
                            ref-num="4"
                            checked={step41 === "true"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectChanged(e);
                                setStep41("true");
                                setMotorErr1(false);

                                setDeps("411,412,413,414", "41");
                                setCart("hasPower", true, "", "ControlType,MotorChannels", [
                                  "Motorized",
                                  selectedMotorChannels.map((obj) => obj.value),
                                ]);
                              } else {
                                selectUncheck(e);
                                setStep41("");
                                // modalHandleShow("noPower");
                                setCustomMotorAcc({});
                                setSelectedMotorPosition([]);
                                setSelectedMotorType([]);
                                setSelectedRemoteName([]);
                                setSelectedMotorChannels([
                                  motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                                ]);
                                setRemoteName("");
                                setDeps("41", "411,412,413");
                                setCart(
                                  "",
                                  "",
                                  "ControlType,hasPower,MotorType,MotorPosition,RemoteName,MotorChannels"
                                );
                              }
                            }}
                            id="411"
                            ref={(ref) => (inputs.current["411"] = ref)}
                          />
                          <label htmlFor="411" className="checkbox_label">
                            <img
                              className="checkbox_label_img checkmark1 img-fluid"
                              src={require("../Images/public/checkmark1_checkbox.png")}
                              alt=""
                            />
                          </label>
                          <span className="checkbox_text">{t("Motor_title")}</span>
                        </div>
                      </div>
                    </div>

                    {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
                    <div
                      className={
                        step41 === "true" && step4 === "Motorized"
                          ? "motorized_options"
                          : "noDisplay"
                      }
                    >
                      <div className="motorized_option_left">
                        <p>{t("Motor Type")}&nbsp;</p>
                        <span onClick={() => modalHandleShow("learnMore1")}>
                          {t("(Learn More)")}
                        </span>
                      </div>
                      <div className="motorized_option_right">
                        <div className="select_container">
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedMotorType}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => {
                              const regexp = new RegExp(state.search, "i");
                              return (
                                <div className={props.className}>
                                  <div className="select_item_container">
                                    {props.options
                                      .filter((item) =>
                                        regexp.test(
                                          item[props.searchBy] ||
                                            item[props.labelField] ||
                                            item.label
                                        )
                                      )
                                      .map((option) => {
                                        let exist = "false";
                                        Object.values(state.values).forEach((obj) => {
                                          if (obj.value === option.value) exist = "true";
                                        });
                                        const isSmart = option.value === "Smart";
                                        const label = option[props.labelField] || option.label;
                                        return (
                                          <div
                                            className="select_item"
                                            item-selected={exist}
                                            disabled={option.disabled}
                                            key={option[props.valueField] || option.value}
                                            onClick={
                                              option.disabled ? null : () => methods.addItem(option)
                                            }
                                          >
                                            <div>
                                              {label}
                                              {isSmart && pageLanguage === "en" && (
                                                <div
                                                  style={{ fontSize: "0.9em", marginTop: "4px" }}
                                                  className="wifi-require-text"
                                                >
                                                  Wi-Fi Required
                                                </div>
                                              )}
                                              {isSmart && pageLanguage === "fa" && (
                                                <div
                                                  style={{ fontSize: "0.9em", marginTop: "4px" }}
                                                >
                                                  نیازمند وای فای
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              );
                            }}
                            contentRenderer={({ props, state, methods }) => {
                              const selectedValue =
                                state.values.length > 0 ? state.values[0] : null;
                              return (
                                <div
                                  className="select_control_container"
                                  onClick={() => methods.dropDown("toggle")}
                                >
                                  <span>
                                    {selectedValue ? selectedValue.label : props.placeholder}
                                  </span>
                                </div>
                              );
                            }}
                            // optionRenderer={
                            //     ({ item, props, state, methods }) => <CustomOption item={item} props={props} state={state} methods={methods}/>
                            // }
                            onChange={(selected) => {
                              if (selected[0] && !motorLoad2) {
                                // console.log(MotorType);
                                setDeps("", "411");
                                setSelectedMotorType(selected);
                                if (motorLoad2) {
                                  setMotorLoad2(false);
                                } else {
                                  if (selected[0]["apiAccValue"]) {
                                    setCustomMotorAcc(selected[0]["apiAccValue"]);
                                    setCart(
                                      "MotorType",
                                      selected[0].value,
                                      undefined,
                                      undefined,
                                      undefined,
                                      selected[0]["apiAccValue"]
                                    );
                                  } else {
                                    setCart("MotorType", selected[0].value);
                                  }
                                }
                              }
                              if (motorLoad2) {
                                setMotorLoad2(false);
                              }
                            }}
                            options={MotorType[pageLanguage]}
                          />
                        </div>
                      </div>
                      <div className="motorized_option_left">
                        <p>{t("Motor Position")}&nbsp;</p>
                        <span onClick={() => modalHandleShow("learnMore2")}>
                          {t("(Learn More)")}
                        </span>
                      </div>
                      <div className="motorized_option_right">
                        <div className="select_container">
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedMotorPosition}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdown props={props} state={state} methods={methods} />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControl props={props} state={state} methods={methods} />
                            )}
                            // optionRenderer={
                            //     ({ item, props, state, methods }) => <CustomOption item={item} props={props} state={state} methods={methods}/>
                            // }
                            onChange={(selected) => {
                              if (selected[0]) {
                                setSelectedMotorPosition(selected);
                                setDeps("", "412");
                                setCart("MotorPosition", selected[0].value);
                              }
                            }}
                            options={MotorPosition[pageLanguage]}
                          />
                        </div>
                      </div>
                      <div className="motorized_option_left">
                        <p>{t("Remote Name")}&nbsp;</p>
                        <span onClick={() => modalHandleShow("learnMore3")}>
                          {t("(Learn More)")}
                        </span>
                      </div>
                      <div className="motorized_option_right">
                        {!!(remoteNames.length > 1) && (
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedRemoteName}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdownWithSearch
                                  props={props}
                                  state={state}
                                  methods={methods}
                                />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              // optionRenderer={
                              //     ({ item, props, state, methods }) => <CustomOption item={item} props={props} state={state} methods={methods}/>
                              // }
                              onChange={(selected) => {
                                if (selected[0]) {
                                  setSelectedRemoteName(selected);
                                  if (selected[0]["value"] === "addNewRemoteName") {
                                    setShowRemoteName(true);
                                    setDeps("413", "");
                                    setCart("", "", "RemoteName");
                                    setRemoteName("");
                                  } else {
                                    setShowRemoteName(false);
                                    setDeps("", "413");
                                    setCart("RemoteName", selected[0]["value"]);
                                    setRemoteName(selected[0]["value"]);
                                  }
                                }
                              }}
                              options={remoteNames}
                            />
                          </div>
                        )}
                        {(remoteNames.length === 1 || remoteNames.length === 0) && (
                          <DebounceInput
                            debounceTimeout={1500}
                            onKeyDown={() => setCartLoading(true)}
                            className="Remote_name"
                            type="text"
                            name="Remote_name"
                            value={remoteName}
                            placeholder={t("Enter a name for your remote")}
                            onChange={(e) => {
                              setTimeout(() => {
                                if (e.target.value === "") {
                                  setDeps("413", "");
                                } else {
                                  setDeps("", "413");
                                }
                                setCart("RemoteName", e.target.value);
                                setRemoteName(Capitalize(e.target.value));
                              }, 300);
                            }}
                          />
                        )}
                      </div>
                      {showRemoteName && (
                        <div className="motorized_option_left">
                          <p>&nbsp;</p>
                        </div>
                      )}
                      {showRemoteName && (
                        <div className="motorized_option_right">
                          <DebounceInput
                            debounceTimeout={1500}
                            onKeyDown={() => setCartLoading(true)}
                            className="Remote_name"
                            type="text"
                            name="Remote_name"
                            value={remoteName}
                            placeholder={t("Enter a name for your remote")}
                            onChange={(e) => {
                              setTimeout(() => {
                                if (e.target.value === "") {
                                  setDeps("413", "");
                                } else {
                                  setDeps("", "413");
                                }
                                setCart("RemoteName", e.target.value);
                                setRemoteName(Capitalize(e.target.value));
                              }, 300);
                            }}
                          />
                        </div>
                      )}
                      <div className="motorized_option_left">
                        <p>{t("Channel(s)")}&nbsp;</p>
                        <span onClick={() => modalHandleShow("learnMore4")}>
                          {t("(Learn More)")}
                        </span>
                      </div>
                      <div className="motorized_option_right">
                        <div className="select_container multi_select_container">
                          <Select
                            className="select select_motor_channels"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            multi={true}
                            values={selectedMotorChannels}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdownMulti props={props} state={state} methods={methods} />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControlMulti props={props} state={state} methods={methods} />
                            )}
                            onChange={(selected) => {
                              setDeps("", "414,999");
                              setCart("MotorChannels", selected.map((obj) => obj.value));
                              setSelectedMotorChannels(selected);
                            }}
                            options={motorChannels[pageLanguage]}
                          />
                        </div>
                      </div>
                    </div>

                    <NextStep
                      currentStep="4"
                      eventKey={
                        step4 === "Motorized" && step41 !== "true" ? "4" : controlTypeNextStep
                      }
                      onClick={() => {
                        if (step4 === "Motorized" && step41 !== "true") {
                          setMotorErr1(true);
                        }
                      }}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  {(stepSelectedValue["4"] === "1" || stepSelectedValue["4"] === undefined) && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header">{t("step4_help_1")}</p>
                          <ul className="help_column_list">
                            <li>{t("step4_help_2")}</li>
                            <li>{t("step4_help_3")}</li>
                          </ul>
                        </div>
                        <div className="help_column help_right_column">
                          <p className="help_column_header">{t("step4_help_4")}</p>
                          <ul className="help_column_list">
                            {/*<li>{t("step4_help_5")}</li>*/}
                            <li className="no_listStyle">
                              <span className="popover_indicator">
                                {
                                  <PopoverStickOnHover
                                    placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                    children={
                                      <object
                                        className="popover_camera"
                                        type="image/svg+xml"
                                        aria-label="imgCamera2"
                                        data={require("../Images/public/camera.svg").default}
                                      />
                                    }
                                    component={
                                      <div className="clearfix">
                                        <div className="popover_image clearfix 2">
                                          <img
                                            src={
                                              popoverImages["step41"] === undefined
                                                ? require("../Images/drapery/zebra/motorized_control_type1.png.jpg")
                                                : popoverImages["step41"]
                                            }
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </div>
                                        <div className="popover_footer">
                                          <span className="popover_footer_title">
                                            {t("step4_popover_1")}
                                          </span>
                                          <span className="popover_thumbnails">
                                            <div>
                                              <img
                                                src={require("../Images/drapery/zebra/motorized_control_type1.png.jpg")}
                                                text="step41"
                                                onMouseEnter={(e) => popoverThumbnailHover(e)}
                                                className="popover_thumbnail_img img-fluid"
                                                alt=""
                                              />
                                            </div>
                                            {/*<div>*/}
                                            {/*    <img src={require('../Images/drapery/zebra/motorized_control_type2.png')}*/}
                                            {/*         text="step41"*/}
                                            {/*         onMouseEnter={(e) => popoverThumbnailHover(e)}*/}
                                            {/*         className="popover_thumbnail_img img-fluid"*/}
                                            {/*         alt=""/>*/}
                                            {/*</div>*/}
                                          </span>
                                        </div>
                                      </div>
                                    }
                                  />
                                }
                              </span>
                              {t("step4_help_5")}
                            </li>
                            {/*<li>{t("step4_help_5.5")}</li>*/}
                            <li>{t("step4_help_6")}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 4A */}
            <Card className={step4 === "Continuous Loop" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("4")) === -1 &&
                  !accordionActiveKey.startsWith("4")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="4A"
                  stepNum={t("4A")}
                  stepTitle={t("zebra_step4A")}
                  stepRef="4A"
                  type="1"
                  required={requiredStep["4A"]}
                  stepSelected={
                    stepSelectedLabel["4A"] === undefined ? "" : stepSelectedLabel["4A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="4A">
                <Card.Body>
                  <div className="card_body card_body_radio special_farsi_card_body">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/windowLeft.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Left")}
                        value="1"
                        name="step4A"
                        ref-num="4A"
                        id="4A1"
                        checked={step4A === "Left"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep4A("Left");
                          setDeps("", "4A");
                          setCart("ControlPosition", "Left");
                        }}
                        ref={(ref) => (inputs.current["4A1"] = ref)}
                      />
                      <label htmlFor="4A1">{t("Left")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/windowRight.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Right")}
                        value="2"
                        name="step4A"
                        ref-num="4A"
                        id="4A2"
                        checked={step4A === "Right"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep4A("Right");
                          setDeps("", "4A");
                          setCart("ControlPosition", "Right");
                        }}
                        ref={(ref) => (inputs.current["4A2"] = ref)}
                      />
                      <label htmlFor="4A2">{t("Right")}</label>
                    </div>
                    <NextStep currentStep="4A" eventKey="4B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">{t("step4A_help_1")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 4B */}
            <Card className={step4 === "Continuous Loop" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("4")) === -1 &&
                  !accordionActiveKey.startsWith("4")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="4B"
                  stepNum={t("4B")}
                  stepTitle={t("zebra_step4B")}
                  stepRef="4B"
                  type="1"
                  required={requiredStep["4B"]}
                  stepSelected={
                    stepSelectedLabel["4B"] === undefined ? "" : stepSelectedLabel["4B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="4B">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <ChainLengthSelector
                     t={t}
                     step4B={step4B}
                     setStep4B={setStep4B}
                     setChainLengthId={setChainLengthId}
                     setDeps={setDeps}
                     selectChanged={selectChanged}
                     setCart={setCart}
                     inputs={inputs}
                     modelAccessories={modelAccessories}
                     GetPrice={GetPrice}
                     pageLanguage={pageLanguage}
                     isTabletOrMobile={isTabletOrMobile}
                    />
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("4")) === -1 ? "4" : "4B"
                      }
                      eventKey="5"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* قاب پرده */}
            {/* step 5 */}
            <Card className={step2 !== "HiddenMoulding" ? "" : "noDisplay"}>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="5"
                  stepNum={t("5")}
                  stepTitle={t("roller_step5")}
                  stepRef="5"
                  type="1"
                  required={requiredStep["5"]}
                  stepSelected={stepSelectedLabel["5"] === undefined ? "" : stepSelectedLabel["5"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_4">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_regular.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_headrail1")}
                        value="1"
                        name="step5"
                        ref-num="5"
                        id="51"
                        checked={step5 === "Exposed"}
                        onChange={(e) => {
                          if (step2 === "") {
                            setStep5("");
                            setHeadRailId(null);
                            modalHandleShow("noMount");
                            setDeps("5", "");
                            setCart("", "", "Headrail,MetalValanceColor");
                            selectUncheck(e);
                          } else {
                            
                            setHeadRailId(null);
                            setStep5("Exposed");
                            setStep5A("");
                            setStep5B("");
                            setStep5C("");
                            setDeps("5A,5B,5C", "5,51");
                            setCart(
                              "Headrail",
                              "Exposed",
                              "MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            setHeadrailsNextStep("5A");
                          }
                          setSelectedValanceColor1([]);
                          setSelectedValanceColor2([]);
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["51"] = ref)}
                      />
                      <label htmlFor="51">{t("roller_headrail1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={
                          require("../Images/drapery/roller/roll_upholstered_valance.svg").default
                        }
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_headrail2")}
                        value="2"
                        name="step5"
                        ref-num="5"
                        id="52"
                        checked={step5 === "Upholstered"}
                        onChange={(e) => {
                          if (step2 === "") {
                            setStep5("");
                            setHeadRailId("900004");
                            modalHandleShow("noMount");
                            setDeps("5", "");
                            setCart("", "", "Headrail,MetalValanceColor");
                            selectUncheck(e);
                          } else {
                            setStepSelectedLabel(prev => {
                              const newObj = { ...prev };
                              delete newObj["5A"];
                              delete newObj["5B"];
                              delete newObj["5C"];
                              return newObj;
                            });
                            setHeadRailId("900004");
                            setStep5("Upholstered");
                            setStep5A("");
                            setStep5B("");
                            setStep5C("");
                            setDeps("", "5,51,5A,5B,5C");
                            setCart(
                              "Headrail",
                              "Upholstered",
                              "MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            setHeadrailsNextStep("6");
                            selectChanged(e);
                          }
                          setSelectedValanceColor1([]);
                          setSelectedValanceColor2([]);
                        }}
                        ref={(ref) => (inputs.current["52"] = ref)}
                      />
                      <label htmlFor="52">
                        {t("roller_headrail2")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["5"]
                            ? modelAccessories["5"]["8"]
                              ? GetPrice(
                                  modelAccessories["5"]["8"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_metal_valance.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_headrail3")}
                        value="3"
                        name="step5"
                        ref-num="5"
                        id="53"
                        checked={step5 === "MetalValance"}
                        onChange={(e) => {
                          if (step2 === "") {
                            setStep5("");
                            setHeadRailId("900005");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("5", "");
                            setCart("", "", "Headrail,MetalValanceColor");
                          } else {
                            setStepSelectedLabel(prev => {
                              const newObj = { ...prev };
                              delete newObj["5A"];
                              delete newObj["5B"];
                              delete newObj["5C"];
                              return newObj;
                            });
                            setHeadRailId("900005");
                            setStep5("MetalValance");
                            setDeps("51", "5,5A,5B,5C");
                            setCart("Headrail", "MetalValance", "MetalValanceColor");
                            setHeadrailsNextStep("6");
                            selectChanged(e);
                          }
                          setSelectedValanceColor1([]);
                          setSelectedValanceColor2([]);
                        }}
                        ref={(ref) => (inputs.current["53"] = ref)}
                      />
                      <label htmlFor="53">
                        {t("roller_headrail3")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["5"]
                            ? modelAccessories["5"]["10"]
                              ? GetPrice(
                                  modelAccessories["5"]["10"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_fabric_insert.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_headrail4")}
                        value="4"
                        name="step5"
                        ref-num="5"
                        id="54"
                        checked={step5 === "MetalValanceFabricInsert"}
                        onChange={(e) => {
                          if (step2 === "") {
                            setStep5("");
                            setHeadRailId("900006");
                            modalHandleShow("noMount");
                            setDeps("5", "");
                            setCart("", "", "Headrail,MetalValanceColor");
                            selectUncheck(e);
                          } else {
                            setStepSelectedLabel(prev => {
                              const newObj = { ...prev };
                              delete newObj["5A"];
                              delete newObj["5B"];
                              delete newObj["5C"];
                              return newObj;
                            });
                            setHeadRailId("900006");
                            setStep5("MetalValanceFabricInsert");
                            setStep5A("");
                            setStep5B("");
                            setStep5C("");
                            setDeps("51", "5,5A,5B,5C");
                            setCart(
                              "Headrail",
                              "MetalValanceFabricInsert",
                              "MetalValanceColor,RollType,BracketType,BracketColor"
                            );
                            setHeadrailsNextStep("6");
                            selectChanged(e);
                          }
                          setSelectedValanceColor1([]);
                          setSelectedValanceColor2([]);
                        }}
                        ref={(ref) => (inputs.current["54"] = ref)}
                      />
                      <label htmlFor="54">
                        {t("roller_headrail4")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["5"]
                            ? modelAccessories["5"]["12"]
                              ? GetPrice(
                                  modelAccessories["5"]["12"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>

                    <div
                      className={
                        step5 === "MetalValance" || step5 === "MetalValanceFabricInsert"
                          ? "selection_section"
                          : "noDisplay"
                      }
                    >
                      <div>
                        <div
                          className={step5 === "MetalValance" ? "select_container" : "noDisplay"}
                        >
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedValanceColor1}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdown props={props} state={state} methods={methods} />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControl props={props} state={state} methods={methods} />
                            )}
                            onChange={(selected) => {
                              if (selected.length) {
                                const selectedValue = selected[0].value;
                                setSelectedValanceColor1(selected);
                                setMetalValanceColorId(metalColorMap[selectedValue]);
                                setDeps("", "51,999");
                                setCart("MetalValanceColor", selected[0].value);
                                let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
                                tempLabels["5"] = t("roller_headrail3") + "/" + selected[0].label;
                                setStepSelectedLabel(tempLabels);
                              }
                            }}
                            options={optionsMetalValance[pageLanguage]}
                          />
                        </div>
                      </div>
                      <div>
                        <div
                          className={
                            step5 === "MetalValanceFabricInsert" ? "select_container" : "noDisplay"
                          }
                        >
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedValanceColor2}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdown props={props} state={state} methods={methods} />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControl props={props} state={state} methods={methods} />
                            )}
                            onChange={(selected) => {
                              if (selected.length) {
                                const selectedValue = selected[0].value;
                                setMetalValanceColorId(metalColorMap[selectedValue]);
                                setSelectedValanceColor2(selected);
                                setDeps("", "51,999");
                                setCart("MetalValanceColor", selected[0].value);
                                let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
                                tempLabels["5"] = t("roller_headrail4") + "/" + selected[0].label;
                                setStepSelectedLabel(tempLabels);
                              }
                            }}
                            options={optionsMetalValanceFabricInsert[pageLanguage]}
                          />
                        </div>
                      </div>
                    </div>

                    <NextStep currentStep="5" eventKey={headrailsNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            <div className="measurementsHelp_link text-center">
                              {t("headrailHelp")}{" "}
                              <span
                                className="link_between_text"
                                onClick={(e) => modalHandleShow("headrailHelp")}
                              >
                                {t("headrailHelp.2")}
                              </span>
                              {t("headrailHelp.3")}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* "نوع قرارگیری پارچه" */}
            {/* step 5A */}
            <Card className={step5 === "Exposed" && step2 !== "HiddenMoulding" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("5")) === -1 &&
                  !accordionActiveKey.startsWith("5")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="5A"
                  stepNum={t("5A")}
                  stepTitle={t("roller_step5A")}
                  stepRef="5A"
                  type="1"
                  required={requiredStep["5A"]}
                  stepSelected={
                    stepSelectedLabel["5A"] === undefined ? "" : stepSelectedLabel["5A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5A">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_regular.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("RollType1")}
                        value="1"
                        name="step5A"
                        ref-num="5A"
                        id="5A1"
                        checked={step5A === "Standard"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep5A("Standard");
                          setRollTypeId(12501);
                          setDeps("", "5A");
                          setCart("RollType", "Standard");
                        }}
                        ref={(ref) => (inputs.current["5A1"] = ref)}
                      />
                      <label htmlFor="5A1">{t("RollType1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_reverse.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("RollType2")}
                        value="2"
                        name="step5A"
                        ref-num="5A"
                        id="5A2"
                        checked={step5A === "Reverse"}
                        onChange={(e) => {
                          selectChanged(e);
                          setRollTypeId(12502);
                          setStep5A("Reverse");
                          setDeps("", "5A");
                          setCart("RollType", "Reverse");
                        }}
                        ref={(ref) => (inputs.current["5A2"] = ref)}
                      />
                      <label htmlFor="5A2">{t("RollType2")}</label>
                    </div>
                    <NextStep currentStep="5A" eventKey="5B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column help_left_column_mount_type">
                        <p className="help_column_header">{t("RollType_help_1")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      aria-label="imgCamera3"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 3">
                                        <img
                                          src={
                                            popoverImages["step51B"] === undefined
                                              ? require("../Images/drapery/roller/RegularRoll1a.jpg")
                                              : popoverImages["step51B"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("RollType_help_7")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/RegularRoll1a.jpg")}
                                              text="step51B"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/RegularRoll2.jpg")}
                                              text="step51B"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("RollType_help_2")}
                          </li>
                          <li>{t("RollType_help_3")}</li>
                        </ul>
                      </div>
                      <div className="help_column help_right_column help_right_column_mount_type">
                        <p className="help_column_header">{t("RollType_help_4")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      aria-label="imgCamera4"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 4">
                                        <img
                                          src={
                                            popoverImages["step51C"] === undefined
                                              ? require("../Images/drapery/roller/ReverseRoll1a.jpg")
                                              : popoverImages["step51C"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("RollType_help_8")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/ReverseRoll1a.jpg")}
                                              text="step51C"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/ReverseRoll2.jpg")}
                                              text="step51C"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("RollType_help_5")}
                          </li>
                          <li>{t("RollType_help_6")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5B */}
            <Card className={step5 === "Exposed" && step2 !== "HiddenMoulding" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("5")) === -1 &&
                  !accordionActiveKey.startsWith("5")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="5B"
                  stepNum={t("5B")}
                  stepTitle={t("roller_step5B")}
                  stepRef="5B"
                  type="1"
                  required={requiredStep["5B"]}
                  stepSelected={
                    stepSelectedLabel["5B"] === undefined ? "" : stepSelectedLabel["5B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5B">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bracket_type_round.png")}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BracketType1")}
                        value="1"
                        name="step5B"
                        ref-num="5B"
                        id="5B1"
                        checked={step5B === "Round Edge"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep5B("Round Edge");
                          setBracketTypeId(12701);
                          setDeps("", "5B");
                          setCart("BracketType", "Round Edge");
                        }}
                        ref={(ref) => (inputs.current["5B1"] = ref)}
                      />
                      <label htmlFor="5B1">{t("BracketType1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bracket_type_square.png")}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BracketType2")}
                        value="2"
                        name="step5B"
                        ref-num="5B"
                        id="5B2"
                        checked={step5B === "Square Edge"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep5B("Square Edge");
                          setBracketTypeId(12702);
                          setDeps("", "5B");
                          setCart("BracketType", "Square Edge");
                        }}
                        ref={(ref) => (inputs.current["5B2"] = ref)}
                      />
                      <label htmlFor="5B2">{t("BracketType2")}</label>
                    </div>
                    <NextStep currentStep="5B" eventKey="5C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5C */}
            <Card className={step5 === "Exposed" && step2 !== "HiddenMoulding" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("5")) === -1 &&
                  !accordionActiveKey.startsWith("5")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="5C"
                  stepNum={t("5C")}
                  stepTitle={t("roller_step5C")}
                  stepRef="5C"
                  type="1"
                  required={requiredStep["5C"]}
                  stepSelected={
                    stepSelectedLabel["5C"] === undefined ? "" : stepSelectedLabel["5C"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5C">
                <Card.Body>
                  <div className="card_body card_body_radio bracket_color">
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor1")}
                            value="1"
                            name="step5C"
                            ref-num="5C"
                            id="5C1"
                            outline="true"
                            checked={step5C === "Satin Brass"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5C("Satin Brass");
                              setBracketColorId(12801);
                              setDeps("", "5C,999");
                              setCart("BracketColor", "Satin Brass");
                            }}
                            ref={(ref) => (inputs.current["5C1"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/oldbrass.png")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor1")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor2")}
                            value="2"
                            name="step5C"
                            ref-num="5C"
                            id="5C2"
                            outline="true"
                            checked={step5C === "Satin Nickel"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5C("Satin Nickel");
                              setBracketColorId(12802);
                              setDeps("", "5C,999");
                              setCart("BracketColor", "Satin Nickel");
                            }}
                            ref={(ref) => (inputs.current["5C2"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/naturalaluminium.png")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor2")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor3")}
                            value="3"
                            name="step5C"
                            ref-num="5C"
                            id="5C3"
                            outline="true"
                            checked={step5C === "Gun Metal"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5C("Gun Metal");
                              setBracketColorId(12803);
                              setDeps("", "5C,999");
                              setCart("BracketColor", "Gun Metal");
                            }}
                            ref={(ref) => (inputs.current["5C3"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/blacknickel.png")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor3")}</h1>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("5")) === -1 ? "5" : "5C"
                      }
                      eventKey="6"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle text-center">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera6"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image_two clearfix">
                                        <img
                                          src={
                                            popoverImages["step53"] === undefined
                                              ? pageLanguage === "fa"
                                                ? require("../Images/drapery/zebra/bracketnewfarsi.png")
                                                : require("../Images/drapery/zebra/bracketnewenglish.png")
                                              : popoverImages["step53"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("bracketColor_help")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* نحوه قرار گیری ارک */}
            {/* step 5Arc */}
            <Card className={step2 === "HiddenMoulding" ? "" : "noDisplay"}>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="5"
                  stepNum={t("5")}
                  stepTitle={t("roller_step5A")}
                  stepRef="5Arc"
                  type="1"
                  required={requiredStep["5Arc"]}
                  stepSelected={
                    stepSelectedLabel["5Arc"] === undefined ? "" : stepSelectedLabel["5Arc"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_regular.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("RollType1")}
                        value="1"
                        name="step5Arc"
                        ref-num="5Arc"
                        id="5Arc1"
                        checked={step5Arc === "Standard"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep5Arc("Standard");
                          setRollTypeId(12501);
                          setDeps("", "5Arc");
                          setCart("RollType", "Standard");
                        }}
                        ref={(ref) => (inputs.current["5Arc1"] = ref)}
                      />
                      <label htmlFor="5Arc1">{t("RollType1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/roll_reverse.svg").default}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("RollType2")}
                        value="2"
                        name="step5Arc"
                        ref-num="5Arc"
                        id="5Arc2"
                        checked={step5Arc === "Reverse"}
                        onChange={(e) => {
                          selectChanged(e);
                          setRollTypeId(12502);
                          setStep5Arc("Reverse");
                          setDeps("", "5Arc");
                          setCart("RollType", "Reverse");
                        }}
                        ref={(ref) => (inputs.current["5Arc2"] = ref)}
                      />
                      <label htmlFor="5Arc2">{t("RollType2")}</label>
                    </div>
                    <NextStep currentStep="5Arc" eventKey="5A">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column help_left_column_mount_type">
                        <p className="help_column_header">{t("RollType_help_1")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera7"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 5">
                                        <img
                                          src={
                                            popoverImages["step51A"] === undefined
                                              ? require("../Images/drapery/roller/RegularRoll1a.jpg")
                                              : popoverImages["step51A"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("RollType_help_7")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/RegularRoll1a.jpg")}
                                              text="step51A"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/RegularRoll2.jpg")}
                                              text="step51A"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("RollType_help_2")}
                          </li>
                          <li>{t("RollType_help_3")}</li>
                        </ul>
                      </div>
                      <div className="help_column help_right_column help_right_column_mount_type">
                        <p className="help_column_header">{t("RollType_help_4")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera8"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 6">
                                        <img
                                          src={
                                            popoverImages["step51"] === undefined
                                              ? require("../Images/drapery/roller/ReverseRoll1a.jpg")
                                              : popoverImages["step51"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("RollType_help_8")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/ReverseRoll1a.jpg")}
                                              text="step51"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/ReverseRoll2.jpg")}
                                              text="step51"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("RollType_help_5")}
                          </li>
                          <li>{t("RollType_help_6")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5AArc */}
            <Card className={step2 === "HiddenMoulding" && step5Arc !== "" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("5")) === -1 &&
                  !accordionActiveKey.startsWith("5")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="5A"
                  stepNum={t("5A")}
                  stepTitle={t("roller_step5B")}
                  stepRef="5AArc"
                  type="1"
                  required={requiredStep["5AArc"]}
                  stepSelected={
                    stepSelectedLabel["5AArc"] === undefined ? "" : stepSelectedLabel["5AArc"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5A">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bracket_type_round.png")}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BracketType1")}
                        value="1"
                        name="step5AArc"
                        ref-num="5AArc"
                        id="5AArc1"
                        checked={step5AArc === "Round Edge"}
                        onChange={(e) => {
                          selectChanged(e);
                          setBracketTypeId(12701);
                          setStep5AArc("Round Edge");
                          setDeps("", "5AArc");
                          setCart("BracketType", "Round Edge");
                        }}
                        ref={(ref) => (inputs.current["5AArc1"] = ref)}
                      />
                      <label htmlFor="5AArc1">{t("BracketType1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bracket_type_square.png")}
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BracketType2")}
                        value="2"
                        name="step5AArc"
                        ref-num="5AArc"
                        id="5AArc2"
                        checked={step5AArc === "Square Edge"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep5AArc("Square Edge");
                          setBracketTypeId(12702);
                          setDeps("", "5AArc");
                          setCart("BracketType", "Square Edge");
                        }}
                        ref={(ref) => (inputs.current["5AArc2"] = ref)}
                      />
                      <label htmlFor="5AArc2">{t("BracketType2")}</label>
                    </div>
                    <NextStep currentStep="5AArc" eventKey="5B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5BArc */}
            <Card className={step2 === "HiddenMoulding" && step5Arc !== "" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("5")) === -1 &&
                  !accordionActiveKey.startsWith("5")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="5B"
                  stepNum={t("5B")}
                  stepTitle={t("roller_step5C")}
                  stepRef="5BArc"
                  type="1"
                  required={requiredStep["5BArc"]}
                  stepSelected={
                    stepSelectedLabel["5BArc"] === undefined ? "" : stepSelectedLabel["5BArc"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5B">
                <Card.Body>
                  <div className="card_body card_body_radio bracket_color">
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor1")}
                            value="1"
                            name="step5BArc"
                            ref-num="5BArc"
                            id="5BArc1"
                            outline="true"
                            checked={step5BArc === "Satin Brass"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5BArc("Satin Brass");
                              setBracketColorId(12801);
                              setDeps("", "5BArc");
                              setCart("BracketColor", "Satin Brass");
                            }}
                            ref={(ref) => (inputs.current["5BArc1"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/SatinBrass.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor1")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor2")}
                            value="2"
                            name="step5BArc"
                            ref-num="5BArc"
                            id="5BArc2"
                            outline="true"
                            checked={step5BArc === "Satin Nickel"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5BArc("Satin Nickel");
                              setBracketColorId(12802);
                              setDeps("", "5BArc");
                              setCart("BracketColor", "Satin Nickel");
                            }}
                            ref={(ref) => (inputs.current["5BArc2"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/SatinNickel.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1> {t("BracketColor2")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor3")}
                            value="3"
                            name="step5BArc"
                            ref-num="5BArc"
                            id="5BArc3"
                            outline="true"
                            checked={step5BArc === "Gun Metal"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep5BArc("Gun Metal");
                              setBracketColorId(12803);
                              setDeps("", "5BArc");
                              setCart("BracketColor", "Gun Metal");
                            }}
                            ref={(ref) => (inputs.current["5BArc2"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/GunMetal.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor3")}</h1>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("5")) === -1 ? "5" : "5BArc"
                      }
                      eventKey="6"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle text-center">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera9"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image_two clearfix">
                                        <img
                                          src={
                                            popoverImages["step52"] === undefined
                                              ? pageLanguage === "fa"
                                                ? require("../Images/drapery/zebra/bracketnewfarsi.png")
                                                : require("../Images/drapery/zebra/bracketnewenglish.png")
                                              : popoverImages["step52"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      {/* <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          <h2>{t("BottomBarStyle_help_5")}</h2>
                                          <h3>{t("BottomBarStyle_help_5.5")}</h3>
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/BracketColorRound1.jpg")}
                                              text="step52"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/BracketColorSquare1.jpg")}
                                              text="step52"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div> */}
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("bracketColor_help")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 6 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="6"
                  stepNum={t("6")}
                  stepTitle={t("roller_step6")}
                  stepRef="6"
                  type="1"
                  required={requiredStep["6"]}
                  stepSelected={stepSelectedLabel["6"] === undefined ? "" : stepSelectedLabel["6"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="6">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_4">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/Standard.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_HemStyle1")}
                        value="1"
                        name="step6"
                        ref-num="6"
                        id="61"
                        checked={step6 === "Straight"}
                        onChange={(e) => {
                          setStep6("Straight");
                          setHemStyleId(null);
                          setDeps("6A", "6");
                          setCart("HemStyle", "Straight");
                          setHemStyleNextStep("6A");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["61"] = ref)}
                      />
                      <label htmlFor="61">{t("roller_HemStyle1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/Scallop.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_HemStyle2.5")}
                        value="2"
                        name="step6"
                        ref-num="6"
                        id="62"
                        checked={step6 === "Scallop"}
                        onChange={(e) => {
                          setStepSelectedLabel(prev => {
                            const newObj = { ...prev };
                            delete newObj["6A"];
                            return newObj;
                          });
                          setStep6("Scallop");
                          setHemStyleId("900001");
                          setStep6A("");
                          setDeps("", "6,6A");
                          setCart("HemStyle", "Scallop", "BottomBarStyle");
                          setHemStyleNextStep("7");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["62"] = ref)}
                      />

                      <label htmlFor="62">
                        {t("roller_HemStyle2.5")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["4"]
                            ? modelAccessories["4"]["6"]
                              ? GetPrice(
                                  modelAccessories["4"]["6"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/Wave.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_HemStyle3")}
                        value="3"
                        name="step6"
                        ref-num="6"
                        id="63"
                        checked={step6 === "Wave"}
                        onChange={(e) => {
                          setStepSelectedLabel(prev => {
                            const newObj = { ...prev };
                            delete newObj["6A"];
                            return newObj;
                          });
                          setStep6("Wave");
                          setHemStyleId("900002");
                          setStep6A("");
                          setDeps("", "6,6A");
                          setCart("HemStyle", "Wave", "BottomBarStyle");
                          setHemStyleNextStep("7");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["63"] = ref)}
                      />
                      <label htmlFor="63">
                        {t("roller_HemStyle3")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["4"]
                            ? modelAccessories["4"]["7"]
                              ? GetPrice(
                                  modelAccessories["4"]["7"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/Colonial.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("roller_HemStyle4")}
                        value="4"
                        name="step6"
                        ref-num="6"
                        id="64"
                        checked={step6 === "Traditional"}
                        onChange={(e) => {
                          setStepSelectedLabel(prev => {
                            const newObj = { ...prev };
                            delete newObj["6A"];
                            return newObj;
                          });
                          setStep6("Traditional");
                          setHemStyleId("900003");
                          setStep6A("");
                          setDeps("", "6,6A");
                          setCart("HemStyle", "Traditional", "BottomBarStyle");
                          setHemStyleNextStep("7");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["64"] = ref)}
                      />
                      <label htmlFor="64">
                        {t("roller_HemStyle4")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["4"]
                            ? modelAccessories["4"]["9"]
                              ? GetPrice(
                                  modelAccessories["4"]["9"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <NextStep currentStep="6" eventKey={hemStyleNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            <div className="measurementsHelp_link text-center">
                              {t("hemStyleHelp_dual_roller")}
                              <span
                                className="link_between_text"
                                onClick={(e) => modalHandleShow("hemStyleHelp")}
                              >
                                {t("headrailHelp.2")}
                              </span>
                              {t("headrailHelp.3")}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 6A */}
            <Card className={step6 === "Straight" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("6")) === -1 &&
                  !accordionActiveKey.startsWith("6")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="6A"
                  stepNum={t("6A")}
                  stepTitle={t("roller_step6A")}
                  stepRef="6A"
                  type="1"
                  required={requiredStep["6A"]}
                  stepSelected={
                    stepSelectedLabel["6A"] === undefined ? "" : stepSelectedLabel["6A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="6A">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bottom_bar_sewn_in.png")}
                        className="img-fluid half_margin special_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BottomBarStyle1")}
                        value="1"
                        name="step6A"
                        ref-num="6A"
                        id="6A1"
                        checked={step6A === "Sewn-In"}
                        onChange={(e) => {
                          selectChanged(e);
                          setStep6A("Sewn-In");
                          setBottomBarStyleId(null);
                          setDeps("", "6A");
                          setCart("BottomBarStyle", "Sewn-In");
                        }}
                        ref={(ref) => (inputs.current["6A1"] = ref)}
                      />
                      <label htmlFor="6A1">{t("BottomBarStyle1")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={require("../Images/drapery/roller/bottom_bar_exposed_designer.png")}
                        className="img-fluid half_margin special_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("BottomBarStyle2")}
                        value="2"
                        name="step6A"
                        ref-num="6A"
                        id="6A2"
                        checked={step6A === "Decorative Metal Bar"}
                        onChange={(e) => {
                          selectChanged(e);
                          setBottomBarStyleId("900007");
                          setStep6A("Decorative Metal Bar");
                          setDeps("", "6A");
                          setCart("BottomBarStyle", "Decorative Metal Bar");
                        }}
                        ref={(ref) => (inputs.current["6A2"] = ref)}
                      />
                      <label htmlFor="6A2">
                        {t("BottomBarStyle2")}
                        <br />
                        <p className="surcharge_price">
                          {Object.keys(modelAccessories).length !== 0
                            ? t("Add ")
                            : t("Surcharge Applies")}
                          {modelAccessories["6"]
                            ? modelAccessories["6"]["13"]
                              ? GetPrice(
                                  modelAccessories["6"]["13"]["Price"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )
                              : null
                            : null}
                        </p>
                      </label>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("6")) === -1 ? "6" : "6A"
                      }
                      eventKey="7"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column help_left_column_mount_type">
                        <p className="help_column_header">{t("BottomBarStyle_help_1")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 8">
                                        <img
                                          src={
                                            popoverImages["step61"] === undefined
                                              ? require("../Images/drapery/roller/SewnIn.jpg")
                                              : popoverImages["step61"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          <h2>{t("BottomBarStyle_help_5")}</h2>
                                          <h3>{t("BottomBarStyle_help_5.5")}</h3>
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/SewnIn.jpg")}
                                              text="step61"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("BottomBarStyle_help_2")}
                          </li>
                        </ul>
                      </div>
                      <div className="help_column help_right_column help_right_column_mount_type">
                        <p className="help_column_header">{t("BottomBarStyle_help_3")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                       aria-label="imgCamera"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix 9">
                                        <img
                                          src={
                                            popoverImages["step61B"] === undefined
                                              ? require("../Images/drapery/roller/designer.jpg")
                                              : popoverImages["step61B"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("BottomBarStyle_help_6")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/roller/designer.jpg")}
                                              text="step61B"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("BottomBarStyle_help_4")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 7 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="7"
                  stepNum={t("7")}
                  stepTitle={t("zebra_step6")}
                  stepRef="7"
                  type="2"
                  required={requiredStep["7"]}
                  stepSelected={stepSelectedLabel["7"] === undefined ? "" : stepSelectedLabel["7"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box100 selectInput_section">
                      <div className="room_select">
                        <label className="select_label">{t("Room")}</label>
                        <div className="select_container">
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedRoomLabel}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdownWithSearch
                                props={props}
                                state={state}
                                methods={methods}
                              />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControl props={props} state={state} methods={methods} />
                            )}
                            onChange={(selected) => {
                              if (selected[0] !== undefined) {
                                setDeps("", "71");
                                roomLabelChanged(selected[0], "7", false);
                                setSelectedRoomLabel(selected);
                                setCart(
                                  "RoomNameFa",
                                  rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                                  "",
                                  "RoomNameEn",
                                  [selected[0].value]
                                );
                              }
                            }}
                            options={rooms[pageLanguage]}
                          />
                        </div>
                      </div>
                      <div className="room_select">
                        <label className="select_label">{t("Window Description")}</label>
                        <DebounceInput
                          debounceTimeout={1500}
                          onKeyDown={() => setCartLoading(true)}
                          type="text"
                          placeholder={t("E.g. Bedroom east wall")}
                          className="form-control window_name"
                          name="order_window_name"
                          value={roomLabelText}
                          onChange={(e) => {
                            if (e.target.value === "") setDeps("72", "");
                            else setDeps("", "72");
                            roomLabelChanged(capitalizeWordsText(e.target.value), "7", true);
                            setRoomLabelText(capitalizeWordsText(e.target.value));
                            setCart("WindowName", capitalizeWordsText(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                    <div className="box100 upload_section">
                      <div
                        className="big_box big_box-new"
                        onDragOver={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onDrop={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                            setSelectedFile(e.dataTransfer.files[0]);
                            setSelectedFileName(e.dataTransfer.files[0].name);
                            setEditedFileName(e.dataTransfer.files[0].name);
                          }
                        }}
                        style={{
                          border: "0.09375rem solid #aaa",
                          height: detailsShow ? "8.5rem" : "3rem",
                          margin: "1.25rem auto",
                          width: "85%",
                          display: "inline-flex",
                          position: "relative",
                          transition: "height 0.3s ease",
                        }}
                      >
                        <div
                          className="upload_button_displayer"
                          onClick={() => {
                            if (detailsShow) setDetailsShow(false);
                            else setDetailsShow(true);
                          }}
                        >
                          <p
                            className="d-flex align-items-center"
                            style={{
                              position: "absolute",
                              top: "0.8rem",
                              left: "0.5rem",
                              right: "0.5rem",
                              width: "100%",
                              zIndex: "2",
                              cursor: "pointer",
                            }}
                          >
                            <span className="details-label unselectable">
                              {detailsShow ? t("room Hide Details") : t("Add Room Image")}
                           
                              {!detailsShow && (
                                 <span className="optional-text">{t("(Optional)")}  </span>
                            )}
                            </span>
                            <span className="details_indicator">
                              {detailsShow && (
                                <img
                                  className="arrow_down img-fluid"
                                  src={require("../Images/public/arrow_up.svg").default}
                                  alt=""
                                />
                              )}
                              {!detailsShow && (
                                <img
                                  className="arrow_down img-fluid"
                                  src={require("../Images/public/arrow_down.svg").default}
                                  alt=""
                                />
                              )}
                            </span>
                          </p>
                        </div>

                        <div
                          className="uploaded_images_section"
                          style={{
                            display: detailsShow ? "block" : "none",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100%",
                            textAlign: "center",
                          }}
                        ></div>

                        <MultipleFileUpload
                          ref={multipleFileUploadRef}
                          baseURLUploadPdf={baseURLUploadPdf}
                          baseURLUploadImg={baseURLUploadImg}
                          addUploadFileUrl={addUploadFileUrl} // تابع موجود شما
                          maxSizeMB={5} // حداکثر حجم بر حسب مگابایت
                          acceptedFormats={[
                            "image/jpeg",
                            "image/png",
                            "image/gif",
                            "application/pdf",
                          ]}
                          t={t}
                          detailsShow={detailsShow}
                          setUploadedImages={setUploadedImages}
                          setUploadedPDFs={setUploadedPDFs}
                          addFailedFileToParent={addFailedFileToParent}
                          onFilesChange={setUploadingFiles}
                        />

                        {detailsShow && (
                          <p
                            className="d-flex text-muted"
                            style={{
                              position: "absolute",
                              bottom: "0.5rem",
                              width: "100%",
                              fontSize: "0.8rem",
                              padding: "0 0.6rem",
                              direction: pageLanguage === "fa" ? "rtl" : "ltr",
                            }}
                          >
                            {t("JPG, PNG, GIF, PDF. Maximum file size 5MB.")}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      className={`box100 hidden_upload_section ${
                        detailsShow ? "show_upload_section" : ""
                      }`}
                    ></div>
                    <div className="box100 uploaded_name_section">
                      <div className="mid_upload">
                        {allFilesSorted.length > 0 && (
                          <UploadedFilesList
                            files={allFilesSorted}
                            onDelete={handleDeleteFile2}
                            formatFileSize={formatFileSize}
                            pageLanguage={pageLanguage}
                          />
                        )}
                      </div>
                    </div>
                    <div className="more_info_section">
                      <div className="more_info_container">
                        <h3 className="more_info_title">{t("Anything else we need to know?")}</h3>
                        <div className="more_info_desc">
                          <p>{t("orderNotes1")}</p>
                        </div>
                      </div>
                      <div className="more_info_input_container">
                        <DebounceInput
                          debounceTimeout={1500}
                          onKeyDown={() => setCartLoading(true)}
                          className="more_info_input"
                          type="text"
                          name="more_info_input"
                          value={moreInfoInput}
                          placeholder=""
                          onChange={(e) => {
                            setTimeout(() => {
                              setCart("moreInfoInput", e.target.value);
                              setMoreInfoInput(e.target.value);
                            }, 300);
                          }}
                        />
                      </div>
                    </div>
                    <NextStep currentStep="7" eventKey="8">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className=" accordion_help">
                    <div className=" help_container">
                      <div className=" help_column help_left_column">
                        <p className=" help_column_header">{t("step6_help_1")}</p>
                        <ul className=" help_column_list">
                          <li className=" no_listStyle">{t("step6_help_2")}</li>
                        </ul>
                      </div>
                      <div className=" help_column help_right_column">
                        <p className=" help_column_header">{t("step6_help_3")}</p>
                        <ul className=" help_column_list">
                          <li className=" no_listStyle">{t("step6_help_4")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 8 */}
            <Card className={accordionActiveKey === "" ? "card_little_margin" : "card_big_margin"}>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="8"
                  stepNum={t("8")}
                  stepTitle={t("zebra_step7")}
                  stepTitle2={t("(Optional)")}
                  stepRef="8"
                  type="2"
                  required={false}
                  stepSelected={stepSelectedLabel["8"] === undefined ? "" : stepSelectedLabel["8"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="8">
                <Card.Body>
                  <div className="card_body card_body_zipcode">
                    <div className="zipcode_bag_section">
                      <div className="zipcode_section_container">
                        <div className="zipcode_text zipcode_section_title_container">
                          <img
                            src={require("../Images/public/W_truck.png")}
                            alt=""
                            className="img-fluid"
                          />
                          <h3>{t("zipcode_text1")}</h3>
                        </div>
                        {hasZipcode === "" && (
                          <h3 className="zipcode_text">{t("zipcode_text1.5")}</h3>
                        )}

                        {hasZipcode === "" && (
                          <div className="zipcode_dropdown_div_container">
                            <div className="zipcode_input_container" style={{gap: "0.5rem"}}>
                              <input
                                className="form-control"
                                type="text"
                                name="zipcode_input"
                                value={zipcode}
                                placeholder={t("Enter Zip Code")}
                                onChange={(e) => {
                                  setZipcode(e.target.value.replace(/\D+/g, ""));
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    measureWindowSize(zipcode);
                                  }
                                }}
                              />
                              <button
                                className="zipcode_input_button white_btn"
                                onClick={() => {
                                  measureWindowSize(zipcode);
                                }}
                              >
                                <div>   
                                  {t("UPDATE")}
                                </div>
                              </button>
                            </div>
                          </div>
                        )}
                        {zipcodeButton && hasZipcode === "" && (
                          <h3
                            className={`${
                              hasInstall === false ? "zipcode_text4" : "zipcode_text2"
                            }`}
                          >
                            {zipcodeButton && hasInstall === false && t("zipcode_text2")}
                            {zipcodeButton && hasInstall && hasZipcode === "" && t("zipcode_text3")}
                            {zipcodeButton &&
                              hasInstall &&
                              hasZipcode !== "" &&
                              installPrice === -1 &&
                              t("zipcode_text3")}
                          </h3>
                        )}
                        {zipcodeButton && hasInstall && installPrice === -1 && (
                          <h3 className="zipcode_text">{t("zipcode_text8")}</h3>
                        )}
                        {zipcodeButton &&
                          hasInstall &&
                          !!installPrice &&
                          installPrice !== -1 &&
                          hasZipcode === "" && (
                            <div className="zipcode_available_container">
                              <div className="checkbox_style">
                                <input
                                  type="checkbox"
                                  value="1"
                                  name="zipcode"
                                  disabled={addingLoading}
                                  checked={zipcodeChecked === "true"}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setZipcodeChecked("true");
                                      setCart("ZipCode", zipcode);
                                    } else {
                                      setZipcodeChecked("false");
                                      setCart("", "", "ZipCode");
                                    }
                                  }}
                                  id="zipcode"
                                  ref={(ref) => (inputs.current["zipcode"] = ref)}
                                />
                                <label htmlFor="zipcode" className="checkbox_label">
                                  <img
                                    className="checkbox_label_img checkmark1 img-fluid"
                                    src={require("../Images/public/checkmark1_checkbox.png")}
                                    alt=""
                                  />
                                </label>
                                <span className="checkbox_text">
                                  {t("zipcode_text4")}
                                  {GetPrice(
                                    installPrice,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                  {t("zipcode_text5")}
                                  <br />
                                  {t("zipcode_text5.5")}
                                  {GetPrice(
                                    transportPrice,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                  {t("zipcode_text6")}
                                </span>
                              </div>
                              {/*<h3 className="zipcode_text3">{t("zipcode_text7")}</h3>*/}
                            </div>
                          )}
                        {installPrice !== -1 && hasZipcode && hasZipcode !== "" && (
                          <div className="checkbox_style checkbox_style_hasZipcode">
                            <input
                              type="checkbox"
                              value="1"
                              name="zipcode"
                              disabled={addingLoading}
                              checked={zipcodeChecked === "true"}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setZipcodeChecked("true");
                                  setCart("ZipCode", zipcode);
                                } else {
                                  setZipcodeChecked("false");
                                  setCart("", "", "ZipCode");
                                }
                              }}
                              id="zipcode"
                              ref={(ref) => (inputs.current["zipcode"] = ref)}
                            />
                            <label htmlFor="zipcode" className="checkbox_label">
                              <img
                                className="checkbox_label_img checkmark1 img-fluid"
                                src={require("../Images/public/checkmark1_checkbox.png")}
                                alt=""
                              />
                            </label>
                            <span className="checkbox_text">
                              {t("zipcode_text4")}
                              {GetPrice(installPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                              {t("zipcode_text5")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className=" accordion_help">
                    <div className=" help_container">
                      <div className=" help_column help_left_column">
                        <p className=" help_column_header" />
                        <ul className=" help_column_list">
                          <li>{t("stepZip_help_1")}</li>
                          <li>{t("stepZip_help_2")}</li>
                          <li>
                            {t("stepZip_help_3")}
                            <h5
                              className="text_underline pointer"
                              onClick={() => modalHandleShow("Zipcode_how_it_works")}
                            >
                              {t("zipcode_measure_verify")}
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <div className="CustomModelFooter_visible_part">
            <div className="bag_buttons_section_container">
              <button
                className="btn add_to_cart"
                disabled={addingLoading || cartLoading}
                onClick={() => {
                  setAddingLoading(true);
                  addToCart();
                }}
              >
                {addingLoading ? t("ADDING...") : t("footer_Add To Cart")}
              </button>
              <button className="btn add_to_cart no_pointer">
                {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
              </button>
              <button
                className="save_to_acc white_btn btn"
                onClick={() => {
                  if (roomLabelText !== "" && selectedRoomLabel.length) {
                    setSavingLoading(true);
                    if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa,
                        projectData
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            console.log("project not saved!");
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          // console.log("hi2");
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    } else {
                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            console.log("hi1");
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            console.log("project not saved!");
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          // console.log("hi1");
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    }
                  } else {
                    setProjectModalState(0);
                    modalHandleShow("add_to_project_modal");
                  }
                }}
                disabled={savingLoading || cartLoading}
              >
                {savingLoading ? t("SAVING...") : t("footer_Save To")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}

      <div
        className={
          filtersShow
            ? "filters_container filters_container_mob_show mobile_only"
            : "filters_container mobile_only"
        }
      >
        <div className="nav_header">
          <div className="nav_header_bottom nav_header_bottom_single">
            <div className="close_menu_icon" onClick={() => setFiltersShow(false)}>
              <img
                src={require("../Images/public/close-button.png")}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
        {filtersShow && (
          <div className="product_filters_container">
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Color")}
                  textOnShow={t("Color")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingColors2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Price")}
                  textOnShow={t("Price")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPrices2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Type")}
                  textOnShow={t("Type")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingTypes2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Pattern")}
                  textOnShow={t("Pattern")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPatterns2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        )}
        <div className="filter_modal_btn_section">
          <button
            className="btn btn-new-dark"
            onClick={() => {
              setIsClearAll(true);
              // setFiltersShow(false);
            }}
          >
            {t("CLEAR")}
          </button>
          <button
            className="btn white_btn"
            onClick={() => {
              setFiltersShow(false);
            }}
          >
            {t("DONE")}
          </button>
        </div>
      </div>

      <Modal
        dialogClassName={`noPower_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noPower"] === undefined ? false : modals["noPower"]}
        onHide={() => modalHandleClose("noPower")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_no power")}</p>

          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noPower")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["MountTypeWarning"] === undefined ? false : modals["MountTypeWarning"]}
        onHide={() => modalHandleClose("MountTypeWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("MountTypeWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("MountTypeWarning");
              }}
            >
              {/* {t("CANCEL_mount_type_roller")} */}
              {pageLanguage === "en" ? "CANCEL" : "ادامه سفارش"}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep2(mountTypeTemp.stepValue);
                setStep3("");
                setStep21("");
                setStep21Err1(false);
                setStep21Err3(false);
                setStep5("");
                setSelectedValanceColor1([]);
                setSelectedValanceColor2([]);
                setStep5Arc("");
                setStep5AArc("");
                setStep5BArc("");
                setStep6("");
                setStep6A("");
                setWidth("");
                setHeight("");
                setWidth1("");
                setWidth2("");
                setWidth3("");
                setHeight1("");
                setHeight2("");
                setHeight3("");
                setWidth3A("");
                setLeft("");
                setRight("");
                setWidthCart("");
                setHeightCart("");
                setHeight3C("");
                setMount("");
                setCeilingToWindow1("");
                setCeilingToWindow2("");
                setCeilingToWindow3("");
                if (
                  mountTypeTemp.stepValue === "Inside" ||
                  mountTypeTemp.stepValue === "HiddenMoulding"
                ) {
                  if (mountTypeTemp.stepValue === "HiddenMoulding") {
                    setDeps(
                      "3,21,5Arc,5AArc,5BArc,6",
                      "2,31,32,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3,5,51,5A,5B,5C,3AIn,3BIn,6A"
                    );
                  } else {
                    setDeps(
                      "3,21,5,6",
                      "2,31,32,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3,5Arc,5AArc,5BArc,51,5A,5B,5C,3AIn,3BIn,6A"
                    );
                  }
                } else {
                  setDeps(
                    "3,5,6",
                    "2,21,31,32,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3,5Arc,5AArc,5BArc,51,5A,5B,5C,3AIn,3BIn,6A"
                  );
                }
                setCart(
                  "Mount",
                  mountTypeTemp.cartValue,
                  "calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width3A,Height3C,ExtensionLeft,ExtensionRight,ShadeMount,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,Headrail,MetalValanceColor,RollType,BracketType,BracketColor,HemStyle,BottomBarStyle",
                  "again"
                );
                clearInputs(mountTypeTemp.event, undefined, "3,5,5A,5B,5C,6,6A");
                setMeasurementsNextStep("4");
                modalHandleClose("MountTypeWarning");
              }}
            >
              {/* {t("I AGREE, CONTINUE ANYWAY_ROLLER")} */}
              {pageLanguage === "en" ? "I AGREE, CONTINUE ANYWAY" : "تغییر نحوه نصب"}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`noInsideUnderstand_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noInsideUnderstand"] === undefined ? false : modals["noInsideUnderstand"]}
        onHide={() => modalHandleClose("noInsideUnderstand")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_mount")}</p>

          {/*<br/>*/}
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("noInsideUnderstand")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noMount"] === undefined ? false : modals["noMount"]}
        onHide={() => modalHandleClose("noMount")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_mount")}</p>

          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noMount")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore1"] === undefined ? false : modals["learnMore1"]}
        onHide={() => modalHandleClose("learnMore1")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore1")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore2"] === undefined ? false : modals["learnMore2"]}
        onHide={() => modalHandleClose("learnMore2")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_learn_more3")}</p>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore2")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore3"] === undefined ? false : modals["learnMore3"]}
        onHide={() => modalHandleClose("learnMore3")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore3_help1")}</li>
            <li>{t("learnMore3_help2")}</li>
            <li>{t("learnMore3_help3")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore3")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore4"] === undefined ? false : modals["learnMore4"]}
        onHide={() => modalHandleClose("learnMore4")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore4_help1")}</li>
            <li>{t("learnMore4_help2")}</li>
            <li>{t("learnMore4_help3")}</li>
            <li>{t("learnMore4_help4")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore4")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
        onHide={() => modalHandleClose("measurementsHelp")}
        scrollable={true}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p className="measurementsHelp_modal_title">{t("HOW TO MEASURE FOR ROLLER SHADES")}</p>
          <div className="help_options_container">
            <ul className="help_options">
              <li
                className={`help_option_item ${
                  helpMeasure === "Inside" ? "help_option_item_on" : ""
                }`}
                onClick={() => setHelpMeasure("Inside")}
              >
                {t("bold_Inside_mount")}
              </li>
              <li className="help_option_item_separator"></li>
              <li
                className={`help_option_item ${
                  helpMeasure === "Outside" ? "help_option_item_on" : ""
                }`}
                onClick={() => setHelpMeasure("Outside")}
              >
                {t("bold_Outside_mount")}
              </li>
              <li className="help_option_item_separator"></li>
              <li
                className={`help_option_item ${
                  helpMeasure === "HiddenMoulding" ? "help_option_item_on" : ""
                }`}
                onClick={() => setHelpMeasure("HiddenMoulding")}
              >
                {t("bold_Arc_mount")}
              </li>
            </ul>
          </div>
          {helpMeasure === "Inside" && (
            <div>
              <div className="measurementsHelp_modal_img_section">
                <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                  aria-label="imgZebra"
                  data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-inside-01.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-inside-01.svg").default
                  }
                />
              </div>
              <div className="accordion_help measurementsHelp_modal_help_section">
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("TO DETERMINE INSIDE MOUNT")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_1")}</li>
                      <li>{t("roller_modal_help_2")}</li>
                      <li>{t("modal_help_2.5")}</li>
                      <li>{t("roller_modal_help_3")}</li>
                      <li>
                        {t("Ensure-the-window")}
                      </li>
                    </ul>
                  </div>

                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("roller_modal_help_4")}</li>
                      <li>{t("roller_modal_help_5")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_right_column">
                    <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_6")}</li>
                      <li>{t("roller_modal_help_7")}</li>
                    </ul>
                  </div>
                </div>
                <br />
                <br />
                <div className="help_container">
                  <div className="help_column help_right_column">
                    <p className="help_column_header" />
                    <ul className="help_column_list">
                  
                      <li>
                        <b>{t("Note:&nbsp;")}</b>
                        {t("roller_modal_help_8")}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*<br/>*/}
          {/*<br/>*/}
          {/*<br/>*/}

          {helpMeasure === "Outside" && (
            <div>
                <div className="help_options_container">
                <ul className="help_options help_options_lengthType help_options_lengthType-zebra">
                  <li
                    className={`help_option_lengthType_item ${
                      helpMeasureLengthType === "wall" ? "help_option_lengthType_item_on" : ""
                    }`}
                    onClick={() => setHelpMeasureLengthType("wall")}
                  >
                    {t("WALL MOUNT")}
                  </li>
                  <li
                    className={`help_option_lengthType_item ${
                      helpMeasureLengthType === "ceiling" ? "help_option_lengthType_item_on" : ""
                    }`}
                    onClick={() => setHelpMeasureLengthType("ceiling")}
                  >
                    {t("CEILING MOUNT")}
                  </li>
                </ul>
              </div>
              {
                helpMeasureLengthType === "wall" &&  <div className="measurementsHelp_modal_img_section 2">
             
                <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                   aria-label="imgHelp"
                   data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-Outside-Wall-٠١.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-Outside-Wall-٠١.svg").default
                  }
                />
              </div> }
              {
                helpMeasureLengthType === "ceiling" &&  <div className="measurementsHelp_modal_img_section measurementsHelp_modal_img_section_outside_ceiling 2">
             
                <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                   aria-label="imgHelp"
                   data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-Outside-Ceiling-Width-٠١.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-Outside-Ceiling-Width-٠١.svg").default
                  }
                />
                 <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                   aria-label="imgHelp"
                   data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-Outside-Ceiling-Height-٠١.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-Outside-Ceiling-Height-٠١.svg").default
                  }
                />
              </div> }
              {
                helpMeasureLengthType === "wall" &&   <div className="accordion_help measurementsHelp_modal_help_section">
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT_WALL")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_9")}</li>
                      <li>{t("modal_help_10")}</li>
                      <li>{t("modal_help_11")}</li>
                      <li>{t("modal_help_11_new_roller")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_12")}</li>
                      <li>{t("roller_modal_help_13")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_right_column">
                    <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_14")}</li>
                      <li>{t("modal_help_15")}</li>
                      <li>{t("modal_help_15.1")}</li>
                    </ul>
                  </div>
                </div>
              </div>}
              {
                helpMeasureLengthType === "ceiling" &&   <div className="accordion_help measurementsHelp_modal_help_section">
                <div className="help_container">
                  {/* <div className="help_column help_left_column">
                    <p className="help_column_header">{t("TO DETERMINE OUTSIDE MOUNT CEILING")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_9")}</li>
                      <li>{t("modal_help_10")}</li>
                      <li>{t("modal_help_11")}</li>
                    </ul>
                  </div> */}

                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_12")}</li>
                      <li>{t("roller_modal_help_13")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_right_column">
                    <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_21-shade")}</li>
                      <li>{t("modal_help__roller")}</li>
                      <li>{t("modal_help_15.1")}</li>
                    </ul>
                  </div>
                </div>
                <br />
                <br />
                <div className="parent_help_container">
                  <div style={{width: '23%'}}></div>
                <div className="help_container">
                  <div className="help_column help_right_column">
                    <ul className="help_column_list">
                    <li>  <b>{t("Note:&nbsp;")}</b>{t("modal_help_11_new_roller")}</li>
                    </ul>
                  </div>
                </div>
                <div style={{width: '23%'}}></div>
                </div>
              </div>}
             
            </div>
          )}
          {helpMeasure === "HiddenMoulding" && (
            <div>
             <div className="measurementsHelp_modal_img_section measurementsHelp_modal_img_section_outside_ceiling" style={{marginTop:"2rem"}}>
              <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                   aria-label="imgCamera"
                   data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-Moulding-Width-٠١.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-Moulding-Width-٠١.svg").default
                  }
                />
                <object
                  className="measurementsHelp_modal_img"
                  type="image/svg+xml"
                   aria-label="imgCamera"
                   data={
                    pageLanguage === "fa"
                      ? require("../Images/drapery/zebra2/FShadeGuide-Moulding-Height-٠١.svg").default
                      : require("../Images/drapery/zebra2/ShadeGuide-Moulding-Height-٠١.svg").default
                  }
                />
              </div>
              <div className="accordion_help measurementsHelp_modal_help_section">
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("TO DETERMINE HIDDEN MOULDING MOUNT")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_16")}</li>
                      <li>{t("roller_modal_help_17")}</li>
                      <li>{t("modal_help_18")}</li>
                      <li>{t("modal_help_11_new_roller")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_left_column">
                    <p className="help_column_header">{t("STEP 1: MEASURE WIDTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_19")}</li>
                      <li>{t("roller_modal_help_20")}</li>
                    </ul>
                  </div>

                  <div className="help_column help_right_column">
                    <p className="help_column_header">{t("STEP 2: MEASURE LENGTH")}</p>
                    <ul className="help_column_list">
                      <li>{t("modal_help_21")}</li>
                      <li>{t("modal_help__roller")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <br />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("measurementsHelp")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["headrailHelp"] === undefined ? false : modals["headrailHelp"]}
        onHide={() => modalHandleClose("headrailHelp")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div className="largeSizeModal_modal_body_container">
            <div className="accordion_help help_largeSizeModal_modal">
              <p className="help_column_header">{t("headrailHelp1")}</p>
              <div className="largeSizeModal_img_plus_help">
                <img
                  src={require("../Images/drapery/roller/roller_help_NoValance.jpg")}
                  className="img-fluid"
                  alt=""
                />
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <ul className="help_column_list">
                      <li>{t("headrailHelp2")}</li>
                      <li>{t("headrailHelp3")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion_help help_largeSizeModal_modal">
              <p className="help_column_header">{t("headrailHelp13")}</p>
              <div className="largeSizeModal_img_plus_help">
                <img
                  src={require("../Images/drapery/roller/roller_help_UphosteredValance.jpg")}
                  className="img-fluid"
                  alt=""
                />
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <ul className="help_column_list">
                      <li>{t("headrailHelp14")}</li>
                      <li>{t("headrailHelp15")}</li>
                      <li>{t("headrailHelp16")}</li>
                      <li>{t("headrailHelp17")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="largeSizeModal_modal_body_container">
            <div className="accordion_help help_largeSizeModal_modal">
              <p className="help_column_header">{t("headrailHelp4")}</p>
              <div className="largeSizeModal_img_plus_help">
                <img
                  src={require("../Images/drapery/roller/roller_help_MetalValance.jpg")}
                  className="img-fluid"
                  alt=""
                />
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <ul className="help_column_list">
                      <li>{t("headrailHelp5")}</li>
                      <li>{t("headrailHelp6")}</li>
                      <li>{t("headrailHelp7")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion_help help_largeSizeModal_modal">
              <p className="help_column_header">{t("headrailHelp8")}</p>
              <div className="largeSizeModal_img_plus_help">
                <img
                  src={require("../Images/drapery/roller/roller_help_MetalValance.jpg")}
                  className="img-fluid"
                  alt=""
                />
                <div className="help_container">
                  <div className="help_column help_left_column">
                    <ul className="help_column_list">
                      <li>{t("headrailHelp9")}</li>
                      <li>{t("headrailHelp10")}</li>
                      <li>{t("headrailHelp11")}</li>
                      <li>{t("headrailHelp12")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("headrailHelp")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["hemStyleHelp"] === undefined ? false : modals["hemStyleHelp"]}
        onHide={() => modalHandleClose("hemStyleHelp")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("hemStyleHelp")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`upload_modal uploadImg_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadImg"] === undefined ? false : modals["uploadImg"]}
        onHide={() => {
          setSelectedFile(undefined);
          setSelectedFileName("");
          setEditedFileName("");
          modalHandleClose("uploadImg");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();

              const { files } = e.dataTransfer;

              if (
                files &&
                files.length &&
                (files[0].type === "image/jpg" ||
                  files[0].type === "image/jpeg" ||
                  files[0].type === "image/png")
              ) {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_img1")}</h2>
            <p className="file_size_description">{t("upload_img2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="image-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_img3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      id="image-upload-btn"
                      name="file"
                      accept="image/png,image/jpeg,image/jpg"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const { files } = e.dataTransfer;

                        if (
                          files &&
                          files.length &&
                          (files[0].type === "image/jpg" ||
                            files[0].type === "image/jpeg" ||
                            files[0].type === "image/png")
                        ) {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_img5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_img4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadImg");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(2);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload Image")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`upload_modal uploadPdf_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadPdf"] === undefined ? false : modals["uploadPdf"]}
        onHide={() => {
          modalHandleClose("uploadPdf");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();

              const { files } = e.dataTransfer;

              if (files && files.length && files[0].type === "application/pdf") {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_pdf1")}</h2>
            <p className="file_size_description">{t("upload_pdf2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="file-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_pdf3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      name="file"
                      id="file-upload-btn"
                      accept="application/pdf"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const { files } = e.dataTransfer;

                        if (files && files.length && files[0].type === "application/pdf") {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_pdf5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_pdf4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadPdf");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(1);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload PDF")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["widthDifferent"] === undefined ? false : modals["widthDifferent"]}
        onHide={() => {
          modalHandleClose("widthDifferent");
        }}
      >
        <Modal.Header>
          {/*<div className="required"/>*/}
          <p>{t("WIDTH DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("WIDTH DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("WIDTH DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("WIDTH DISCREPANCIES_2.2")}
            </Link>
            {t("WIDTH DISCREPANCIES_2.3")}
          </p>
          <p>{t("WIDTH DISCREPANCIES4")}</p>
          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "WidthDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("widthDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("widthDifferent");
                setAccordionActiveKey("3B");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`addToCartErr bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["addToCartErr"] === undefined ? false : modals["addToCartErr"]}
        onHide={() => {
          modalHandleClose("addToCartErr");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal-header-grommet">
            {pageLanguage === "fa"
              ? "برای ادامه نیاز است مراحل زیر را تکمیل کنید:"
              : "PLEASE COMPLETE THE FOLLOWING:"}
          </div>
          <ul
            className={`addToCartErr_list_new ${
              pageLanguage === "fa" ? "addToCartErr_list_font_farsi" : ""
            }`}
          >
            {addCartErr}
          </ul>
          <br />
          <span>{t("addToCartErr1")}</span>
          {/*<span>{t("addToCartErr2")}</span>*/}
          <span>{t("addToCartErr3")}</span>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("addToCartErr")}>
              {t("OK")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        keyboard={false}
        dialogClassName={`Zipcode_how_it_works customSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["Zipcode_how_it_works"] === undefined ? false : modals["Zipcode_how_it_works"]}
        onHide={() => {
          modalHandleClose("Zipcode_how_it_works");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="zipcode_modal_title_container">
            <h1 className="zipcode_modal_title">{t("zipcode_modal_text1")}</h1>
          </div>
          <div className="zipcode_modal_body">
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_bag.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text2")}</div>
              <div
                className={`zipcode_modal_item_text_container ${
                  pageLanguage === "fa" ? "font_farsi" : ""
                }`}
              >
                {t("zipcode_modal_text3")}
              </div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_mark.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text4")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text5")}</div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_truck.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text6")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text7")}</div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_tools.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text8")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text9")}</div>
            </div>
          </div>
          <div className="zipcode_modal_footer">
            <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text10")}</div>
          </div>

          {/*<br/>*/}
          {/*<div className="text_center">*/}
          {/*    <button className="btn btn-new-dark" onClick={() => modalHandleClose("Zipcode_how_it_works")}>{t("OK")}</button>*/}
          {/*</div>*/}
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["heightDifferent"] === undefined ? false : modals["heightDifferent"]}
        onHide={() => {
          modalHandleClose("heightDifferent");
        }}
      >
        <Modal.Header>
          {/*<div className="required"/>*/}
          <p>{t("HEIGHT DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("HEIGHT DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("HEIGHT DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("HEIGHT DISCREPANCIES_2.2")}
            </Link>
            {t("HEIGHT DISCREPANCIES_2.3")}
          </p>
          <p>{t("HEIGHT DISCREPANCIES4")}</p>
          <br />

          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "HeightDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("heightDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("heightDifferent");
                setAccordionActiveKey("4");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }}
        id="cart_modal"
      >
        {cartStateAgree && (
          <div className="custom_cart_header_desc">{`${
            freeShipPrice - sideCartPrice > 0
              ? `${t("cart_agree_free_ship1")}${
                  pageLanguage === "fa"
                    ? NumberToPersianWord.convertEnToPe(
                        `${GetPrice(
                          freeShipPrice - sideCartPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}`
                      )
                    : GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )
                }${t("cart_agree_free_ship2")}`
              : `${t("cart_agree_free_ship")}`
          }`}</div>
        )}
        <Modal.Header>
          {cartStateAgree && (
            <span className="custom_cart_title">
              {t("My Bag")}{" "}
              <h3>
                (
                {pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                  : cartCount}
                )
              </h3>
            </span>
          )}
          {!cartStateAgree && <p className="custom_cart_title">&nbsp;</p>}
          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              setCartStateAgree(false);
              setAddingLoading(false);
              sessionStorage.clear();
              if (cartStateAgree) {
                  navigate("/" + pageLanguage);
              }
            }}
          >
            {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div ref={modalTopRef}>
            <p></p>
          </div>
          {cartStateAgree && (
            <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
          )}

          {!cartStateAgree && <h1 className="cart_agree_title1">{t("REVIEW ORDER")}</h1>}
          {!cartStateAgree && <h2 className="cart_agree_title2">{t("TERMS OF SALE")}</h2>}
          {!cartStateAgree && <div>{cartAgree}</div>}
          {!cartStateAgree && (
            <span className="cart_agree_desc">
              <label className="checkbox_style">
                <input
                  type="checkbox"
                  checked={cartAgreeDescription}
                  onChange={(e) => {
                    setCartAgreeDescription(e.target.checked);
                  }}
                  id="cartAgreeDescription"
                />
                <label htmlFor="cartAgreeDescription" className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                <span className="checkbox_text">{t("cart_agree_desc")}</span>
              </label>
            </span>
          )}
          {!cartStateAgree && (
            <div className="go_to_checkout">
              <button
                className="basket_checkout"
                onClick={() => {
                  setAddingLoading(true);
                  addToCart_agreed();
                  topScroll();
                }}
                disabled={addingLoading || !cartAgreeDescription}
              >
                {addingLoading ? t("ADDING...") : t("AGREE & ADD TO BAG")}
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {cartStateAgree && (
            <div className="go_to_checkout" style={{backgroundColor: "#faf9f7"}}>
              <div className="checkout_button_section small_checkout_button_section">
                  <div className="small_cart_price_summary">
                {
                  sideCartProductTotal > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail"  style={{marginTop:"0.7rem"}}>
                      <h3>{t("PRODUCT TOTAL")}</h3>
                      <h4>
                        {GetPrice(sideCartProductTotal, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                      </h4>
                    </span>
                  )
                }
                  
                    {sideCartInstallPrice > 0 && (
                      <span className="checkout_payment_price_detail payment_price_detail">
                        <h3>{t("INSTALLATION SERVICES")}</h3>
                        <h4>
                          {GetPrice(
                            sideCartInstallPrice,
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                        </h4>
                      </span>
                    )}
                    {sideCartTransportPrice > 0 && (
                      <span className="checkout_payment_price_detail payment_price_detail">
                        <h3>{t("TRANSPORTATION FEE")}</h3>
                        <h4>
                          {GetPrice(
                            sideCartTransportPrice,
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                        </h4>
                      </span>
                    )}
                    {(sideCartHasSwatches ||
                      sideCartProductTotal > 0 ||
                      sideCartInstallPrice > 0 ||
                      sideCartTransportPrice > 0) && (
                      <span className="checkout_payment_price_detail payment_price_detail">
                        <h3>{t("SHIPPING")}</h3>
                        <h4>
                          {freeShipPrice > 0 &&
                          (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                            ? t("FREE")
                            : t("CALCULATED AT CHECKOUT")}
                        </h4>
                      </span>
                    )}
                  </div>
                <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
                <h3>
  {freeShipPrice > 0 &&
  (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
    ? t("TOTAL")
    : t("SUBTOTAL")}
</h3>
                  <h4>
                    {GetPrice(
                      isLoggedIn
                        ? sideCartPrice
                        : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )}
                  </h4>
                </span>
                <Link
                  className="basket_checkout btn"
                  to={"/" + pageLanguage + "/Basket"}
                  onClick={() => {
                    setCartStateAgree(false);
                  }}
                >
                  {t("CHECKOUT")}
                </Link>
              </div>
            </div>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["moreThan300"] === undefined ? false : modals["moreThan300"]}
        onHide={() => {
          modalHandleClose("moreThan300");
          setStepSelectedLabel((prev) => {
            const newLabels = { ...prev };
            delete newLabels["3BOut1"];
            delete newLabels["3BOut2"];
            delete newLabels["3BOut"];
            return newLabels;
          });
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("moreThan300")}</p>

          <br />
          <div className=" text_center">
            <button
              className="Btn"
              onClick={() => {
                modalHandleClose("moreThan300");
                setStepSelectedLabel((prev) => {
                  const newLabels = { ...prev };
                  delete newLabels["3BOut1"];
                  delete newLabels["3BOut2"];
                  delete newLabels["3BOut"];
                  return newLabels;
                });
              }}
            >
              <NextStep currentStep="3AOut" eventKey="3B">
                {t("CONTINUE")}
              </NextStep>
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["moreThan280"] === undefined ? false : modals["moreThan280"]}
        onHide={() => {
          modalHandleClose("moreThan280");
          setStepSelectedLabel((prev) => {
            const newLabels = { ...prev };
            delete newLabels["3BOut1"];
            delete newLabels["3BOut2"];
            delete newLabels["3BOut"];
            return newLabels;
          });
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("moreThan280")}</p>

          <br />
          <div className=" text_center">
            <button
              className="Btn"
              //  onClick={() => modalHandleClose("moreThan280")}
              onClick={() => {
                modalHandleClose("moreThan280");
                setStepSelectedLabel((prev) => {
                  const newLabels = { ...prev };
                  delete newLabels["3BOut1"];
                  delete newLabels["3BOut2"];
                  delete newLabels["3BOut"];
                  return newLabels;
                });
              }}
            >
              <NextStep currentStep="3AOut" eventKey="3B">
                {t("CONTINUE")}
              </NextStep>
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["moreThan400"] === undefined ? false : modals["moreThan400"]}
        onHide={() => modalHandleClose("moreThan400")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("moreThan400")}</p>

          <br />
          <div className=" text_center">
            <button
              className="Btn"
              onClick={() => {
                setStepSelectedLabel((prev) => {
                  const newLabels = { ...prev };
                  delete newLabels["3DOut"];
                  console.log("newLabels", newLabels);
                  return newLabels;
                });

                modalHandleClose("moreThan400");
              }}
            >
              <NextStep currentStep="3AOut" eventKey="3D">
                {t("CONTINUE")}
              </NextStep>
            </button>
          </div>
        </Modal.Body>
        {/*<Modal.Footer>*/}
        {/*    */}
        {/*</Modal.Footer>*/}
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {projectModalState === 0 && (
            <div className="add_to_project_container2">
              <h2 className="project_added_text">{t("Please select a room name")}</h2>
              <div className="box100 selectInput_section">
                <div className="room_select">
                  <label className="select_label">{t("Room")}</label>
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={t("Please Select")}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedRoomLabel}
                      // onDropdownOpen={() => {
                      //     let temp1 = window.scrollY;
                      //     window.scrollTo(window.scrollX, window.scrollY + 1);
                      //     setTimeout(() => {
                      //         let temp2 = window.scrollY;
                      //         if (temp2 === temp1)
                      //             window.scrollTo(window.scrollX, window.scrollY - 1);
                      //     }, 100);
                      // }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      // optionRenderer={
                      //     ({ item, props, state, methods }) => <CustomOption item={item} props={props} state={state} methods={methods}/>
                      // }
                      onChange={(selected) => {
                        setDeps("", "71");
                        roomLabelChanged(selected[0], "7", false);
                        setSelectedRoomLabel(selected);
                        // setCart("RoomNameEn", selected[0].value);
                        setCart(
                          "RoomNameFa",
                          rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                          "",
                          "RoomNameEn",
                          [selected[0].value]
                        );
                      }}
                      options={rooms[pageLanguage]}
                    />
                  </div>
                </div>
                <div className="room_select">
                  <label className="select_label">{t("Window Description")}</label>
                  <DebounceInput
                    debounceTimeout={1500}
                    onKeyDown={() => setCartLoading(true)}
                    type="text"
                    placeholder={t("E.g. Bedroom east wall")}
                    className="form-control window_name"
                    name="order_window_name"
                    value={roomLabelText}
                    onChange={(e) => {
                      if (e.target.value === "") setDeps("72", "");
                      else setDeps("", "72");
                      roomLabelChanged(e.target.value, "7", true);
                      setRoomLabelText(e.target.value);
                      setCart("WindowName", e.target.value);
                    }}
                  />
                </div>
              </div>
              {!!(roomLabelText !== "" && selectedRoomLabel.length) && (
                <button
                  className="save_item_btn btn-new-dark"
                  onClick={() => {
                    if (roomLabelText !== "" && selectedRoomLabel.length) {
                      setSavingLoading(true);
                      if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          projectData,
                          customMotorAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              modalHandleShow("add_to_project_modal");
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              console.log("project not saved!");
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                            // console.log("hi4");
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      } else {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          undefined,
                          customMotorAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              console.log("project not saved!");
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            // console.log("hi3",);
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      }
                    } else {
                      setProjectModalState(0);
                    }
                  }}
                  disabled={savingLoading}
                >
                  {savingLoading ? t("SAVING...") : t("SAVE ITEM")}
                </button>
              )}
            </div>
          )}
          {projectModalState === 1 && (
            <div className="add_to_project_container">
              <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR PROJECTS")}</h2>
              <Link
                className="add_to_project_btn btn"
                to={"/" + pageLanguage + "/Account/Projects"}
              >
                {t("VIEW PROJECTS")}
              </Link>
              <button
                className="continue_shopping_btn"
                onClick={() => {
                  modalHandleClose("add_to_project_modal");
                }}
              >
                {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
              </button>
            </div>
          )}

          {projectModalState === 2 && <ModalLogin />}
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal side_login_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["side_login_modal"] === undefined ? false : modals["side_login_modal"]}
        onHide={() => {
          modalHandleClose("side_login_modal");
          setSwatchLogin(false);
        }}
        id="side_login_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalLogin />
        </Modal.Body>
      </Modal>

      <div className={`CustomModelFooter ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
        <div className="CustomModelFooter_hidden_part" />
        <div className="CustomModelFooter_visible_part">
          <div className="bag_buttons_section_container">
            <button
              className="btn add_to_cart"
              disabled={addingLoading || cartLoading}
              onClick={() => {
                setAddingLoading(true);
                addToCart();
              }}
            >
              {addingLoading ? t("ADDING...") : t("footer_Add To Cart")}
            </button>
            <button className="btn add_to_cart no_pointer">
              {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
            </button>
            <button
              className="save_to_acc white_btn btn"
              onClick={() => {
                if (roomLabelText !== "" && selectedRoomLabel.length) {
                  setSavingLoading(true);
                  if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      projectData,
                      customMotorAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          console.log("project not saved!");
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        // console.log("hi2");
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  } else {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      undefined,
                      customMotorAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          console.log("hi1");
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          console.log("project not saved!");
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        // console.log("hi1");
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  }
                } else {
                  setProjectModalState(0);
                  modalHandleShow("add_to_project_modal");
                }
              }}
              disabled={savingLoading || cartLoading}
            >
              {savingLoading ? t("SAVING...") : t("footer_Save To")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Roller;
